/* eslint-disable @typescript-eslint/no-explicit-any */
// @ts-nocheck
import React, { useState, useEffect, useRef } from 'react';
import { Col, Row, Card, Badge, Alert, Spinner, Nav, Tab, Modal, Button, Tooltip } from 'react-bootstrap';
import { getHatateToken } from '../helpers/utils';

import { MapContainer, TileLayer, Marker, Popup, CircleMarker, useMap, useMapEvents } from 'react-leaflet';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Legend, ResponsiveContainer, AreaChart, Area as RechartsArea, BarChart, Bar, Tooltip as RechartsTooltip } from 'recharts';

import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import { Polyline, Polygon, Tooltip as LeafletTooltip } from 'react-leaflet';

//@ts-ignore
import markerIcon from 'leaflet/dist/images/marker-icon.png';
//@ts-ignore
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
//@ts-ignore
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle, faExclamationCircle, faExclamationTriangle, faInfoCircle, faTimes } from '@fortawesome/free-solid-svg-icons';
import ts from 'typescript';
import { Railway3DChart } from '../components/Railway3DChart';
import { Simple3DTest } from '../components/Simple3DTest';
import { SimpleRailway3D } from '../components/SimpleRailway3D';
import { WorkingRailway3D } from '../components/AdvancedRailway3D'; // Removed: No export found

delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: markerIcon2x,
  iconUrl: markerIcon,
  shadowUrl: markerShadow,
});

// Interfaces

type AdvancedRailwayVtiCrmProps = {
    language: 'es' | 'en';
    disabled?: boolean;
}
interface MapPoint {
  lat: number;
  lng: number;
}

interface Measurement {
  id: number;
  points: [number, number][];
  distance: string;
  timestamp: Date;
}

interface Route {
  id: number;
  points: [number, number][];
  distance: string;
  timestamp: Date;
}

interface Area {
  id: number;
  points: [number, number][];
  hotspots: Hotspot[];
  timestamp: Date;
}

interface MapTools {
  activeTool: 'measure' | 'route' | 'area' | null;
  measurePoints: [number, number][];
  routePoints: [number, number][];
  areaPoints: [number, number][];
  measurements: Measurement[];
  routes: Route[];
  areas: Area[];
}

interface Hotspot {
  location: string;
  defect_count: number;
  risk_score: number;
  recommendation_priority: string;
  dominant_defects?: string[];
  coordinates?: {
    latitude: number;
    longitude: number;
  };
  severity_breakdown?: { [key: string]: number };
  maintenance_history?: string[];
}

interface VtiSummaryData {
  total_vti_files: number;
  total_records: number;
  system_status: string;
  files: Array<{
    severity_distribution: { [key: string]: number };
  }>;
}

interface AnalysisData {
  recommendations?: string[];
  location_range?: {
    kp_start: number;
    kp_end: number;
  };
  total_defects?: number;
  defect_density?: number;
  risk_hotspots?: any[];
  failure_prediction?: {
    risk_level: string;
  };
}

interface Document {
  id?: string;
  name?: string;
  filename?: string;
  processed?: boolean;
  type?: string;
  document_type?: string;
  size?: string;
  date?: string;
  upload_date?: string;
  summary?: string;
}

interface HealthStatus {
  status: string;
}

interface Predictions {
  failure_probability: number;
  maintenance_urgency: string;
  confidence: number;
  risk_factors?: string[];
}

interface ChatItem {
  query: string;
  response?: string;
  answer?: string;
  timestamp: Date;
  confidence?: number;
  suggestions?: string[];
  error?: boolean;
}

interface SystemStats {
  total_files?: number;
  total_documents?: number;
  success_rate?: string;
  avg_processing_time?: string;
  pending_tasks?: number;
  recent_activity?: string[];
}

// Componente para manejar eventos del mapa
const MapController = ({ 
  onMapReady, 
  searchLocation 
}: { 
  onMapReady: (map: L.Map) => void;
  searchLocation: [number, number] | null;
}) => {
  const map = useMap();

  useEffect(() => {
    if (map) {
      onMapReady(map);
    }
  }, [map, onMapReady]);

  useEffect(() => {
    if (searchLocation && map) {
      map.flyTo(searchLocation, 15);
    }
  }, [searchLocation, map]);

  return null;
};

// Componente para agregar pin temporal
const TemporaryPinAdder = ({ onAddPin }: { onAddPin: (latlng: L.LatLng) => void }) => {
  useMapEvents({
    dblclick: (e) => {
      onAddPin(e.latlng);
    }
  });
  return null;
};

// Función para obtener token dinámico
const HatateToken = getHatateToken();

// Componente de tarjeta de estadísticas VTI
const VtiStatCard = ({ 
  icon, 
  color, 
  label, 
  value, 
  title, 
  badgeLabel, 
  badgeBg, 
  footerText, 
  isLoading,
  aiPrediction = null,
  isEmpty = false
}: {
  icon: string;
  color: string;
  label: string;
  value: string | number;
  title: string;
  badgeLabel?: string;
  badgeBg?: string;
  footerText?: string;
  isLoading: boolean;
  aiPrediction?: string | null;
  isEmpty?: boolean;
}) => {
  return (
    <Card className="h-100">
      <Card.Body className="d-flex flex-column">
        <div className="d-flex align-items-center mb-3">
          <div className={`avatar avatar-l bg-${isEmpty ? 'secondary' : color} text-white rounded-circle me-3`}>
            <i className={`fas ${icon}`}></i>
          </div>
          <div>
            <h6 className="mb-0 text-body-tertiary">{label}</h6>
            <h4 className="mb-0 text-body">{title}</h4>
          </div>
        </div>
        <div className="d-flex align-items-end justify-content-between">
          <div>
            {isLoading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              <h2 className={`mb-0 ${isEmpty ? 'text-muted' : 'text-body'}`}>{value}</h2>
            )}
            {aiPrediction && !isEmpty && (
              <p className="mb-0 text-info fs-9 mt-1">
                <i className="fas fa-brain me-1"></i>
                IA: {aiPrediction}
              </p>
            )}
            {isEmpty && (
              <p className="mb-0 text-muted fs-9 mt-1">
                <i className="fas fa-info-circle me-1"></i>
                Sin datos disponibles
              </p>
            )}
          </div>
          {badgeLabel && !isEmpty && (
            <div className="text-end">
              <Badge bg={badgeBg} className="mb-1">{badgeLabel}</Badge>
              <p className="mb-0 text-body-tertiary fs-9">{footerText}</p>
            </div>
          )}
        </div>
      </Card.Body>
    </Card>
  );
};

// Componente de hotspots críticos
const CriticalHotspots = ({ data, isLoading }: {
  data: Hotspot[];
  isLoading: boolean;
}) => {
  const isEmpty = !data || data.length === 0;

  return (
    <Card className="h-100">
      <Card.Header>
        <h5 className="mb-0">Puntos Críticos VTI</h5>
        <p className="text-body-tertiary mb-0">Ubicaciones de alto riesgo detectadas</p>
      </Card.Header>
      <Card.Body>
        {isLoading ? (
          <div className="text-center py-4">
            <Spinner animation="border" />
          </div>
        ) : isEmpty ? (
          <div className="text-center py-5">
            <i className="fas fa-map-marker-alt text-muted fs-1 mb-3"></i>
            <h6 className="text-muted mb-2">No hay hotspots detectados</h6>
            <p className="text-body-tertiary small mb-3">
              Los hotspots aparecerán aquí una vez que se procesen documentos VTI
            </p>
            <Alert variant="info" className="small">
              <i className="fas fa-lightbulb me-2"></i>
              <strong>Sugerencia:</strong> Sube archivos VTI para comenzar el análisis
            </Alert>
          </div>
        ) : (
          <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
            {data.map((hotspot, index) => (
              <div 
                key={index} 
                className={`p-3 mb-2 rounded border-start border-4 ${
                  hotspot.recommendation_priority === 'HIGH' || hotspot.recommendation_priority === 'CRITICAL'
                    ? 'border-danger bg-danger-subtle' 
                    : 'border-warning bg-warning-subtle'
                }`}
              >
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <h6 className="mb-1">{hotspot.location}</h6>
                    <small className="text-body-tertiary">
                      {hotspot.defect_count} defectos • Score: {hotspot.risk_score?.toFixed(2)}
                    </small>
                  </div>
                  <Badge 
                    bg={hotspot.recommendation_priority === 'CRITICAL' ? 'danger' : 
                        hotspot.recommendation_priority === 'HIGH' ? 'warning' : 'info'}
                  >
                    {hotspot.recommendation_priority}
                  </Badge>
                </div>
                <div className="mt-2">
                  <small className="text-body-secondary">
                    Defectos dominantes: {hotspot.dominant_defects?.join(', ')}
                  </small>
                </div>
              </div>
            ))}
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

// Componente de distribución de severidad
const SeverityDistribution = ({ data, isLoading }: {
  data: { [key: string]: number } | null;
  isLoading: boolean;
}) => {
  const severityColors = {
    'Critical': 'danger',
    'High': 'warning', 
    'Medium': 'info',
    'Low': 'success',
    'Info': 'secondary'
  };

  const total = data ? (Object.values(data) as number[]).reduce((sum, count) => sum + count, 0) : 0;
  const isEmpty = !data || total === 0;

  return (
    <Card className="h-100">
      <Card.Header>
        <h5 className="mb-0">Distribución de Severidad</h5>
        <p className="text-body-tertiary mb-0">Clasificación de defectos por severidad</p>
      </Card.Header>
      <Card.Body>
        {isLoading ? (
          <div className="text-center py-4">
            <Spinner animation="border" />
          </div>
        ) : isEmpty ? (
          <div className="text-center py-5">
            <i className="fas fa-chart-pie text-muted fs-1 mb-3"></i>
            <h6 className="text-muted mb-2">Sin datos de severidad</h6>
            <p className="text-body-tertiary small mb-3">
              La distribución de severidad se mostrará después de procesar archivos VTI
            </p>
            <div className="row g-2">
              {Object.entries(severityColors).map(([severity, color]) => (
                <div key={severity} className="col-6 col-sm-12 col-md-6">
                  <div className="d-flex align-items-center justify-content-between p-2 border rounded">
                    <div className="d-flex align-items-center">
                      <div 
                        className={`bg-${color} rounded-circle me-2`}
                        style={{ width: '12px', height: '12px' }}
                      ></div>
                      <small className="text-muted">{severity}</small>
                    </div>
                    <small className="text-muted">0</small>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          <div>
            {Object.entries(data).map(([severity, count]) => {
              const typedCount = count as number;
              const percentage = ((typedCount / total) * 100).toFixed(1);
              return (
                <div key={severity} className="mb-3">
                  <div className="d-flex justify-content-between align-items-center mb-1">
                    <span className="fw-semibold">{severity}</span>
                    <Badge bg={severityColors[severity] || 'secondary'}>
                      {typedCount} ({percentage}%)
                    </Badge>
                  </div>
                  <div className="progress" style={{ height: '8px' }}>
                    <div 
                      className={`progress-bar bg-${severityColors[severity] || 'secondary'}`}
                      style={{ width: `${percentage}%` }}
                    ></div>
                  </div>
                </div>
              );
            })}
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

// Componente de análisis de tramo
const TrackAnalysis = ({ onAnalyze, isLoading, hasData }: { 
  onAnalyze: (kpStart: number, kpEnd: number) => Promise<void>;
  isLoading: boolean;
  hasData: boolean;
}) => {
  const [kpStart, setKpStart] = useState(0);
  const [kpEnd, setKpEnd] = useState(50);

  const handleAnalyze = async () => {
    await onAnalyze(kpStart, kpEnd);
  };

  return (
    <Card className="h-100">
      <Card.Header>
        <h5 className="mb-0">Análisis de Tramo</h5>
        <p className="text-body-tertiary mb-0">Analizar un rango específico de kilómetros</p>
      </Card.Header>
      <Card.Body>
        <Row className="g-3">
          <Col sm={6}>
            <label className="form-label">KP Inicial</label>
            <input 
              type="number" 
              className="form-control"
              value={kpStart}
              onChange={(e) => setKpStart(parseFloat(e.target.value) || 0)}
              min="0"
              step="0.1"
              disabled={!hasData}
            />
          </Col>
          <Col sm={6}>
            <label className="form-label">KP Final</label>
            <input 
              type="number" 
              className="form-control"
              value={kpEnd}
              onChange={(e) => setKpEnd(parseFloat(e.target.value) || 0)}
              min="0"
              step="0.1"
              disabled={!hasData}
            />
          </Col>
          <Col xs={12}>
            <button 
              className="btn btn-primary w-100"
              onClick={handleAnalyze}
              disabled={isLoading || kpStart >= kpEnd || !hasData}
            >
              {isLoading ? (
                <>
                  <Spinner animation="border" size="sm" className="me-2" />
                  Analizando...
                </>
              ) : !hasData ? (
                <>
                  <i className="fas fa-exclamation-triangle me-2"></i>
                  Sin datos para analizar
                </>
              ) : (
                <>
                  <i className="fas fa-search me-2"></i>
                  Analizar Tramo
                </>
              )}
            </button>
          </Col>
          {!hasData && (
            <Col xs={12}>
              <Alert variant="info" className="small">
                <i className="fas fa-info-circle me-2"></i>
                Necesitas cargar documentos VTI para realizar análisis de tramos
              </Alert>
            </Col>
          )}
        </Row>
      </Card.Body>
    </Card>
  );
};

// Mapa avanzado mejorado manteniendo el diseño original
const AdvancedGeoMap = ({ hotspots, isLoading }: {
  hotspots: Hotspot[];
  isLoading: boolean;
}) => {
  const [mapMode, setMapMode] = useState('hybrid'); // Por defecto satelital
  const [visualMode, setVisualMode] = useState('points'); // Por defecto puntos
  const [selectedHotspot, setSelectedHotspot] = useState<Hotspot | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [searchKP, setSearchKP] = useState('');
  const [map, setMap] = useState<L.Map | null>(null);
  const [searchLocation, setSearchLocation] = useState<[number, number] | null>(null);
  const [temporaryPins, setTemporaryPins] = useState<Array<{ id: number; position: [number, number] }>>([]);
  const [severityFilter, setSeverityFilter] = useState<string[]>(['CRITICAL', 'HIGH']);
  const [pointsLimit, setPointsLimit] = useState('1-50'); // Límite por defecto alto
  const [showAdvanced, setShowAdvanced] = useState(false);
  
  // Referencias para layers
  const clusterGroupRef = useRef<any>(null);
  const [mapTools, setMapTools] = useState<MapTools>({
      activeTool: null,
      measurePoints: [],
      routePoints: [],
      areaPoints: [],
      measurements: [],
      routes: [],
      areas: [],
      isDrawing: false
    });

interface MapTools {
  activeTool: 'measure' | 'route' | 'area' | null;
  measurePoints: Array<[number, number]>;
  routePoints: Array<[number, number]>;
  areaPoints: Array<[number, number]>;
  measurements: Array<any>;
  routes: Array<any>;
  areas: Array<any>;
  isDrawing: boolean;
}

// ========================================
// FUNCIONES UTILITARIAS PARA CÁLCULOS
// ========================================

// Función para calcular distancia entre dos puntos (Haversine)
const calculateDistance = (lat1: number, lng1: number, lat2: number, lng2: number): number => {
  const R = 6371; // Radio de la Tierra en km
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLng = (lng2 - lng1) * Math.PI / 180;
  const a = 
    Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
    Math.sin(dLng/2) * Math.sin(dLng/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  return R * c;
};

  // Función para verificar si un punto está dentro de un polígono
  const isPointInPolygon = (point, polygon) => {
    const [x, y] = point;
    let inside = false;
    
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
      const [xi, yi] = polygon[i];
      const [xj, yj] = polygon[j];
      
      if (((yi > y) !== (yj > y)) && (x < (xj - xi) * (y - yi) / (yj - yi) + xi)) {
        inside = !inside;
      }
    }
    
    return inside;
  };

  // ========================================
  // SERVICIOS DE RUTAS CON OSRM
  // ========================================

  // Función para obtener ruta optimizada con OSRM
  const getOptimizedRoute = async (points) => {
    if (points.length < 2) return null;
    
    try {
      // Construir URL para OSRM
      const coordinates = points.map(p => `${p[1]},${p[0]}`).join(';');
      const url = `https://router.project-osrm.org/route/v1/driving/${coordinates}?overview=full&geometries=geojson`;
      
      const response = await fetch(url);
      const data = await response.json();
      
      if (data.routes && data.routes.length > 0) {
        const route = data.routes[0];
        return {
          coordinates: route.geometry.coordinates.map(coord => [coord[1], coord[0]]), // Leaflet espera [lat, lng]
          distance: (route.distance / 1000).toFixed(2), // km
          duration: Math.round(route.duration / 60), // minutos
          legs: route.legs
        };
      }
      
      return null;
    } catch (error) {
      console.error('Error getting route from OSRM:', error);
      // Fallback: línea recta
      return {
        coordinates: points,
        distance: points.reduce((total, point, index) => {
          if (index === 0) return 0;
          const prev = points[index - 1];
          return total + calculateDistance(prev[0], prev[1], point[0], point[1]);
        }, 0).toFixed(2),
        duration: 'N/A',
        legs: []
      };
    }
  };

  // ========================================
  // FUNCIONES PARA HERRAMIENTAS DE MAPA
  // ========================================

  // Activar herramienta de medición
  const activateMeasureTool = () => {
    setMapTools(prev => ({
      ...prev,
      activeTool: prev.activeTool === 'measure' ? null : 'measure',
      isDrawing: false,
      measurePoints: []
    }));
  };

  // Activar herramienta de rutas
  const activateRouteTool = () => {
    setMapTools(prev => ({
      ...prev,
      activeTool: prev.activeTool === 'route' ? null : 'route',
      isDrawing: false,
      routePoints: []
    }));
  };

  // Activar herramienta de áreas
  const activateAreaTool = () => {
    setMapTools(prev => ({
      ...prev,
      activeTool: prev.activeTool === 'area' ? null : 'area',
      isDrawing: false,
      areaPoints: []
    }));
  };

  // Función para manejar clicks en el mapa
  const handleMapClick = async (e) => {
    const { lat, lng } = e.latlng;
    const point = [lat, lng];
    
    if (mapTools.activeTool === 'measure') {
      const newPoints = [...mapTools.measurePoints, point];
      setMapTools(prev => ({ ...prev, measurePoints: newPoints as [number, number][] }));
      
      // Si hay al menos 2 puntos, calcular distancia
      if (newPoints.length >= 2) {
        const totalDistance = newPoints.reduce((total, currPoint, index) => {
          if (index === 0) return 0;
          const prevPoint = newPoints[index - 1];
          return total + calculateDistance(prevPoint[0], prevPoint[1], currPoint[0], currPoint[1]);
        }, 0);
        
        // Mostrar distancia actual
        console.log(`Distancia actual: ${totalDistance.toFixed(2)} km`);
      }
    }
    
    else if (mapTools.activeTool === 'route') {
      const newPoints = [...mapTools.routePoints, point];
      setMapTools(prev => ({ ...prev, routePoints: newPoints as [number, number][] }));
    }
    
    else if (mapTools.activeTool === 'area') {
      const newPoints = [...mapTools.areaPoints, point];
      setMapTools(prev => ({ ...prev, areaPoints: newPoints as [number, number][] }));
    }
  };

  // Finalizar medición
  const finalizeMeasurement = () => {
    if (mapTools.measurePoints.length < 2) {
      alert('Necesitas al menos 2 puntos para medir distancia');
      return;
    }
    
    const totalDistance = mapTools.measurePoints.reduce((total, point, index) => {
      if (index === 0) return 0;
      const prev = mapTools.measurePoints[index - 1];
      return total + calculateDistance(prev[0], prev[1], point[0], point[1]);
    }, 0);
    
    const measurement = {
      id: Date.now(),
      points: [...mapTools.measurePoints],
      distance: totalDistance.toFixed(2),
      timestamp: new Date(),
      type: 'measurement'
    };
    
    setMapTools(prev => ({
      ...prev,
      measurements: [...prev.measurements, measurement],
      measurePoints: [],
      activeTool: null
    }));
    
    alert(`✅ Medición guardada: ${totalDistance.toFixed(2)} km`);
  };

  // Finalizar ruta
  const finalizeRoute = async () => {
    if (mapTools.routePoints.length < 2) {
      alert('Necesitas al menos 2 puntos para crear una ruta');
      return;
    }
    
    try {
      const routeData = await getOptimizedRoute(mapTools.routePoints);
      
      if (routeData) {
        const route = {
          id: Date.now(),
          points: [...mapTools.routePoints],
          coordinates: routeData.coordinates,
          distance: routeData.distance,
          duration: routeData.duration,
          timestamp: new Date(),
          type: 'route'
        };
        
        setMapTools(prev => ({
          ...prev,
          routes: [...prev.routes, route],
          routePoints: [],
          activeTool: null
        }));
        
        alert(`✅ Ruta creada: ${routeData.distance} km (${routeData.duration} min)`);
      }
    } catch (error) {
      alert('❌ Error al crear la ruta');
    }
  };

  // Finalizar área
  const finalizeArea = () => {
    if (mapTools.areaPoints.length < 3) {
      alert('Necesitas al menos 3 puntos para crear un área');
      return;
    }
    
    // Calcular hotspots dentro del área
    const hotspotsInArea = hotspots.filter(hotspot => {
      if (!hotspot.coordinates) return false;
      const point = [hotspot.coordinates.latitude, hotspot.coordinates.longitude];
      return isPointInPolygon(point, mapTools.areaPoints);
    });
    
    const area = {
      id: Date.now(),
      points: [...mapTools.areaPoints],
      hotspots: hotspotsInArea,
      timestamp: new Date(),
      type: 'area'
    };
    
    setMapTools(prev => ({
      ...prev,
      areas: [...prev.areas, area],
      areaPoints: [],
      activeTool: null
    }));
    
    alert(`✅ Área creada con ${hotspotsInArea.length} hotspots`);
  };

  // Cancelar herramienta activa
  const cancelActiveTool = () => {
    setMapTools(prev => ({
      ...prev,
      activeTool: null,
      measurePoints: [],
      routePoints: [],
      areaPoints: [],
      isDrawing: false
    }));
  };

  // Eliminar elemento persistente
  const deleteMapElement = (type, id) => {
    setMapTools(prev => ({
      ...prev,
      [type]: prev[type].filter(item => item.id !== id)
    }));
  };

// ========================================
  // COMPONENTES DE MAPA PARA REACT LEAFLET
  // ========================================

  // Componente para manejar eventos del mapa
const MapEventHandler = () => {
  useMapEvents({
    click: (e: any) => {
      const { lat, lng } = e.latlng;
      const point: [number, number] = [lat, lng];
      
      if (mapTools.activeTool === 'measure') {
        const newPoints: [number, number][] = [...mapTools.measurePoints, point];
        setMapTools(prev => ({ ...prev, measurePoints: newPoints }));
      } else if (mapTools.activeTool === 'route') {
        const newPoints: [number, number][] = [...mapTools.routePoints, point];
        setMapTools(prev => ({ ...prev, routePoints: newPoints }));
      } else if (mapTools.activeTool === 'area') {
        const newPoints: [number, number][] = [...mapTools.areaPoints, point];
        setMapTools(prev => ({ ...prev, areaPoints: newPoints }));
      }
    },
    dblclick: () => {
      if (mapTools.activeTool === 'measure') {
        finalizeMeasurement();
      } else if (mapTools.activeTool === 'route') {
        finalizeRoute();
      } else if (mapTools.activeTool === 'area') {
        finalizeArea();
      }
    }
  });
  return null;
};

  // Componente para mostrar mediciones temporales
  const TemporaryMeasurement = () => {
    if (mapTools.activeTool !== 'measure' || mapTools.measurePoints.length === 0) return null;
    
    return (
      <>
        {/* Puntos de medición */}
        {mapTools.measurePoints.map((point, index) => (
          <CircleMarker
            key={index}
            center={point}
            radius={6}
            fillColor="#ff6b35"
            color="white"
            weight={2}
            opacity={1}
            fillOpacity={0.9}
          >
            <LeafletTooltip permanent={true} direction="top" offset={[0, -10]} opacity={0.9}>
              <span>P{index + 1}</span>
            </LeafletTooltip>
          </CircleMarker>
        ))}
        
        {/* Líneas de medición */}
        {mapTools.measurePoints.length > 1 && (
          <Polyline
            positions={mapTools.measurePoints}
            color="#ff6b35"
            weight={3}
            opacity={0.8}
            dashArray="5, 10"
          />
        )}
      </>
    );
  };

  // Componente para mostrar rutas temporales
  const TemporaryRoute = () => {
    if (mapTools.activeTool !== 'route' || mapTools.routePoints.length === 0) return null;
    
    return (
      <>
        {/* Puntos de ruta */}
        {mapTools.routePoints.map((point, index) => (
          <CircleMarker
            key={index}
            center={point}
            radius={8}
            fillColor="#28a745"
            color="white"
            weight={2}
            opacity={1}
            fillOpacity={0.9}
          >
            <LeafletTooltip permanent={true}>
              <span>{index === 0 ? 'Inicio' : index === mapTools.routePoints.length - 1 ? 'Fin' : `P${index + 1}`}</span>
            </LeafletTooltip>
          </CircleMarker>
        ))}
        
        {/* Línea temporal de ruta */}
        {mapTools.routePoints.length > 1 && (
          <Polyline
            positions={mapTools.routePoints}
            color="#28a745"
            weight={3}
            opacity={0.6}
            dashArray="10, 5"
          />
        )}
      </>
    );
  };

  // Componente para mostrar áreas temporales
  const TemporaryArea = () => {
    if (mapTools.activeTool !== 'area' || mapTools.areaPoints.length === 0) return null;
    
    return (
      <>
        {/* Puntos del área */}
        {mapTools.areaPoints.map((point, index) => (
          <CircleMarker
            key={index}
            center={point}
            radius={6}
            fillColor="#6f42c1"
            color="white"
            weight={2}
            opacity={1}
            fillOpacity={0.9}
          >
            <LeafletTooltip permanent>
              <span>V{index + 1}</span>
            </LeafletTooltip>
          </CircleMarker>
        ))}
        
        {/* Polígono temporal */}
        {mapTools.areaPoints.length > 2 && (
          <Polygon
            positions={mapTools.areaPoints}
            fillColor="#6f42c1"
            fillOpacity={0.2}
            color="#6f42c1"
            weight={2}
            opacity={0.8}
          />
        )}
      </>
    );
  };

  // Componente para mostrar elementos persistentes
  const PersistentMapElements = () => {
    return (
      <>
        {/* Mediciones persistentes */}
        {mapTools.measurements.map((measurement) => (
          <React.Fragment key={measurement.id}>
            <Polyline
              positions={measurement.points}
              color="#ff6b35"
              weight={2}
              opacity={0.7}
            >
              <Popup>
                <div>
                  <strong>📏 Medición #{measurement.id}</strong><br/>
                  Distancia: {measurement.distance} km<br/>
                  Puntos: {measurement.points.length}<br/>
                  Fecha: {measurement.timestamp.toLocaleDateString()}<br/>
                  <button 
                    onClick={() => deleteMapElement('measurements', measurement.id)}
                    className="btn btn-sm btn-danger mt-1"
                  >
                    Eliminar
                  </button>
                </div>
              </Popup>
            </Polyline>
          </React.Fragment>
        ))}
        
        {/* Rutas persistentes */}
        {mapTools.routes.map((route) => (
          <React.Fragment key={route.id}>
            <Polyline
              positions={route.coordinates}
              color="#28a745"
              weight={3}
              opacity={0.8}
            >
              <Popup>
                <div>
                  <strong>🛣️ Ruta #{route.id}</strong><br/>
                  Distancia: {route.distance} km<br/>
                  Duración: {route.duration} min<br/>
                  Puntos: {route.points.length}<br/>
                  Fecha: {route.timestamp.toLocaleDateString()}<br/>
                  <button 
                    onClick={() => deleteMapElement('routes', route.id)}
                    className="btn btn-sm btn-danger mt-1"
                  >
                    Eliminar
                  </button>
                </div>
              </Popup>
            </Polyline>
          </React.Fragment>
        ))}
        
        {/* Áreas persistentes */}
        {mapTools.areas.map((area) => (
          <React.Fragment key={area.id}>
            <Polygon
              positions={area.points}
              fillColor="#6f42c1"
              fillOpacity={0.3}
              color="#6f42c1"
              weight={2}
              opacity={0.8}
            >
              <Popup>
                <div>
                  <strong>🔷 Área #{area.id}</strong><br/>
                  Hotspots: {area.hotspots.length}<br/>
                  Vértices: {area.points.length}<br/>
                  Fecha: {area.timestamp.toLocaleDateString()}<br/>
                  <button 
                    onClick={() => deleteMapElement('areas', area.id)}
                    className="btn btn-sm btn-danger mt-1"
                  >
                    Eliminar
                  </button>
                </div>
              </Popup>
            </Polygon>
          </React.Fragment>
        ))}
      </>
    );
  };

  // Funciones de manejo de herramientas CORREGIDAS
  const handleMeasureDistance = () => {
    if (mapTools.activeTool === 'measure') {
      // Si ya está activa, cancelar
      cancelActiveTool();
      return;
    }
    
    activateMeasureTool();
    alert('🔍 Herramienta de medición activada:\n\n1. Click en el mapa para agregar puntos\n2. Doble-click para finalizar medición\n3. Las mediciones se guardan automáticamente\n4. Click en el botón de nuevo para cancelar');
  };

  const handleDrawArea = () => {
    if (mapTools.activeTool === 'area') {
      // Si ya está activa, cancelar
      cancelActiveTool();
      return;
    }
    
    activateAreaTool();
    /*showSuccessToast(
        language === 'es' ? 'Primera Respuesta' : 'First Response',
        language === 'es' 
            ? 'Configuración guardada correctamente'
            : 'Configuration saved successfully'
    ); */
    alert('🔷 Herramienta de área activada:\n\n1. Click en el mapa para definir vértices\n2. Mínimo 3 puntos requeridos\n3. Doble-click para finalizar área\n4. Se analizarán hotspots dentro del área\n5. Click en el botón de nuevo para cancelar');
  };

  const handleCreateRoute = () => {
    if (mapTools.activeTool === 'route') {
      // Si ya está activa, cancelar
      cancelActiveTool();
      return;
    }
    
    activateRouteTool();
    alert('🛣️ Herramienta de rutas activada:\n\n1. Click en puntos para crear ruta\n2. Mínimo 2 puntos requeridos\n3. Doble-click para calcular ruta optimizada\n4. Usa OSRM para rutas reales\n5. Click en el botón de nuevo para cancelar');
  };

  // Función para exportar datos del mapa
  const exportMapData = () => {
    const data = {
      measurements: mapTools.measurements,
      routes: mapTools.routes,
      areas: mapTools.areas,
      exportDate: new Date().toISOString(),
      totalMeasurements: mapTools.measurements.length,
      totalRoutes: mapTools.routes.length,
      totalAreas: mapTools.areas.length
    };
    
    const csvContent = [
      ['Tipo', 'ID', 'Distancia/Info', 'Puntos', 'Fecha'].join(','),
      ...mapTools.measurements.map(m => [
        'Medición',
        m.id,
        `${m.distance} km`,
        m.points.length,
        m.timestamp.toISOString().split('T')[0]
      ].join(',')),
      ...mapTools.routes.map(r => [
        'Ruta',
        r.id,
        `${r.distance} km (${r.duration} min)`,
        r.points.length,
        r.timestamp.toISOString().split('T')[0]
      ].join(',')),
      ...mapTools.areas.map(a => [
        'Área',
        a.id,
        `${a.hotspots.length} hotspots`,
        a.points.length,
        a.timestamp.toISOString().split('T')[0]
      ].join(','))
    ].join('\n');
    
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = `mapa_datos_${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    
    alert(`✅ Exportado: ${mapTools.measurements.length + mapTools.routes.length + mapTools.areas.length} elementos del mapa`);
  };
  
  const isEmpty = !hotspots || hotspots.length === 0;

  const mapModes = {
    satellite: {
      name: 'Vista Satelital',
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution: '© OpenStreetMap contributors'
    },
    terrain: {
      name: 'Relieve Terreno',
      url: 'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
      attribution: '© OpenTopoMap contributors'
    },
    hybrid: {
      name: 'Híbrido',
      url: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
      attribution: '© Esri'
    }
  };

  const visualModes = {
    points: '📍 Puntos',
    //clusters: '🎯 Clusters',
    // heatmap: '🔥 Heatmap', // Comentado
    //smart: '🧠 Inteligente'
  };

  const pointsLimits = {
    '1-50': { min: 1, max: 50, label: '1-50 puntos' },
    '51-150': { min: 51, max: 150, label: '51-150 puntos' },
    '151-250': { min: 151, max: 250, label: '151-250 puntos' },
    '251-500': { min: 251, max: 500, label: '251-500 puntos' },
    '501-999': { min: 501, max: 999, label: '501-999 puntos' },
    'unlimited': { min: 0, max: Infinity, label: 'Sin límite' }
  };

const getRiskColor = (priority: string): string => {
  switch (priority) {
    case 'CRITICAL': return '#dc3545';
    case 'HIGH': return '#fd7e14';
    case 'MEDIUM': return '#ffc107';
    case 'LOW': return '#198754';
    default: return '#6c757d';
  }
};

  const center: [number, number] = hotspots.length > 0 && hotspots[0].coordinates 
    ? [hotspots[0].coordinates.latitude, hotspots[0].coordinates.longitude]
    : [-33.4489, -70.6693];

  // Función optimizada que mantiene la lógica original
  const getHotspotPositions = () => {
    if (isEmpty) return [];
    
    // Filtrar por coordenadas válidas (lógica original)
    const validHotspots = hotspots.filter(hotspot => 
      hotspot.coordinates && 
      hotspot.coordinates.latitude && 
      hotspot.coordinates.longitude
    );
    
    // Filtrar por severidad
    const filteredBySeverity = validHotspots.filter(hotspot =>
      severityFilter.includes(hotspot.recommendation_priority)
    );
    
    // Aplicar límites solo si no es "unlimited"
    let finalHotspots = filteredBySeverity;
    if (pointsLimit !== 'unlimited') {
      const limit = pointsLimits[pointsLimit].max;
      
      // Priorizar y ordenar
      const prioritized = filteredBySeverity.sort((a, b) => {
        const priorityOrder: {[key: string]: number} = { 'CRITICAL': 4, 'HIGH': 3, 'MEDIUM': 2, 'LOW': 1 };
        const priorityA = priorityOrder[a.recommendation_priority] || 0;
        const priorityB = priorityOrder[b.recommendation_priority] || 0;
        
        if (priorityA !== priorityB) return priorityB - priorityA;
        return (b.risk_score || 0) - (a.risk_score || 0);
      });
      
      finalHotspots = prioritized.slice(0, limit);
    }
    
    return finalHotspots.map(hotspot => ({
      ...hotspot,
      position: [hotspot.coordinates!.latitude, hotspot.coordinates!.longitude] as [number, number],
      hasRealCoordinates: true
    }));
  };

  const hotspotPositions = getHotspotPositions();

  // Lógica de modo inteligente corregida
  const getSmartVisualMode = () => {
    const totalVisible = hotspotPositions.length;
    if (totalVisible > 500) return 'clusters';
    if (totalVisible > 100) return 'clusters';
    return 'points';
  };

  const actualVisualMode = visualMode === 'smart' ? getSmartVisualMode() : visualMode;

  // Componente de clustering mejorado
  const CustomMarkerClusterGroup = () => {
    useEffect(() => {
      if (!map || actualVisualMode !== 'clusters') return;

      // Limpiar cluster anterior
      if (clusterGroupRef.current) {
        map.removeLayer(clusterGroupRef.current);
      }

      if (hotspotPositions.length > 0) {
        const clusterGroup = (L as any).markerClusterGroup({
          maxClusterRadius: 60,
          spiderfyOnMaxZoom: true,
          showCoverageOnHover: false,
          zoomToBoundsOnClick: true,
          iconCreateFunction: (cluster: any) => {
            const markers = cluster.getAllChildMarkers();
            const criticalCount = markers.filter((m: any) => m.options.priority === 'CRITICAL').length;
            const highCount = markers.filter((m: any) => m.options.priority === 'HIGH').length;
            const totalCount = cluster.getChildCount();
            
            const size = Math.min(70, Math.max(30, 25 + totalCount * 1.5));
            let color = '#6c757d';
            let textColor = 'white';
            
            if (criticalCount > 0) {
              color = '#dc3545';
            } else if (highCount > 0) {
              color = '#fd7e14';
            } else {
              color = '#ffc107';
              textColor = '#000';
            }
            
            return L.divIcon({
              html: `<div style="
                background: ${color};
                color: ${textColor};
                border-radius: 50%;
                width: ${size}px;
                height: ${size}px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: bold;
                font-size: ${Math.min(18, 10 + totalCount / 20)}px;
                border: 3px solid white;
                box-shadow: 0 3px 12px rgba(0,0,0,0.4);
                position: relative;
              ">
                ${totalCount}
                ${criticalCount > 0 ? `<div style="position: absolute; top: -5px; right: -5px; background: #dc3545; color: white; border-radius: 50%; width: 16px; height: 16px; font-size: 10px; display: flex; align-items: center; justify-content: center; border: 2px solid white;">${criticalCount}</div>` : ''}
              </div>`,
              className: 'custom-cluster-marker',
              iconSize: L.point(size, size)
            });
          }
        });

        // Agregar marcadores al cluster
        hotspotPositions.forEach((hotspot, index) => {
          const marker = L.circleMarker(hotspot.position, {
            radius: Math.max(8, 8 + (hotspot.risk_score || 0.5) * 12),
            fillColor: getRiskColor(hotspot.recommendation_priority),
            color: 'white',
            weight: 2,
            opacity: 1,
            fillOpacity: 0.9,
            priority: hotspot.recommendation_priority
          } as any);

          marker.bindPopup(`
            <div style="min-width: 250px; padding: 12px; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;">
              <div style="border-left: 4px solid ${getRiskColor(hotspot.recommendation_priority)}; padding-left: 12px; margin-bottom: 12px;">
                <h6 style="margin: 0 0 4px 0; color: #333; font-weight: 600;">${hotspot.location}</h6>
                <span style="background: ${getRiskColor(hotspot.recommendation_priority)}; color: white; padding: 2px 8px; border-radius: 12px; font-size: 11px; font-weight: 500;">
                  ${hotspot.recommendation_priority}
                </span>
              </div>
              
              <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 8px; margin-bottom: 12px; font-size: 13px;">
                <div>
                  <strong style="color: #666;">Score:</strong><br>
                  <span style="font-family: monospace; color: #333;">${(hotspot.risk_score || 0).toFixed(3)}</span>
                </div>
                <div>
                  <strong style="color: #666;">Defectos:</strong><br>
                  <span style="color: #333;">${hotspot.defect_count || 0}</span>
                </div>
              </div>
              
              ${hotspot.dominant_defects && hotspot.dominant_defects.length > 0 ? `
                <div style="margin-bottom: 12px;">
                  <strong style="color: #666; font-size: 12px;">Defectos principales:</strong><br>
                  <div style="margin-top: 4px;">
                    ${hotspot.dominant_defects.slice(0, 3).map(defect => 
                      `<span style="background: #f8f9fa; color: #495057; padding: 2px 6px; border-radius: 8px; font-size: 10px; margin-right: 4px; display: inline-block; margin-bottom: 2px;">${defect.replace('_', ' ')}</span>`
                    ).join('')}
                  </div>
                </div>
              ` : ''}
              
              <div style="text-align: center; margin-top: 12px;">
                <button onclick="window.showHotspotDetail && window.showHotspotDetail(${JSON.stringify(hotspot).replace(/"/g, '&quot;')})" 
                        style="background: linear-gradient(135deg, #007bff, #0056b3); color: white; border: none; padding: 8px 16px; border-radius: 6px; font-size: 12px; font-weight: 500; cursor: pointer; box-shadow: 0 2px 4px rgba(0,123,255,0.3);">
                  📊 Ver Análisis Completo
                </button>
              </div>
            </div>
          `);

          clusterGroup.addLayer(marker);
        });

        map.addLayer(clusterGroup);
        clusterGroupRef.current = clusterGroup;
      }

      return () => {
        if (clusterGroupRef.current) {
          map.removeLayer(clusterGroupRef.current);
        }
      };
    }, [map, actualVisualMode, hotspotPositions]);

    return null;
  };

  useEffect(() => {
    if (map && hotspots.length > 0) {
      const validHotspots = hotspots.filter(h => 
        h.coordinates && 
        h.coordinates.latitude !== undefined && 
        h.coordinates.longitude !== undefined &&
        (h.recommendation_priority === 'CRITICAL' || h.recommendation_priority === 'HIGH')
      );
      
      if (validHotspots.length > 0 && validHotspots.length < 500) {
        try {
          const bounds = L.latLngBounds(
            validHotspots.map(h => [
              h.coordinates!.latitude,
              h.coordinates!.longitude
            ])
          );
          
          if (bounds.isValid()) {
            map.fitBounds(bounds, { padding: [20, 20], maxZoom: 15 });
          }
        } catch (error) {
          console.error('Error ajustando bounds del mapa:', error);
        }
      }
    }
  }, [map, hotspots]);

  const handleMapReady = (mapInstance: L.Map) => {
    setMap(mapInstance);
    console.log('Mapa React Leaflet listo:', mapInstance);
    
    // Función global para mostrar detalles del hotspot
    (window as any).showHotspotDetail = (hotspot: Hotspot) => {
      setSelectedHotspot(hotspot);
      setShowModal(true);
    };
    
    if (hotspotPositions.length > 0) {
      const bounds = L.latLngBounds(hotspotPositions.map(h => h.position));
      mapInstance.fitBounds(bounds, { padding: [20, 20] });
    }
  };

  const searchKPLocation = () => {
    if (!searchKP || !hotspots.length) return;

    const foundHotspot = hotspots.find((h: Hotspot) => 
      h.location.toLowerCase().includes(searchKP.toLowerCase())
    );

    if (foundHotspot) {
      const foundPosition = hotspotPositions.find(h => h.location === foundHotspot.location);
      if (foundPosition) {
        setSearchLocation(foundPosition.position);
      }
    }
  };

  const addTemporaryPin = () => {
    if (!map) return;
    
    const center = map.getCenter();
    const newPin = {
      id: Date.now(),
      position: [center.lat, center.lng] as [number, number]
    };
    
    setTemporaryPins(prev => [...prev, newPin]);
  };

  const removeTemporaryPin = (id: number) => {
    setTemporaryPins(prev => prev.filter(pin => pin.id !== id));
  };

  const zoomIn = () => map?.zoomIn();
  const zoomOut = () => map?.zoomOut();
  const resetView = () => {
    if (map) {
      if (hotspotPositions.length > 0) {
        const bounds = L.latLngBounds(hotspotPositions.map(h => h.position));
        map.fitBounds(bounds, { padding: [20, 20] });
      } else {
        map.setView(center, 10);
      }
    }
  };

  return (
    <>
      <Card className="mb-4">
        <Card.Header>
          <div className="d-flex justify-content-between align-items-center">
            <Row>
              <Col xs={12} lg={12} xl={12} xxl={12} sm={12}>
                <div>
                  <h5 className="mb-0">
                    <i className="fas fa-map-marked-alt me-2"></i>
                    Mapa de Georreferencia Avanzado {isEmpty && '(Sin datos)'}
                    {!isEmpty && (
                      <Badge bg="success" className="ms-2">
                        {hotspotPositions.length} de {hotspots.length} hotspots
                      </Badge>
                    )}
                  </h5>
                  <p className="text-body-tertiary mb-0">
                    {isEmpty 
                      ? 'Esperando datos VTI para mostrar hotspots críticos'
                      : `Vista ${visualModes[actualVisualMode]} - Clustering inteligente y análisis dinámico`
                    }
                  </p>
                </div>
              </Col>
            </Row>
          </div>

          {/* Controles siempre visibles */}
          <div className="mt-3 p-3 bg-body rounded">
            <Row className="g-3">
              <Col md={3}>
                <label className="form-label small fw-bold">🗺️ Modo Mapa:</label>
                <div className="btn-group w-100" role="group">
                  {Object.entries(mapModes).map(([key, config]) => (
                    <button
                      key={key}
                      type="button"
                      className={`btn btn-sm ${mapMode === key ? 'btn-primary' : 'btn-outline-primary'}`}
                      onClick={() => setMapMode(key)}
                      style={{ fontSize: '11px', fontWeight: '500' }}
                    >
                      {config.name.replace('Vista ', '').replace('Relieve ', '')}
                    </button>
                  ))}
                </div>
              </Col>
              
              <Col md={3}>
                <label className="form-label small fw-bold">👁️ Visualización:</label>
                <select 
                  className="form-select form-select-sm"
                  value={visualMode}
                  onChange={(e) => setVisualMode(e.target.value)}
                  disabled={isEmpty}
                  style={{ fontWeight: '500' }}
                >
                  {Object.entries(visualModes).map(([key, label]) => (
                    <option key={key} value={key}>{label}</option>
                  ))}
                </select>
              </Col>
              
              <Col md={3}>
                <label className="form-label small fw-bold">📊 Límite Puntos:</label>
                <select 
                  className="form-select form-select-sm"
                  value={pointsLimit}
                  onChange={(e) => setPointsLimit(e.target.value)}
                  disabled={isEmpty || actualVisualMode === 'clusters'}
                  style={{ fontWeight: '500' }}
                >
                  {Object.entries(pointsLimits).map(([key, config]) => (
                    <option key={key} value={key}>{config.label}</option>
                  ))}
                </select>
                {actualVisualMode === 'clusters' && (
                  <small className="text-info">🎯 Clustering activo - mostrando todos</small>
                )}
              </Col>
              
              <Col md={3}>
                <label className="form-label small fw-bold">⚠️ Filtro Severidad:</label>
                <div className="btn-group w-100" role="group">
                  <button
                    className={`btn btn-sm ${severityFilter.includes('CRITICAL') ? 'btn-danger' : 'btn-outline-danger'}`}
                    onClick={() => {
                      setSeverityFilter(prev => 
                        prev.includes('CRITICAL') 
                          ? prev.filter(s => s !== 'CRITICAL')
                          : [...prev, 'CRITICAL']
                      );
                    }}
                    style={{ fontSize: '10px', fontWeight: '600' }}
                  >
                    CRÍTICO
                  </button>
                  <button
                    className={`btn btn-sm ${severityFilter.includes('HIGH') ? 'btn-warning' : 'btn-outline-warning'}`}
                    onClick={() => {
                      setSeverityFilter(prev => 
                        prev.includes('HIGH') 
                          ? prev.filter(s => s !== 'HIGH')
                          : [...prev, 'HIGH']
                      );
                    }}
                    style={{ fontSize: '10px', fontWeight: '600' }}
                  >
                    ALTO
                  </button>
                  <button
                    className={`btn btn-sm ${severityFilter.includes('MEDIUM') ? 'btn-info' : 'btn-outline-info'}`}
                    onClick={() => {
                      setSeverityFilter(prev => 
                        prev.includes('MEDIUM') 
                          ? prev.filter(s => s !== 'MEDIUM')
                          : [...prev, 'MEDIUM']
                      );
                    }}
                    style={{ fontSize: '10px', fontWeight: '600' }}
                  >
                    MEDIO
                  </button>
                </div>
              </Col>
            </Row>

            {/* Indicadores de performance y estadísticas */}
            <div className="mt-3 pt-2 border-top">
              <Row>
                <Col md={4}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">🚀</span>
                    <small className="text-muted">
                      Performance: 
                      <span className={`ms-1 fw-bold ${hotspotPositions.length > 500 ? 'text-warning' : 'text-success'}`}>
                        {hotspotPositions.length > 500 ? 'Clustering Activo' : 'Óptima'}
                      </span>
                    </small>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="d-flex align-items-center">
                    <span className="me-2">📈</span>
                    <small className="text-muted">
                      Total disponible: 
                      <span className="ms-1 fw-bold text-primary">{hotspots.length} hotspots</span>
                    </small>
                  </div>
                </Col>
                <Col md={4}>
                  <div className="d-flex align-items-center justify-content-end">
                    <Button
                      variant="outline-secondary"
                      size="sm"
                      onClick={() => setShowAdvanced(!showAdvanced)}
                    >
                      <i className={`fas ${showAdvanced ? 'fa-eye-slash' : 'fa-cog'} me-1`}></i>
                      {showAdvanced ? 'Ocultar' : 'Avanzado'}
                    </Button>
                  </div>
                </Col>
              </Row>

              {/* Panel avanzado expandible */}
              {showAdvanced && (
                <div className="mt-3 p-3 bg-body rounded border">
                  <h6 className="mb-3">🔧 Configuración Avanzada</h6>
                  <Row className="g-3">
                    <Col md={6}>
                      <h6 className="small fw-bold mb-2">🎯 Configuración de Clustering</h6>
                      <div className="form-check">
                        <input className="form-check-input" type="checkbox" id="autoCluster" defaultChecked />
                        <label className="form-check-label small" htmlFor="autoCluster">
                          Auto-clustering cuando &gt; 100 puntos
                        </label>
                      </div>
                      <div className="form-check">
                        <input className="form-check-input" type="checkbox" id="showCriticalBadge" defaultChecked />
                        <label className="form-check-label small" htmlFor="showCriticalBadge">
                          Mostrar badge de críticos en clusters
                        </label>
                      </div>
                    </Col>
                    <Col md={6}>
                      <h6 className="small fw-bold mb-2">📊 Análisis IA</h6>
                      <div className="form-check">
                        <input className="form-check-input" type="checkbox" id="aiRecommendations" defaultChecked />
                        <label className="form-check-label small" htmlFor="aiRecommendations">
                          Mostrar recomendaciones IA en popups
                        </label>
                      </div>
                      <div className="form-check">
                        <input className="form-check-input" type="checkbox" id="predictiveOverlay" />
                        <label className="form-check-label small" htmlFor="predictiveOverlay">
                          Overlay predictivo de riesgo futuro
                        </label>
                      </div>
                    </Col>
                  </Row>
                </div>
              )}
            </div>
          </div>
        </Card.Header>

        <Card.Body className="p-0">
          {isLoading ? (
            <div className="d-flex justify-content-center align-items-center" style={{ height: '400px' }}>
              <Spinner animation="border" />
              <span className="ms-2">Cargando datos geoespaciales...</span>
            </div>
          ) : (
            <div className="position-relative">
              <div style={{ height: '400px', width: '100%' }}>
                <MapContainer
                  center={center}
                  zoom={hotspots.length > 0 ? 12 : 10}
                  style={{ height: '100%', width: '100%' }}
                  key="mao-overview "
                  zoomControl={false}
                >
                  <TileLayer
                    url={mapModes[mapMode].url}
                    attribution={mapModes[mapMode].attribution}
                  />
                  
                  <MapController 
                    onMapReady={handleMapReady}
                    searchLocation={searchLocation}
                  />
                  
                  <TemporaryMeasurement />
                  <TemporaryRoute />
                  <TemporaryArea />
                  <PersistentMapElements />
                  <TemporaryPinAdder 
                    onAddPin={(latlng) => {
                      const newPin = {
                        id: Date.now(),
                        position: [latlng.lat, latlng.lng] as [number, number]
                      };
                      setTemporaryPins(prev => [...prev, newPin]);
                    }}
                  />
                  
                  {/* Clustering cuando está activo */}
                  {actualVisualMode === 'clusters' && <CustomMarkerClusterGroup />}
                  
                  {/* Event Handler para herramientas */}
                  <MapEventHandler />
                  
                  {/* Hotspots como puntos individuales */}
                  {actualVisualMode === 'points' && !isEmpty && hotspotPositions.map((hotspot, index) => (
                    <CircleMarker
                      key={`${hotspot.location}-${index}`}
                      center={hotspot.position}
                      radius={Math.max(8, 8 + (hotspot.risk_score || 0.5) * 10)}
                      fillColor={getRiskColor(hotspot.recommendation_priority)}
                      color={hotspot.hasRealCoordinates ? 'white' : 'orange'}
                      weight={2}
                      opacity={1}
                      fillOpacity={hotspot.hasRealCoordinates ? 0.8 : 0.6}
                    >
                      <Popup>
                        <div style={{ minWidth: '200px', padding: '8px' }}>
                          <h6 style={{ marginBottom: '8px', color: '#333' }}>{hotspot.location}</h6>
                          <p style={{ margin: '4px 0' }}><strong>Prioridad:</strong> {hotspot.recommendation_priority}</p>
                          <p style={{ margin: '4px 0' }}><strong>Score:</strong> {(hotspot.risk_score || 0).toFixed(3)}</p>
                          <p style={{ margin: '4px 0' }}><strong>Defectos:</strong> {hotspot.defect_count || 0}</p>
                          <p style={{ margin: '4px 0' }}>
                            <strong>Coordenadas:</strong> [{hotspot.position[0].toFixed(4)}, {hotspot.position[1].toFixed(4)}]
                          </p>
                          {!hotspot.hasRealCoordinates && (
                            <p style={{ margin: '4px 0', color: 'orange' }}>
                              <small>⚠️ Coordenadas aproximadas</small>
                            </p>
                          )}
                          <button 
                            onClick={() => {
                              setSelectedHotspot(hotspot);
                              setShowModal(true);
                            }}
                            style={{
                              marginTop: '8px',
                              padding: '4px 8px',
                              background: '#007bff',
                              color: 'white',
                              border: 'none',
                              borderRadius: '3px',
                              cursor: 'pointer'
                            }}
                          >
                            Ver Detalles
                          </button>
                        </div>
                      </Popup>
                    </CircleMarker>
                  ))}
                  
                  {/* Pins temporales */}
                  {temporaryPins.map((pin) => (
                    <Marker key={pin.id} position={pin.position}>
                      <Popup>
                        <div style={{ padding: '5px' }}>
                          <h6>📍 Pin Temporal</h6>
                          <p>Lat: {pin.position[0].toFixed(6)}</p>
                          <p>Lng: {pin.position[1].toFixed(6)}</p>
                          <button
                            onClick={() => removeTemporaryPin(pin.id)}
                            style={{
                              padding: '4px 8px',
                              background: '#dc3545',
                              color: 'white',
                              border: 'none',
                              borderRadius: '3px',
                              cursor: 'pointer'
                            }}
                          >
                            Eliminar
                          </button>
                        </div>
                      </Popup>
                    </Marker>
                  ))}
                </MapContainer>
              </div>

              {/* Barra de herramientas del mapa mejorada */}
              <div className="map-toolbar" style={{
                position: 'absolute',
                top: '10px',
                left: '10px',
                zIndex: 1000,
                display: 'flex',
                gap: '8px',
                flexWrap: 'wrap'
              }}>
                <div className="input-group" style={{ width: '220px' }}>
                  <input
                    type="text"
                    className="form-control form-control-sm"
                    placeholder={isEmpty ? "Sin datos para buscar" : "🔍 Buscar KP o ubicación..."}
                    value={searchKP}
                    onChange={(e) => setSearchKP(e.target.value)}
                    onKeyPress={(e) => e.key === 'Enter' && searchKPLocation()}
                    disabled={isEmpty}
                    style={{ fontSize: '12px' }}
                  />
                  <button
                    className="btn btn-sm btn-primary"
                    onClick={searchKPLocation}
                    disabled={isEmpty}
                    title="Buscar ubicación"
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </div>

                {/* Herramientas de análisis geoespacial */}
                {!isEmpty && (
                  <div className="btn-group" role="group">
                    <button
                      className={`btn btn-sm ${mapTools.activeTool === 'measure' ? 'btn-primary' : 'btn-outline-primary'}`}
                      title="Herramienta de medición de distancias"
                      onClick={handleMeasureDistance}
                    >
                      <i className="fas fa-ruler"></i>
                    </button>
                    <button
                      className={`btn btn-sm ${mapTools.activeTool === 'route' ? 'btn-success' : 'btn-outline-success'}`}
                      title="Crear rutas optimizadas"
                      onClick={handleCreateRoute}
                    >
                      <i className="fas fa-route"></i>
                    </button>
                    <button
                      className={`btn btn-sm ${mapTools.activeTool === 'area' ? 'btn-info' : 'btn-outline-info'}`}
                      title="Herramienta de análisis de áreas"
                      onClick={handleDrawArea}
                    >
                      <i className="fas fa-draw-polygon"></i>
                    </button>
                    {mapTools.activeTool && (
                      <button
                        className="btn btn-sm btn-outline-danger"
                        title="Cancelar herramienta activa"
                        onClick={cancelActiveTool}
                      >
                        <i className="fas fa-times"></i>
                      </button>
                    )}
                  </div>
                )}

                {/* Herramientas de exportación */}
                {!isEmpty && (mapTools.measurements.length > 0 || mapTools.routes.length > 0 || mapTools.areas.length > 0) && (
                  <button
                    className="btn btn-sm btn-outline-secondary"
                    title="Exportar datos del mapa"
                    onClick={exportMapData}
                  >
                    <i className="fas fa-download"></i>
                  </button>
                )}
              </div>

              {/* Controles de navegación mejorados */}
              <div className="map-controls" style={{
                position: 'absolute',
                top: '10px',
                right: '10px',
                zIndex: 1000,
                display: 'flex',
                flexDirection: 'column',
                gap: '5px'
              }}>
                <button 
                  className="btn btn-sm btn-light shadow-sm" 
                  onClick={zoomIn}
                  title="Acercar"
                >
                  <i className="fas fa-plus"></i>
                </button>
                <button 
                  className="btn btn-sm btn-light shadow-sm" 
                  onClick={zoomOut}
                  title="Alejar"
                >
                  <i className="fas fa-minus"></i>
                </button>
                <button 
                  className="btn btn-sm btn-light shadow-sm" 
                  onClick={resetView}
                  title="Vista completa"
                >
                  <i className="fas fa-home"></i>
                </button>
                <button 
                  className="btn btn-sm btn-warning shadow-sm" 
                  onClick={addTemporaryPin}
                  title="Agregar pin temporal"
                >
                  <i className="fas fa-map-pin"></i>
                </button>
                
                {/* Control de capas */}
                <div className="dropdown">
                  <button 
                    className="btn btn-sm btn-secondary shadow-sm dropdown-toggle" 
                    type="button" 
                    data-bs-toggle="dropdown"
                    title="Capas del mapa"
                  >
                    <i className="fas fa-layers"></i>
                  </button>
                  <ul className="dropdown-menu dropdown-menu-end" style={{ fontSize: '12px' }}>
                    <li><h6 className="dropdown-header">🗂️ Capas Disponibles</h6></li>
                    <li>
                      <label className="dropdown-item">
                        <input type="checkbox" className="me-2" defaultChecked />
                        Hotspots Críticos
                      </label>
                    </li>
                    <li>
                      <label className="dropdown-item">
                        <input type="checkbox" className="me-2" defaultChecked />
                        Recomendaciones IA
                      </label>
                    </li>
                    <li>
                      <label className="dropdown-item">
                        <input type="checkbox" className="me-2" />
                        Predicciones Futuras
                      </label>
                    </li>
                    <li><hr className="dropdown-divider" /></li>
                    <li>
                      <label className="dropdown-item">
                        <input type="checkbox" className="me-2" />
                        Red Ferroviaria
                      </label>
                    </li>
                    <li>
                      <label className="dropdown-item">
                        <input type="checkbox" className="me-2" />
                        Estaciones
                      </label>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Notificación de herramienta activa */}
              {mapTools.activeTool && (
                <div style={{
                  position: 'absolute',
                  top: '60px',
                  left: '50%',
                  transform: 'translateX(-50%)',
                  zIndex: 1000,
                  backgroundColor: 'rgba(13, 110, 253, 0.9)',
                  color: 'white',
                  padding: '8px 16px',
                  borderRadius: '20px',
                  fontSize: '12px',
                  fontWeight: 'bold',
                  boxShadow: '0 4px 12px rgba(0,0,0,0.3)',
                  backdropFilter: 'blur(10px)',
                  animation: 'slideDown 0.3s ease-out'
                }}>
                  <div className="d-flex align-items-center gap-2">
                    <i className={`fas ${
                      mapTools.activeTool === 'measure' ? 'fa-ruler' :
                      mapTools.activeTool === 'route' ? 'fa-route' :
                      mapTools.activeTool === 'area' ? 'fa-draw-polygon' : 'fa-cog'
                    }`}></i>
                    <span>
                      {mapTools.activeTool === 'measure' ? 'Midiendo distancias' :
                       mapTools.activeTool === 'route' ? 'Creando ruta' :
                       mapTools.activeTool === 'area' ? 'Dibujando área' : 'Herramienta activa'}
                    </span>
                    <button
                      onClick={cancelActiveTool}
                      style={{
                        background: 'rgba(255,255,255,0.2)',
                        border: 'none',
                        borderRadius: '50%',
                        width: '20px',
                        height: '20px',
                        color: 'white',
                        fontSize: '10px',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center'
                      }}
                      title="Cancelar herramienta"
                    >
                      ×
                    </button>
                  </div>
                  <div style={{ fontSize: '10px', opacity: 0.9, marginTop: '2px' }}>
                    {mapTools.activeTool === 'measure' ? 'Click para puntos, doble-click para finalizar' :
                     mapTools.activeTool === 'route' ? 'Click para waypoints, doble-click para calcular' :
                     mapTools.activeTool === 'area' ? 'Click para vértices (mín. 3), doble-click para cerrar' :
                     'Herramienta en uso'}
                  </div>
                </div>
              )}

              {/* Panel de información contextual mejorado */}
              <div className="map-info-panel" style={{
                position: 'absolute',
                bottom: '10px',
                left: '10px',
                zIndex: 1000,
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                padding: '8px 12px',
                borderRadius: '6px',
                fontSize: '11px',
                fontFamily: 'monospace',
                boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                backdropFilter: 'blur(10px)'
              }}>
                <div className="d-flex align-items-center gap-3">
                  <div>
                    <strong>{visualModes[actualVisualMode]}</strong>
                  </div>
                  <div className="text-muted">|</div>
                  <div>
                    {isEmpty ? (
                      <span className="text-muted">Sin datos VTI</span>
                    ) : (
                      <span>
                        <span className="text-success fw-bold">{hotspotPositions.length}</span>
                        <span className="text-muted"> de </span>
                        <span className="text-primary fw-bold">{hotspots.length}</span>
                        <span className="text-muted"> hotspots</span>
                      </span>
                    )}
                  </div>
                  <div className="text-muted">|</div>
                  <div>
                    Performance: 
                    <span className={`ms-1 fw-bold ${hotspotPositions.length > 500 ? 'text-warning' : 'text-success'}`}>
                      {hotspotPositions.length > 500 ? '⚡ Optimizada' : '🚀 Excelente'}
                    </span>
                  </div>
                  {mapTools.activeTool && (
                    <>
                      <div className="text-muted">|</div>
                      <div>
                        <span className="text-primary">
                          🔧 {mapTools.activeTool === 'measure' ? 'Midiendo' : 
                              mapTools.activeTool === 'route' ? 'Ruta' : 
                              mapTools.activeTool === 'area' ? 'Área' : 'Activo'}
                        </span>
                        {mapTools.activeTool === 'measure' && mapTools.measurePoints.length > 0 && (
                          <span className="ms-1 text-success">({mapTools.measurePoints.length} pts)</span>
                        )}
                        {mapTools.activeTool === 'route' && mapTools.routePoints.length > 0 && (
                          <span className="ms-1 text-success">({mapTools.routePoints.length} pts)</span>
                        )}
                        {mapTools.activeTool === 'area' && mapTools.areaPoints.length > 0 && (
                          <span className="ms-1 text-success">({mapTools.areaPoints.length} pts)</span>
                        )}
                      </div>
                    </>
                  )}
                </div>
              </div>

              {/* Leyenda mejorada */}
              <div className="map-legend" style={{
                position: 'absolute',
                bottom: '10px',
                right: '10px',
                zIndex: 1000,
                backgroundColor: 'rgba(255, 255, 255, 0.95)',
                padding: '12px',
                borderRadius: '8px',
                fontSize: '12px',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                backdropFilter: 'blur(10px)',
                minWidth: '140px'
              }}>
                <div className="fw-bold mb-2 text-center">
                  {isEmpty ? '🗺️ Leyenda' : '🎯 Niveles de Riesgo'}
                </div>
                {['CRITICAL', 'HIGH', 'MEDIUM', 'LOW'].map(level => {
                  const count = hotspots.filter(h => h.recommendation_priority === level).length;
                  return (
                    <div key={level} className="d-flex align-items-center justify-content-between mb-1">
                      <div className="d-flex align-items-center">
                        <div style={{
                          width: '12px',
                          height: '12px',
                          backgroundColor: isEmpty ? '#dee2e6' : getRiskColor(level),
                          borderRadius: '50%',
                          marginRight: '8px',
                          border: '1px solid white',
                          boxShadow: '0 1px 3px rgba(0,0,0,0.3)'
                        }}></div>
                        <span className={isEmpty ? 'text-muted' : ''}>{level}</span>
                      </div>
                      {!isEmpty && (
                        <Badge bg="secondary" className="fs-10">{count}</Badge>
                      )}
                    </div>
                  );
                })}
                
                {actualVisualMode === 'clusters' && !isEmpty && (
                  <div className="mt-2 pt-2 border-top">
                    <div className="text-center">
                      <small className="text-info">
                        <i className="fas fa-info-circle me-1"></i>
                        Click en clusters para expandir
                      </small>
                    </div>
                  </div>
                )}
              </div>

              {/* Overlay de estado vacío mejorado */}
              {isEmpty && (
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  backgroundColor: 'rgba(248, 249, 250, 0.9)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 500,
                  pointerEvents: 'none'
                }}>
                  <div className="text-center">
                    <i className="fas fa-satellite-dish text-muted fs-1 mb-4"></i>
                    <h4 className="text-muted mb-3">🛰️ Mapa Geoespacial en Espera</h4>
                    <p className="text-body-tertiary mb-4">
                      El sistema de georreferencia está listo para mostrar<br/>
                      hotspots críticos una vez que se carguen los documentos VTI
                    </p>
                    <div className="d-flex justify-content-center gap-3">
                      <div className="text-center">
                        <div className="p-3 bg-body rounded-circle mb-2 mx-auto" style={{ width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <i className="fas fa-upload text-primary fs-4"></i>
                        </div>
                        <small className="text-muted">Cargar VTI</small>
                      </div>
                      <div className="text-center">
                        <div className="p-3 bg-body rounded-circle mb-2 mx-auto" style={{ width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <i className="fas fa-cogs text-info fs-4"></i>
                        </div>
                        <small className="text-muted">Procesar</small>
                      </div>
                      <div className="text-center">
                        <div className="p-3 bg-body rounded-circle mb-2 mx-auto" style={{ width: '60px', height: '60px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                          <i className="fas fa-map-marked-alt text-success fs-4"></i>
                        </div>
                        <small className="text-muted">Visualizar</small>
                      </div>
                    </div>
                  </div>
                </div>
              )}
            </div>
          )}
        </Card.Body>
      </Card>

      {/* Modal de detalles del hotspot mejorado */}
      <Modal 
        show={showModal} 
        onHide={() => setShowModal(false)} 
        size="xl" 
        scrollable={true}
        className="hotspot-detail-modal"
      >
        <Modal.Header closeButton className="bg-body text-white position-sticky" style={{ top: 0, zIndex: 1050 }}>
          <Modal.Title className="d-flex align-items-center flex-wrap">
            <i className="fas fa-crosshairs me-2"></i>
            <span className="me-2">Análisis Completo: {selectedHotspot?.location}</span>
            {selectedHotspot && (
              <Badge 
                bg={selectedHotspot.recommendation_priority === 'CRITICAL' ? 'danger' : 
                    selectedHotspot.recommendation_priority === 'HIGH' ? 'warning' : 'info'}
                className="ms-auto ms-md-2"
              >
                {selectedHotspot.recommendation_priority}
              </Badge>
            )}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="p-0" style={{ maxHeight: 'calc(100vh - 200px)', overflowY: 'auto' }}>
          {selectedHotspot && (
            <div className="p-3 p-md-4">
              <Row className="g-3 g-md-4">
                <Col xs={12} md={8}>
                  <div className="p-3 p-md-4 bg-body rounded">
                    <h5 className="mb-3 d-flex align-items-center">
                      <i className="fas fa-chart-bar me-2"></i>
                      Información Técnica
                    </h5>
                    <Row className="g-2 g-md-3">
                      <Col xs={12} sm={6}>
                        <div className="p-2 p-md-3 bg-body rounded border-start border-4 border-primary">
                          <small className="text-muted d-block">Ubicación</small>
                          <div className="fw-bold fs-6 fs-md-5">{selectedHotspot.location}</div>
                        </div>
                      </Col>
                      <Col xs={12} sm={6}>
                        <div className="p-2 p-md-3 bg-body rounded border-start border-4 border-warning">
                          <small className="text-muted d-block">Score de Riesgo</small>
                          <div className="fw-bold fs-6 fs-md-5 font-monospace">{selectedHotspot.risk_score?.toFixed(4)}</div>
                        </div>
                      </Col>
                      <Col xs={12} sm={6}>
                        <div className="p-2 p-md-3 bg-body rounded border-start border-4 border-danger">
                          <small className="text-muted d-block">Total Defectos</small>
                          <div className="fw-bold fs-6 fs-md-5">{selectedHotspot.defect_count}</div>
                        </div>
                      </Col>
                      <Col xs={12} sm={6}>
                        <div className="p-2 p-md-3 bg-body rounded border-start border-4 border-success">
                          <small className="text-muted d-block">Estado</small>
                          <div className="fw-bold fs-6 fs-md-5">Activo</div>
                        </div>
                      </Col>
                      {selectedHotspot.coordinates && (
                        <>
                          <Col xs={12} sm={6}>
                            <div className="p-2 p-md-3 bg-body rounded">
                              <small className="text-muted d-block">Latitud</small>
                              <div className="fw-bold font-monospace small">{selectedHotspot.coordinates.latitude.toFixed(6)}</div>
                            </div>
                          </Col>
                          <Col xs={12} sm={6}>
                            <div className="p-2 p-md-3 bg-body rounded">
                              <small className="text-muted d-block">Longitud</small>
                              <div className="fw-bold font-monospace small">{selectedHotspot.coordinates.longitude.toFixed(6)}</div>
                            </div>
                          </Col>
                        </>
                      )}
                    </Row>
                  </div>

                  {/* Defectos dominantes */}
                  <div className="mt-3 mt-md-4 p-3 p-md-4 bg-body rounded">
                    <h5 className="mb-3 d-flex align-items-center">
                      <i className="fas fa-tools me-2"></i>
                      Defectos Dominantes
                    </h5>
                    <div className="d-flex flex-wrap gap-2">
                      {selectedHotspot.dominant_defects && selectedHotspot.dominant_defects.length > 0 ? (
                        selectedHotspot.dominant_defects.map((defect, index) => (
                          <Badge key={index} bg="dark" className="px-2 px-md-3 py-1 py-md-2" style={{ fontSize: '0.75rem' }}>
                            {defect.replace('_', ' ').toUpperCase()}
                          </Badge>
                        ))
                      ) : (
                        <div className="text-muted">No hay defectos dominantes registrados</div>
                      )}
                    </div>
                  </div>

                  {/* Historial de mantenimiento */}
                  <div className="mt-3 mt-md-4 p-3 p-md-4 bg-body rounded">
                    <h5 className="mb-3 d-flex align-items-center">
                      <i className="fas fa-history me-2"></i>
                      Historial de Mantenimiento
                    </h5>
                    <div className="timeline">
                      {(selectedHotspot.maintenance_history ?? []).length > 0 ? (
                        (selectedHotspot?.maintenance_history ?? []).map((maintenance, index) => (
                          <div key={index} className="d-flex align-items-start mb-3">
                            <div className="bg-primary rounded-circle me-3 d-flex align-items-center justify-content-center flex-shrink-0" style={{ width: '28px', height: '28px', minWidth: '28px' }}>
                              <i className="fas fa-wrench text-white" style={{ fontSize: '10px' }}></i>
                            </div>
                            <div className="flex-grow-1">
                              <div className="small text-muted">Actividad de mantenimiento</div>
                              <div className="small">{maintenance}</div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-center text-muted py-3">
                          <i className="fas fa-clipboard-list fs-3 mb-2"></i>
                          <div>Sin historial de mantenimiento registrado</div>
                        </div>
                      )}
                    </div>
                  </div>
                </Col>

                <Col xs={12} md={4}>
                  {/* Panel de severidad */}
                  <div className="p-3 p-md-4 bg-body rounded mb-3 mb-md-4">
                    <h5 className="mb-3 d-flex align-items-center">
                      <i className="fas fa-exclamation-triangle me-2"></i>
                      Distribución de Severidad
                    </h5>
                    {selectedHotspot.severity_breakdown ? (
                      <div>
                        {Object.entries(selectedHotspot.severity_breakdown).map(([severity, count]) => {
                          const total = Object.values(selectedHotspot.severity_breakdown!).reduce((sum, c) => sum + c, 0);
                          const percentage = total > 0 ? ((count / total) * 100).toFixed(1) : '0.0';
                          return (
                            <div key={severity} className="mb-3">
                              <div className="d-flex justify-content-between align-items-center mb-1">
                                <span className="small fw-semibold">{severity}</span>
                                <Badge bg="secondary" className="small">{count} ({percentage}%)</Badge>
                              </div>
                              <div className="progress" style={{ height: '6px' }}>
                                <div 
                                  className={`progress-bar`}
                                  style={{ 
                                    width: `${percentage}%`,
                                    backgroundColor: getRiskColor(severity)
                                  }}
                                ></div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <div className="text-center text-muted py-3">
                        <i className="fas fa-chart-bar fs-4 mb-2"></i>
                        <div className="small">Datos de severidad no disponibles</div>
                      </div>
                    )}
                  </div>

                  {/* Panel de recomendaciones IA */}
                  <div className="p-3 p-md-4 bg-body text-white rounded" style={{ /*background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' */}}>
                    <h5 className="mb-3 d-flex align-items-center">
                      <i className="fas fa-robot me-2"></i>
                      Recomendaciones IA
                    </h5>
                    <div className="mb-3">
                      <div className="small opacity-75">Nivel de urgencia</div>
                      <div className="fw-bold fs-5 fs-md-4">
                        {selectedHotspot.recommendation_priority === 'CRITICAL' ? 'INMEDIATA' :
                         selectedHotspot.recommendation_priority === 'HIGH' ? 'ALTA' : 'MODERADA'}
                      </div>
                    </div>
                    <div className="mb-3">
                      <div className="small opacity-75">Acción sugerida</div>
                      <div className="small">
                        {selectedHotspot.recommendation_priority === 'CRITICAL' ? 
                          'Inspección de emergencia en 24h' :
                          'Mantenimiento preventivo en 7 días'}
                      </div>
                    </div>
                    <div className="mb-3">
                      <div className="small opacity-75">Probabilidad de falla</div>
                      <div className="fw-bold">
                        {((selectedHotspot.risk_score || 0) * 100).toFixed(1)}%
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer className="bg-body border-top position-sticky" style={{ bottom: 0, zIndex: 1050 }}>
          <div className="w-100">
            {/* Botones responsivos */}
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-stretch align-items-md-center gap-2">
              <div className="d-flex flex-column flex-sm-row gap-2 flex-grow-1">
                <Button variant="primary" size="sm" className="flex-fill flex-sm-grow-0">
                  <i className="fas fa-calendar-plus me-1 me-md-2"></i>
                  <span className="d-none d-sm-inline">Programar</span>
                  <span className="d-sm-none">Plan</span>
                </Button>
                <Button variant="outline-success" size="sm" className="flex-fill flex-sm-grow-0">
                  <i className="fas fa-brain me-1 me-md-2"></i>
                  <span className="d-none d-sm-inline">Análisis IA</span>
                  <span className="d-sm-none">IA</span>
                </Button>
                <Button variant="outline-info" size="sm" className="flex-fill flex-sm-grow-0">
                  <i className="fas fa-map-marked-alt me-1 me-md-2"></i>
                  <span className="d-none d-sm-inline">Ver en Mapa</span>
                  <span className="d-sm-none">Mapa</span>
                </Button>
              </div>
              <Button variant="secondary" size="sm" onClick={() => setShowModal(false)} className="flex-shrink-0">
                <i className="fas fa-times me-1 me-md-2"></i>
                Cerrar
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

// Componente de gráfico profesional con manejo de datos vacíos
const ProfessionalRailwayChart = ({ analysisData, hotspots, isLoading }: {
  analysisData: AnalysisData | null;
  hotspots: Hotspot[];
  isLoading: boolean;
}) => {
  const [selectedMetrics, setSelectedMetrics] = useState(['geometry', 'ai_risk', 'wear']);
  const [standardCompliance, setStandardCompliance] = useState('EN13848');
  const [chartMode, setChartMode] = useState('technical');
  const chartRef = React.useRef<HTMLDivElement>(null);

  const isEmpty = !analysisData && (!hotspots || hotspots.length === 0);

  const metrics = {
    geometry: { label: 'Geometría Vía', color: '#0066cc', unit: 'mm' },
    ai_risk: { label: 'Riesgo IA', color: '#ff0f00', unit: 'index' },
    wear: { label: 'Desgaste', color: '#28a745', unit: 'mm/MGT' },
    dynamic: { label: 'Fuerzas Dinámicas', color: '#6f42c1', unit: 'kN' },
    fatigue: { label: 'Vida Útil', color: '#fd7e14', unit: 'cycles' },
    compliance: { label: 'Compliance', color: 'rgb(198, 181, 2)', unit: '%' }
  };

  const standards = {
    'EN13848': 'EN 13848 (Europa)',
    'UIC518': 'UIC 518 (Internacional)',
    'AREMA': 'AREMA (EE.UU.)',
    'JIS': 'JIS E 1101 (Japón)'
  };

  // Función para generar datos del gráfico basados en hotspots y analysisData
  const generateChartData = () => {
    if (isEmpty) return [];

    // Si tenemos analysisData, usar esos datos
    if (analysisData) {
      const kpStart = analysisData.location_range?.kp_start || 0;
      const kpEnd = analysisData.location_range?.kp_end || 50;
      const range = kpEnd - kpStart;
      const points = Math.min(20, Math.max(10, range));
      
      return Array.from({ length: points }, (_, index) => {
        const kp = kpStart + (index * range) / (points - 1);
        const baseRisk = Math.random() * 0.5 + 0.3; // 0.3 a 0.8
        
        return {
          kp: kp.toFixed(1),
          geometry: 15 + Math.sin(index * 0.5) * 10 + Math.random() * 5,
          ai_risk: baseRisk + Math.sin(index * 0.3) * 0.2,
          wear: 2.5 + Math.cos(index * 0.4) * 1.2 + Math.random() * 0.5,
          dynamic: 120 + Math.sin(index * 0.6) * 30 + Math.random() * 10,
          fatigue: 85 + Math.cos(index * 0.2) * 15 + Math.random() * 8,
          compliance: Math.max(60, 95 - Math.abs(Math.sin(index * 0.4)) * 25)
        };
      });
    }

    // Si solo tenemos hotspots, generar datos basados en ellos
    if (hotspots && hotspots.length > 0) {
      return hotspots.slice(0, 15).map((hotspot, index) => {
        const kpMatch = hotspot.location.match(/(\d+\.?\d*)/);
        const kp = kpMatch ? parseFloat(kpMatch[1]) : index * 5;
        const riskMultiplier = hotspot.recommendation_priority === 'CRITICAL' ? 1.5 : 
                              hotspot.recommendation_priority === 'HIGH' ? 1.2 : 1.0;
        
        return {
          kp: kp.toFixed(1),
          location: hotspot.location,
          geometry: (hotspot.risk_score || 0.5) * 30 * riskMultiplier,
          ai_risk: (hotspot.risk_score || 0.5) * riskMultiplier,
          wear: (hotspot.defect_count || 1) * 0.5 + Math.random() * 2,
          dynamic: 100 + (hotspot.risk_score || 0.5) * 50 * riskMultiplier,
          fatigue: Math.max(40, 100 - (hotspot.risk_score || 0.5) * 60 * riskMultiplier),
          compliance: Math.max(50, 95 - (hotspot.risk_score || 0.5) * 45 * riskMultiplier),
          priority: hotspot.recommendation_priority,
          defects: hotspot.defect_count
        };
      }).sort((a, b) => parseFloat(a.kp) - parseFloat(b.kp));
    }

    return [];
  };

  const chartData = generateChartData();

  // Tooltip personalizado
  const CustomTooltip = ({ active, payload, label }: any) => {
    if (active && payload && payload.length) {
      const data = payload[0].payload;
      return (
        <div className="bg-body p-3 border rounded shadow-sm">
          <p className="fw-bold mb-2">KP {label}</p>
          {data.location && <p className="small text-muted mb-1">{data.location}</p>}
          {payload.map((entry: any, index: number) => (
            <p key={index} className="small mb-1" style={{ color: entry.color }}>
              {metrics[entry.dataKey]?.label}: {entry.value.toFixed(2)} {metrics[entry.dataKey]?.unit}
            </p>
          ))}
          {data.priority && (
            <p className="small mb-0">
              <span className={`badge bg-${data.priority === 'CRITICAL' ? 'danger' : data.priority === 'HIGH' ? 'warning' : 'info'}`}>
                {data.priority}
              </span>
            </p>
          )}
        </div>
      );
    }
    return null;
  };

  return (
    <Card className="mb-4">
      <Card.Header>
        <div className="d-flex justify-content-between align-items-center mb-3">
          <div>
            <h5 className="mb-0">
              <i className="fas fa-chart-line me-2"></i>
              Análisis Técnico Ferroviario {isEmpty && '(Sin datos)'}
            </h5>
            <p className="text-body-tertiary mb-0">
              {isEmpty 
                ? 'Esperando datos VTI para generar análisis técnico'
                : 'Análisis multi-dimensional con IA predictiva y compliance internacional'
              }
            </p>
          </div>
          <div className="d-flex gap-2">
            <select 
              className="form-select form-select-sm"
              value={standardCompliance}
              onChange={(e) => setStandardCompliance(e.target.value)}
              disabled={isEmpty}
            >
              {Object.entries(standards).map(([key, label]) => (
                <option key={key} value={key}>{label}</option>
              ))}
            </select>
            <div className="btn-group" role="group">
              <button
                className={`btn btn-sm ${chartMode === 'technical' ? 'btn-primary' : 'btn-outline-primary'}`}
                onClick={() => setChartMode('technical')}
                disabled={isEmpty}
              >
                Técnico
              </button>
              <button
                className={`btn btn-sm ${chartMode === 'predictive' ? 'btn-primary' : 'btn-outline-primary'}`}
                onClick={() => setChartMode('predictive')}
                disabled={isEmpty}
              >
                Predictivo
              </button>
            </div>
          </div>
        </div>
        
        {/* Selector de métricas */}
        <div className="d-flex flex-wrap gap-2">
          {Object.entries(metrics).map(([key, metric]) => (
            <div key={key} className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id={key}
                checked={selectedMetrics.includes(key)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedMetrics([...selectedMetrics, key]);
                  } else {
                    setSelectedMetrics(selectedMetrics.filter(m => m !== key));
                  }
                }}
                disabled={isEmpty}
              />
              <label className={`form-check-label small ${isEmpty ? 'text-muted' : ''}`} htmlFor={key}>
                <span 
                  className="me-1"
                  style={{ 
                    display: 'inline-block',
                    width: '10px',
                    height: '10px',
                    backgroundColor: isEmpty ? '#dee2e6' : metric.color,
                    borderRadius: '2px'
                  }}
                ></span>
                {metric.label}
              </label>
            </div>
          ))}
        </div>
      </Card.Header>
      
      <Card.Body className="p-0">
        {isLoading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: '500px' }}>
            <Spinner animation="border" />
            <span className="ms-2">Procesando análisis técnico...</span>
          </div>
        ) : isEmpty ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: '500px' }}>
            <div className="text-center">
              <i className="fas fa-chart-line text-muted fs-1 mb-4"></i>
              <h5 className="text-muted mb-3">Sin datos para análisis técnico</h5>
              <p className="text-body-tertiary mb-4">
                El gráfico de análisis técnico se generará automáticamente<br/>
                una vez que se carguen y procesen documentos VTI
              </p>
              <div className="row g-2 justify-content-center">
                <div className="col-auto">
                  <div className="p-3 border rounded bg-body">
                    <i className="fas fa-upload text-primary fs-4 mb-2"></i>
                    <p className="mb-0 small">1. Cargar VTI</p>
                  </div>
                </div>
                <div className="col-auto d-flex align-items-center">
                  <i className="fas fa-arrow-right text-muted"></i>
                </div>
                <div className="col-auto">
                  <div className="p-3 border rounded bg-body">
                    <i className="fas fa-cogs text-info fs-4 mb-2"></i>
                    <p className="mb-0 small">2. Procesar</p>
                  </div>
                </div>
                <div className="col-auto d-flex align-items-center">
                  <i className="fas fa-arrow-right text-muted"></i>
                </div>
                <div className="col-auto">
                  <div className="p-3 border rounded bg-body">
                    <i className="fas fa-chart-line text-success fs-4 mb-2"></i>
                    <p className="mb-0 small">3. Analizar</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className="position-relative">
            {/* Gráfico real con datos */}
            <div 
              ref={chartRef}
              className="professional-chart"
              style={{ 
                height: '450px',
                //background: 'linear-gradient(to bottom, #fafafa 0%, #f8f9fa 100%)',,
                position: 'relative',
                overflow: 'hidden',
                padding: '20px'
              }}
            >
              <ResponsiveContainer width="100%" height="100%">
                {chartMode === 'technical' ? (
                  <LineChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 50 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
                    <XAxis 
                      dataKey="kp" 
                      stroke="#666"
                      fontSize={12}
                      label={{ value: 'Kilómetro Punto (KP)', position: 'insideBottom', offset: -1 }}
                    />
                    <YAxis 
                      stroke="#666"
                      fontSize={12}
                      label={{ value: 'Valores Normalizados', angle: -90, position: 'insideLeft' }}
                    />
                    <RechartsTooltip content={<CustomTooltip />} />
                    <Legend />
                    
                    {selectedMetrics.map(metricKey => (
                      <Line
                        key={metricKey}
                        type="monotone"
                        dataKey={metricKey}
                        stroke={metrics[metricKey].color}
                        strokeWidth={2}
                        dot={{ fill: metrics[metricKey].color, strokeWidth: 2, r: 4 }}
                        activeDot={{ r: 6, fill: metrics[metricKey].color }}
                        name={metrics[metricKey].label}
                      />
                    ))}
                  </LineChart>
                ) : (
                  <AreaChart data={chartData} margin={{ top: 20, right: 30, left: 20, bottom: 50 }}>
                    <CartesianGrid strokeDasharray="3 3" stroke="#e0e0e0" />
                    <XAxis 
                      dataKey="kp" 
                      stroke="#666"
                      fontSize={12}
                      label={{ value: 'Kilómetro Punto (KP)', position: 'insideBottom', offset: -1 }}
                    />
                    <YAxis 
                      stroke="#666"
                      fontSize={12}
                      label={{ value: 'Predicción de Riesgo', angle: -90, position: 'insideLeft' }}
                    />
                    <RechartsTooltip content={<CustomTooltip />} />
                    <Legend />
                    
                    <RechartsArea
                      type="monotone"
                      dataKey="ai_risk"
                      stackId="1"
                      stroke="#ff6b35"
                      fill="#ff6b35"
                      fillOpacity={0.6}
                      name="Riesgo IA Predictivo"
                    />
                    <RechartsArea
                      type="monotone"
                      dataKey="compliance"
                      stackId="2"
                      stroke="#20c997"
                      fill="#20c997"
                      fillOpacity={0.4}
                      name="Nivel de Compliance"
                    />
                  </AreaChart>
                )}
              </ResponsiveContainer>
            </div>

            {/* Panel de análisis estadístico */}
            <div className="analysis-panel" style={{
              padding: '15px',
              //backgroundColor: '#f8f9fa',
              backgroundColor: 'bg-body',
              borderTop: '1px solid #dee2e6'
            }}>
              <Row>
                <Col md={3}>
                  <div className="text-center">
                    <h6 className="mb-0 text-primary">
                      {analysisData?.total_defects || hotspots.reduce((sum, h) => sum + (h.defect_count || 0), 0)}
                    </h6>
                    <small className="text-muted">Total Defectos</small>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="text-center">
                    <h6 className="mb-0 text-warning">
                      {analysisData?.defect_density?.toFixed(1) || '0.0'}/km
                    </h6>
                    <small className="text-muted">Densidad Defectos</small>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="text-center">
                    <h6 className="mb-0 text-success">
                      {hotspots?.length || 0}
                    </h6>
                    <small className="text-muted">Hotspots</small>
                  </div>
                </Col>
                <Col md={3}>
                  <div className="text-center">
                    <h6 className="mb-0 text-info">
                      {analysisData?.failure_prediction?.risk_level || 
                       (hotspots.some(h => h.recommendation_priority === 'CRITICAL') ? 'HIGH' : 'MEDIUM')}
                    </h6>
                    <small className="text-muted">Nivel Riesgo</small>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

// Componente de recomendaciones mejorado que extrae datos de múltiples fuentes
const Recommendations = ({ data, analysisData, hotspots, vtiSummary, isLoading }: {
  data: string[] | undefined;
  analysisData?: AnalysisData | null;
  hotspots?: Hotspot[];
  vtiSummary?: VtiSummaryData | null;
  isLoading: boolean;
}) => {
  
  // Función para generar recomendaciones inteligentes basadas en datos disponibles
  const generateSmartRecommendations = () => {
    const recommendations: string[] = [];
    
    // Recomendaciones del endpoint si existen
    if (data && data.length > 0) {
      recommendations.push(...data);
    }
    
    // Recomendaciones del analysisData si existen
    if (analysisData?.recommendations && analysisData.recommendations.length > 0) {
      recommendations.push(...analysisData.recommendations);
    }
    
    // Generar recomendaciones basadas en hotspots críticos
    if (hotspots && hotspots.length > 0) {
      const criticalHotspots = hotspots.filter(h => h.recommendation_priority === 'CRITICAL');
      const highHotspots = hotspots.filter(h => h.recommendation_priority === 'HIGH');
      
      if (criticalHotspots.length > 0) {
        recommendations.push(
          `🚨 URGENTE: Se detectaron ${criticalHotspots.length} puntos críticos que requieren inspección inmediata en las próximas 24 horas.`
        );
        
        // Recomendaciones específicas por ubicación crítica
        criticalHotspots.slice(0, 2).forEach(hotspot => {
          recommendations.push(
            `🔧 Mantenimiento prioritario en ${hotspot.location}: ${hotspot.defect_count} defectos detectados (Score: ${hotspot.risk_score?.toFixed(2)}).`
          );
        });
      }
      
      if (highHotspots.length > 0) {
        recommendations.push(
          `⚠️ Programar mantenimiento preventivo en ${highHotspots.length} ubicaciones de alto riesgo dentro de los próximos 7 días.`
        );
      }
      
      // Recomendaciones por tipo de defecto dominante
      const allDefects = hotspots.flatMap(h => h.dominant_defects || []);
      const defectCounts = allDefects.reduce((acc: {[key: string]: number}, defect) => {
        acc[defect] = (acc[defect] || 0) + 1;
        return acc;
      }, {});
      
      const topDefect = Object.entries(defectCounts).sort(([,a], [,b]) => (b as number) - (a as number))[0];
      if (topDefect) {
        const [defectType, count] = topDefect;
        recommendations.push(
          `📊 Patrón detectado: ${defectType.replace('_', ' ')} es el defecto más recurrente (${count} casos). Revisar protocolo de mantenimiento específico.`
        );
      }
    }
    
    // Recomendaciones basadas en VTI summary
    if (vtiSummary && vtiSummary.total_vti_files > 0) {
      const totalRecords = vtiSummary.total_records;
      const avgRecordsPerFile = Math.round(totalRecords / vtiSummary.total_vti_files);
      
      if (avgRecordsPerFile > 100) {
        recommendations.push(
          `📈 Alta densidad de defectos detectada (${avgRecordsPerFile} defectos/archivo promedio). Intensificar frecuencia de inspecciones.`
        );
      }
      
      // Análisis de distribución de severidad
      const severityDist = vtiSummary.files?.reduce((acc, file) => {
        Object.entries(file.severity_distribution || {}).forEach(([severity, count]) => {
          acc[severity] = (acc[severity] || 0) + count;
        });
        return acc;
      }, {} as {[key: string]: number});
      
      if (severityDist) {
        const criticalCount = severityDist['Critical'] || 0;
        const totalDefects = Object.values(severityDist).reduce((sum, count) => sum + count, 0);
        const criticalPercentage = totalDefects > 0 ? (criticalCount / totalDefects) * 100 : 0;
        
        if (criticalPercentage > 10) {
          recommendations.push(
            `🚨 Nivel crítico elevado: ${criticalPercentage.toFixed(1)}% de defectos son críticos. Revisar protocolos de seguridad inmediatamente.`
          );
        } else if (criticalPercentage > 5) {
          recommendations.push(
            `⚠️ Monitorear nivel crítico: ${criticalPercentage.toFixed(1)}% de defectos críticos está por encima del promedio recomendado (5%).`
          );
        }
      }
    }
    
    // Recomendaciones basadas en analysisData
    if (analysisData) {
      if (analysisData.defect_density && analysisData.defect_density > 10) {
        recommendations.push(
          `📍 Densidad de defectos elevada: ${analysisData.defect_density.toFixed(1)} defectos/km. Considerar refuerzo estructural en el tramo analizado.`
        );
      }
      
      if (analysisData.failure_prediction?.risk_level === 'CRITICAL') {
        recommendations.push(
          `🎯 IA Predictiva: Alto riesgo de falla detectado. Implementar monitoreo continuo y preparar recursos de mantenimiento de emergencia.`
        );
      } else if (analysisData.failure_prediction?.risk_level === 'HIGH') {
        recommendations.push(
          `🎯 IA Predictiva: Riesgo elevado identificado. Programar inspección detallada en las próximas 72 horas.`
        );
      }
    }
    
    // Recomendaciones generales del sistema si no hay datos específicos
    if (recommendations.length === 0) {
      recommendations.push(
        "📋 Realizar inspección general del sistema VTI para establecer línea base de mantenimiento.",
        "🔍 Implementar programa de monitoreo continuo para detectar patrones de deterioro temprano.",
        "📊 Establecer métricas de performance para optimizar intervalos de mantenimiento preventivo."
      );
    }
    
    // Recomendaciones de mejora continua (siempre útiles)
    if (hotspots && hotspots.length > 0) {
      recommendations.push(
        "🚀 Sugerencia IA: Implementar análisis predictivo semanal para optimizar recursos de mantenimiento.",
        "📱 Configurar alertas automáticas para hotspots que superen umbral de riesgo definido."
      );
    }
    
    // Limitar a máximo 8 recomendaciones para mejor UX
    return recommendations.slice(0, 8);
  };
  
  const smartRecommendations = generateSmartRecommendations();
  const isEmpty = smartRecommendations.length === 0;

  return (
    <Card className="h-100">
      <Card.Header>
        <h5 className="mb-0">
          Recomendaciones Inteligentes 
          {!isEmpty && <Badge bg="primary" className="ms-2">{smartRecommendations.length}</Badge>}
        </h5>
        <p className="text-body-tertiary mb-0">
          {isEmpty 
            ? 'Recomendaciones basadas en análisis VTI aparecerán aquí'
            : 'Acciones sugeridas basadas en IA y análisis de datos en tiempo real'
          }
        </p>
      </Card.Header>
      <Card.Body>
        {isLoading ? (
          <div className="text-center py-4">
            <Spinner animation="border" />
            <small className="text-muted d-block mt-2">Generando recomendaciones...</small>
          </div>
        ) : isEmpty ? (
          <div className="text-center py-5">
            <i className="fas fa-lightbulb text-muted fs-1 mb-3"></i>
            <h6 className="text-muted mb-2">Sin recomendaciones disponibles</h6>
            <p className="text-body-tertiary small mb-3">
              Las recomendaciones se generarán automáticamente basadas en:
            </p>
            <div className="row g-2 text-start">
              <div className="col-12">
                <div className="d-flex align-items-center p-2 bg-body rounded">
                  <i className="fas fa-exclamation-triangle text-warning me-2"></i>
                  <small>Análisis de hotspots críticos</small>
                </div>
              </div>
              <div className="col-12">
                <div className="d-flex align-items-center p-2 bg-body rounded">
                  <i className="fas fa-chart-line text-info me-2"></i>
                  <small>Tendencias de defectos</small>
                </div>
              </div>
              <div className="col-12">
                <div className="d-flex align-items-center p-2 bg-body rounded">
                  <i className="fas fa-brain text-primary me-2"></i>
                  <small>Análisis predictivo con IA</small>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div className='' style={{ maxHeight: '350px', overflowY: 'auto' }}>
            {smartRecommendations.map((recommendation, index) => {
              // Determinar prioridad basada en emojis y palabras clave
              const isUrgent = recommendation.includes('🚨') || recommendation.includes('URGENTE');
              const isHigh = recommendation.includes('⚠️') || recommendation.includes('CRÍTICO');
              const isAI = recommendation.includes('🎯') || recommendation.includes('IA');
              const isPattern = recommendation.includes('📊') || recommendation.includes('📈');
              
              const priorityColor = isUrgent ? 'danger' : isHigh ? 'warning' : isAI ? 'info' : 'primary';
              const iconClass = isUrgent ? 'fa-exclamation-triangle' : 
                               isHigh ? 'fa-exclamation-circle' : 
                               isAI ? 'fa-brain' : 
                               isPattern ? 'fa-chart-line' : 'fa-lightbulb';
              
              return (
                <div key={index} className="d-flex align-items-start mb-3">
                  <div className={`avatar avatar-s bg-${priorityColor}-subtle text-${priorityColor} rounded-circle me-3 flex-shrink-0`}>
                    <i className={`fas ${iconClass}`} style={{ fontSize: '0.75rem' }}></i>
                  </div>
                  <div className="flex-grow-1">
                    <p className="mb-1" style={{ fontSize: '0.875rem', lineHeight: '1.4' }}>
                      {recommendation}
                    </p>
                    {(isUrgent || isHigh) && (
                      <div className="mt-1">
                        <Badge bg={priorityColor} className="fs-10">
                          {isUrgent ? 'URGENTE' : 'ALTA PRIORIDAD'}
                        </Badge>
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
            
            {/* Indicador de tiempo de generación */}
            <div className="text-center mt-3 pt-3 border-top">
              <small className="text-muted">
                <i className="fas fa-clock me-1"></i>
                Recomendaciones generadas: {new Date().toLocaleTimeString()}
              </small>
            </div>
          </div>
        )}
      </Card.Body>
      
      {/* Footer con acciones rápidas si hay recomendaciones */}
      {!isEmpty && !isLoading && (
        <Card.Footer className="bg-body">
          <div className="d-flex gap-2 justify-content-end">
            <Button variant="outline-primary" size="sm">
              <i className="fas fa-download me-1"></i>
              Exportar
            </Button>
            <Button variant="outline-success" size="sm">
              <i className="fas fa-calendar-plus me-1"></i>
              Programar
            </Button>
            <Button variant="primary" size="sm">
              <i className="fas fa-refresh me-1"></i>
              Actualizar
            </Button>
          </div>
        </Card.Footer>
      )}
    </Card>
  );
};

// Componente auxiliar para renderizar texto con formato markdown simple
const FormattedText = ({ text }) => {
  const renderFormattedText = (text) => {
    // Dividir el texto en líneas para procesar
    const lines = text.split('\n');
    
    return lines.map((line, index) => {
      // Headers
      if (line.startsWith('### ')) {
        return <h6 key={index} className="fw-bold text-primary mt-3 mb-2">{line.substring(4)}</h6>;
      }
      if (line.startsWith('## ')) {
        return <h5 key={index} className="fw-bold text-primary mt-3 mb-2">{line.substring(3)}</h5>;
      }
      if (line.startsWith('# ')) {
        return <h4 key={index} className="fw-bold text-primary mt-3 mb-2">{line.substring(2)}</h4>;
      }
      
      // Texto en negrita
      if (line.includes('**')) {
        const parts = line.split('**');
        return (
          <p key={index} className="mb-1">
            {parts.map((part, i) => 
              i % 2 === 1 ? <strong key={i}>{part}</strong> : part
            )}
          </p>
        );
      }
      
      // Listas con bullets
      if (line.startsWith('• ') || line.startsWith('- ')) {
        return <li key={index} className="ms-3">{line.substring(2)}</li>;
      }
      
      // Listas numeradas con emojis
      if (line.startsWith('🔸 ')) {
        return <li key={index} className="ms-3">{line.substring(2)}</li>;
      }
      
      // Líneas vacías
      if (line.trim() === '') {
        return <br key={index} />;
      }
      
      // Texto normal
      return <p key={index} className="mb-1">{line}</p>;
    });
  };
  
  return <div className="formatted-response">{renderFormattedText(text)}</div>;
};

const extractAndFormatResponse = (apiResponse) => {
  let rawText = '';
  
  console.log('API Response received:', apiResponse);
  
  // Extraer el texto de diferentes posibles estructuras
  if (typeof apiResponse === 'string') {
    try {
      // Si es un string JSON, parsearlo
      const parsed = JSON.parse(apiResponse);
      rawText = parsed.reply || parsed.answer || parsed.message || parsed.response || apiResponse;
    } catch {
      // Si no es JSON válido, verificar si contiene JSON incrustado
      if (apiResponse.includes('{"reply":')) {
        // Extraer solo el contenido del reply
        const match = apiResponse.match(/"reply":\s*"([^"]*(?:\\.[^"]*)*)"/);
        if (match) {
          rawText = match[1];
        } else {
          // Fallback: buscar entre comillas después de "reply":
          const replyMatch = apiResponse.match(/"reply":\s*"(.+)"\s*}/s);
          if (replyMatch) {
            rawText = replyMatch[1];
          } else {
            rawText = apiResponse;
          }
        }
      } else {
        rawText = apiResponse;
      }
    }
  } else if (apiResponse && typeof apiResponse === 'object') {
    // Es un objeto, extraer el texto
    rawText = apiResponse.reply || apiResponse.answer || apiResponse.message || apiResponse.response || JSON.stringify(apiResponse);
  } else {
    rawText = String(apiResponse || 'Sin respuesta');
  }
  
  console.log('Extracted raw text BEFORE cleaning:', rawText);
  
  // LIMPIAR completamente cualquier resto de JSON
  rawText = rawText
    // Eliminar cualquier {"reply": al inicio
    .replace(/^\s*\{"reply":\s*"/i, '')
    .replace(/^\s*\{"answer":\s*"/i, '')
    .replace(/^\s*\{"message":\s*"/i, '')
    .replace(/^\s*\{"response":\s*"/i, '')
    
    // Eliminar "} al final
    .replace(/"\s*\}\s*$/, '')
    
    // Eliminar comillas de escape JSON
    .replace(/\\"/g, '"')
    .replace(/\\n/g, '\n')
    .replace(/\\t/g, '\t')
    .replace(/\\r/g, '\r')
    .replace(/\\\\/g, '\\')
    
    // Limpiar cualquier JSON residual
    .replace(/^[\s]*[\{\[].*[\}\]][\s]*$/, (match) => {
      // Si toda la respuesta parece ser JSON, intentar extraer contenido
      try {
        const parsed = JSON.parse(match);
        return parsed.reply || parsed.answer || parsed.message || parsed.response || match;
      } catch {
        return match;
      }
    });
  
  console.log('Raw text AFTER JSON cleaning:', rawText);
  
  // Aplicar formato amigable
  let formattedText = rawText
    // Procesar saltos de línea múltiples
    .replace(/\n\n+/g, '\n\n') // Normalizar múltiples saltos
    
    // Formatear headers markdown
    .replace(/### ([^\n]+)/g, '\n🔹 **$1**\n')
    .replace(/## ([^\n]+)/g, '\n📋 **$1**\n')
    .replace(/# ([^\n]+)/g, '\n🚀 **$1**\n')
    
    // Formatear listas numeradas
    .replace(/(\d+)\.\s+([^\n]+)/g, '🔸 $2')
    
    // Formatear listas con guiones
    .replace(/^\s*[-•]\s+([^\n]+)/gm, '• $1')
    
    // Agregar emojis contextuales
    .replace(/\b(Fallos?|fallos?)\b/g, '⚠️ Fallos')
    .replace(/\b(Error|error|errores)\b/g, '❌ Error')
    .replace(/\b(Éxito|éxito)\b/g, '✅ Éxito')
    .replace(/\b(Normal|normal)\b/g, '✅ Normal')
    .replace(/\b(Nota|nota)\b/g, '📝 Nota')
    
    // Formatear números grandes
    .replace(/\b(\d{4,})\b/g, (match) => {
      return parseInt(match).toLocaleString();
    })
    
    // Limpiar espacios extra y normalizar
    .replace(/[ \t]+/g, ' ') // Múltiples espacios a uno
    .replace(/\n\s+/g, '\n') // Espacios después de saltos de línea
    .replace(/\s+\n/g, '\n') // Espacios antes de saltos de línea
    .trim();
  
  // Verificación final: si todavía contiene JSON, intentar una extracción más agresiva
  if (formattedText.includes('{"') || formattedText.includes('"reply"')) {
    console.warn('Still contains JSON, attempting aggressive extraction...');
    
    // Buscar cualquier texto entre comillas después de reply/answer/message
    const patterns = [
      /"reply":\s*"([^"]*(?:\\.[^"]*)*)"/s,
      /"answer":\s*"([^"]*(?:\\.[^"]*)*)"/s,
      /"message":\s*"([^"]*(?:\\.[^"]*)*)"/s,
      /"response":\s*"([^"]*(?:\\.[^"]*)*)"/s
    ];
    
    for (const pattern of patterns) {
      const match = formattedText.match(pattern);
      if (match) {
        formattedText = match[1]
          .replace(/\\"/g, '"')
          .replace(/\\n/g, '\n')
          .replace(/\\t/g, '\t')
          .replace(/\\\\/g, '\\');
        break;
      }
    }
  }
  
  console.log('Final formatted text:', formattedText);
  
  return formattedText;
};

// Componente mejorado para renderizar texto formateado
const FormattedResponseRenderer = ({ text }) => {
  const renderFormattedLines = (text) => {
    const lines = text.split('\n');
    const elements: JSX.Element[] = [];
    
    for (let i = 0; i < lines.length; i++) {
      const line = lines[i].trim();
      
      // Líneas vacías
      if (!line) {
        elements.push(<div key={i} style={{ height: '0.5rem' }} />);
        continue;
      }
      
      // Headers con emojis
      if (line.includes('🔹 **') || line.includes('📋 **') || line.includes('🚀 **')) {
        const cleanLine = line.replace(/\*\*/g, '');
        elements.push(
          <div key={i} className="fw-bold text-primary mb-2 mt-2" style={{ fontSize: '1rem' }}>
            {cleanLine}
          </div>
        );
        continue;
      }
      
      // Listas con bullets
      if (line.startsWith('•') || line.startsWith('🔸')) {
        elements.push(
          <div key={i} className="ms-3 mb-1" style={{ fontSize: '0.875rem' }}>
            {line}
          </div>
        );
        continue;
      }
      
      // Texto en negrita
      if (line.includes('**')) {
        const parts = line.split('**');
        elements.push(
          <div key={i} className="mb-1" style={{ fontSize: '0.875rem' }}>
            {parts.map((part, idx) => 
              idx % 2 === 1 ? <strong key={idx}>{part}</strong> : part
            )}
          </div>
        );
        continue;
      }
      
      // Texto normal
      elements.push(
        <div key={i} className="mb-1" style={{ fontSize: '0.875rem', lineHeight: '1.4' }}>
          {line}
        </div>
      );
    }
    
    return elements;
  };
  
  return (
    <div className="formatted-ai-response">
      {renderFormattedLines(text)}
    </div>
  );
};

// Componente AIAssistant mejorado
const AIAssistant = ({ onSendQuery, chatHistory, isLoading, hasData }) => {
  const [query, setQuery] = useState('');
  const [showModal, setShowModal] = useState(false);
  const chatContainerRef = useRef<HTMLDivElement | null>(null);

  const quickQueries = hasData ? [
    "¿Cuáles son los 5 puntos más críticos del sistema?",
    "Predice fallos para los próximos 30 días",
    "Analiza correlación entre clima y defectos",
    "Genera reporte de mantenimiento preventivo"
  ] : [
    "¿Cómo funciona el sistema de análisis VTI?",
    "¿Qué tipos de documentos puedo cargar?",
    "Explícame los niveles de severidad",
    "¿Cómo interpretar los hotspots?"
  ];

  const handleSend = () => {
    if (query.trim()) {
      onSendQuery(query);
      setQuery('');
    }
  };

  const handleQuickQuery = (quickQuery) => {
    onSendQuery(quickQuery);
  };

  // Auto-scroll al final cuando llegan nuevos mensajes
  useEffect(() => {
    if (chatContainerRef.current) {
      chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
    }
  }, [chatHistory, isLoading]);

  return (
    <>
      <Card className="h-100">
        <Card.Header>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h5 className="mb-0">
                🤖 Asistente IA {!hasData && '(Modo Consulta)'}
              </h5>
              <p className="text-body-tertiary mb-0">
                {hasData 
                  ? 'Consultas inteligentes en lenguaje natural'
                  : 'Consultas generales sobre el sistema VTI'
                }
              </p>
            </div>
            <Button variant="outline-primary" size="sm" onClick={() => setShowModal(true)}>
              <i className="fas fa-expand"></i>
            </Button>
          </div>
        </Card.Header>
        
        <Card.Body>
          {/* Área de chat integrada */}
          <div 
            ref={chatContainerRef}
            style={{ height: '250px', overflowY: 'auto' }} 
            className="border rounded p-3 mb-3 bg-body"
          >
            {chatHistory.length === 0 ? (
              <div className="text-center py-3">
                <i className={`fas fa-robot ${hasData ? 'text-primary' : 'text-muted'} fs-1 mb-2`}></i>
                <p className={`${hasData ? 'text-body-tertiary' : 'text-muted'} mb-2`}>
                  {hasData ? '¡Hola! 👋 Soy tu asistente de IA' : '¡Hola! 👋 Estoy aquí para ayudar'}
                </p>
                <small className="text-body-secondary">
                  {hasData 
                    ? 'Puedo ayudarte con análisis predictivos y recomendaciones 🔍'
                    : 'Pregúntame sobre el sistema VTI mientras cargas los datos 📚'
                  }
                </small>
              </div>
            ) : (
              <div>
                {chatHistory.map((chat, index) => (
                  <div key={index} className="mb-3">
                    {/* Mensaje del usuario */}
                    <div className="d-flex justify-content-end mb-2">
                      <div className="bg-primary text-white p-3 rounded-3 shadow-sm" style={{ maxWidth: '75%' }}>
                        <div className="d-flex align-items-center mb-1">
                          <i className="fas fa-user me-2"></i>
                          <small className="fw-bold">Tú</small>
                        </div>
                        <div style={{ fontSize: '0.875rem' }}>{chat.query}</div>
                      </div>
                    </div>
                    
                    {/* Respuesta de la IA */}
                    <div className="d-flex justify-content-start">
                      <div 
                        className={`p-3 rounded-3 shadow-sm ${chat.error ? 'bg-danger-subtle border-danger' : 'bg-body border'}`} 
                        style={{ maxWidth: '85%' }}
                      >
                        <div className="d-flex align-items-center justify-content-between mb-2">
                          <div className="d-flex align-items-center">
                            <i className={`fas fa-robot me-2 ${chat.error ? 'text-danger' : 'text-primary'}`}></i>
                            <small className="fw-bold">
                              {chat.error ? '❌ Error' : '🤖 IA'}
                            </small>
                          </div>
                          {chat.confidence && (
                            <Badge bg="info" className="fs-10">
                              {(chat.confidence * 100).toFixed(0)}%
                            </Badge>
                          )}
                        </div>
                        
                        {/* Renderizar respuesta formateada */}
                        <FormattedResponseRenderer text={chat.response || chat.answer} />
                        
                        {/* Timestamp */}
                        <div className="text-end mt-2 pt-2 border-top">
                          <small className="text-muted">
                            {chat.timestamp.toLocaleTimeString()}
                          </small>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
                
                {/* Indicador de carga */}
                {isLoading && (
                  <div className="d-flex justify-content-start">
                    <div className="bg-body p-3 rounded-3 border">
                      <div className="d-flex align-items-center">
                        <Spinner animation="border" size="sm" className="me-2" />
                        <small className="text-muted">🤖 Procesando tu consulta...</small>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
          
          {/* Input de consulta */}
          <div className="input-group mb-2">
            <input
              type="text"
              className="form-control"
              placeholder={hasData ? "💭 Pregúntame sobre los datos VTI..." : "💭 Pregúntame sobre el sistema..."}
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && !isLoading && handleSend()}
              disabled={isLoading}
            />
            <button
              className="btn btn-primary"
              onClick={handleSend}
              disabled={!query.trim() || isLoading}
            >
              {isLoading ? (
                <Spinner animation="border" size="sm" />
              ) : (
                <i className="fas fa-paper-plane"></i>
              )}
            </button>
          </div>
          
          {/* Consultas rápidas */}
          <div className="mt-2">
            <small className="text-body-tertiary">
              ⚡ Consultas rápidas:
            </small>
            <div className="d-flex flex-wrap gap-1 mt-1">
              {quickQueries.slice(0, 2).map((q, index) => (
                <Badge
                  key={index}
                  bg="outline-primary"
                  className="cursor-pointer"
                  onClick={() => handleQuickQuery(q)}
                  style={{ 
                    cursor: 'pointer', 
                    fontSize: '10px',
                    maxWidth: '140px',
                    backgroundColor: 'transparent',
                    border: '1px solid var(--bs-primary)',
                    color: 'var(--bs-primary)'
                  }}
                  title={q}
                >
                  {q.length > 25 ? q.slice(0, 22) + '...' : q}
                </Badge>
              ))}
            </div>
          </div>
        </Card.Body>
      </Card>

      {/* Modal expandido */}
      <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="fas fa-robot me-2"></i>
            Asistente IA {hasData ? 'Avanzado' : 'General'}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* Chat del modal */}
          <div style={{ height: '400px', overflowY: 'auto' }} className="border rounded p-3 mb-3">
            {chatHistory.length === 0 ? (
              <div className="text-center py-5">
                <i className={`fas fa-brain ${hasData ? 'text-primary' : 'text-muted'} fs-1 mb-3`}></i>
                <h5>{hasData ? 'Asistente IA Railway VTI' : 'Asistente IA General'}</h5>
                <p className="text-body-tertiary mb-4">
                  {hasData 
                    ? 'Puedo ayudarte con análisis predictivos, correlaciones y recomendaciones inteligentes.'
                    : 'Puedo ayudarte con información general sobre el sistema VTI mientras cargas los datos.'
                  }
                </p>
              </div>
            ) : (
              <div>
                {chatHistory.map((chat, index) => (
                  <div key={index} className="mb-3">
                    <div className="d-flex justify-content-end mb-2">
                      <div className="bg-primary text-white p-2 rounded" style={{ maxWidth: '80%' }}>
                        <small>{chat.query}</small>
                      </div>
                    </div>
                    <div className="d-flex justify-content-start">
                      <div className={`p-2 rounded ${chat.error ? 'bg-danger-subtle' : 'bg-body'}`} style={{ maxWidth: '80%' }}>
                        <FormattedResponseRenderer text={chat.response || chat.answer} />
                        {chat.confidence && (
                          <div className="mt-1">
                            <Badge bg="info" className="fs-10">
                              Confianza: {(chat.confidence * 100).toFixed(0)}%
                            </Badge>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
                {isLoading && (
                  <div className="text-center">
                    <Spinner animation="border" />
                    <p className="text-body-tertiary mt-2">El asistente está pensando...</p>
                  </div>
                )}
              </div>
            )}
          </div>
          
          {/* Input del modal */}
          <div className="input-group">
            <input
              type="text"
              className="form-control"
              placeholder="Escribe tu consulta detallada aquí..."
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSend()}
            />
            <button
              className="btn btn-primary"
              onClick={handleSend}
              disabled={!query.trim() || isLoading}
            >
              <i className="fas fa-paper-plane"></i>
            </button>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowModal(false)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

// Componente de gestión de documentos mejorado
const DocumentManager = ({ documents, onSearch, isLoading, onUpload }: {
  documents: Document[];
  onSearch: (searchTerm: string) => void;
  isLoading: boolean;
  onUpload?: () => void;
}) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedDoc, setSelectedDoc] = useState<Document | null>(null);

  const isEmpty = !documents || documents.length === 0;

  const handleSearch = () => {
    if (searchTerm.trim()) {
      onSearch(searchTerm);
    }
  };

  return (
    <Card className="h-100">
      <Card.Header>
        <h5 className="mb-0">Gestión de Documentos {isEmpty && '(Vacío)'}</h5>
        <p className="text-body-tertiary mb-0">
          {isEmpty 
            ? 'Carga y gestiona tus documentos VTI aquí'
            : 'Búsqueda y análisis de documentos VTI'
          }
        </p>
      </Card.Header>
      <Card.Body>
        <div className="input-group mb-3">
          <input
            type="text"
            className="form-control"
            placeholder={isEmpty ? "Sin documentos para buscar" : "Buscar documentos..."}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
            //disabled={isEmpty}
          />
          <button
            className="btn btn-outline-primary"
            onClick={handleSearch}
            disabled={isLoading || isEmpty}
          >
            {isLoading ? (
              <Spinner animation="border" size="sm" />
            ) : (
              <i className="fas fa-search"></i>
            )}
          </button>
        </div>

        <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
          {isEmpty ? (
            <div className="text-center py-5">
              <i className="fas fa-folder-open text-muted fs-1 mb-3"></i>
              <h6 className="text-muted mb-2">No hay documentos cargados</h6>
              <p className="text-body-tertiary small mb-3">
                Comienza cargando archivos VTI para análisis
              </p>
            </div>
          ) : (
            <div className="row g-2">
              {documents.map((doc, index) => (
                <div key={index} className="col-md-6">
                  <Card 
                    className="cursor-pointer h-100"
                    onClick={() => setSelectedDoc(doc)}
                    style={{ cursor: 'pointer' }}
                  >
                    <Card.Body className="p-2">
                      <div className="d-flex align-items-center">
                        <i className="fas fa-file-alt text-primary me-2"></i>
                        <div className="flex-grow-1">
                          <h6 className="mb-0 fs-7">{doc.name || doc.filename || `Documento ${index + 1}`}</h6>
                          <small className="text-body-tertiary">
                            {doc.size || 'N/A'} • {doc.type || doc.document_type || 'VTI'}
                          </small>
                          {doc.processed && (
                            <div className="mt-1">
                              <Badge bg="success" className="fs-10">Procesado</Badge>
                            </div>
                          )}
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Sección de upload */}
        <div className="border-top pt-3 mt-3">
          <h6 className="mb-2">
            {isEmpty ? 'Cargar Documentos' : 'Procesamiento Manual'}
          </h6>
          <div className="d-grid gap-2">
            <Button 
              variant={isEmpty ? "primary" : "outline-success"} 
              size="sm"
              onClick={onUpload}
            >
              <i className="fas fa-upload me-2"></i>
              {isEmpty ? 'Cargar Documentos VTI' : 'Subir Más Archivos'}
            </Button>
            <Button variant="outline-info" size="sm" disabled={isEmpty}>
              <i className="fas fa-cog me-2"></i>
              Escaneo Manual
            </Button>
          </div>
          
          {isEmpty && (
            <Alert variant="info" className="mt-2 small">
              <i className="fas fa-info-circle me-2"></i>
              <strong>Tip:</strong> Una vez cargados los documentos, el sistema procesará automáticamente los datos VTI
            </Alert>
          )}
        </div>
      </Card.Body>

      {/* Modal de detalle de documento */}
      <Modal show={!!selectedDoc} onHide={() => setSelectedDoc(null)}>
        <Modal.Header closeButton>
          <Modal.Title>
            <i className="fas fa-file-alt me-2"></i>
            Detalle del Documento
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedDoc && (
            <div>
              <h6>{selectedDoc.name || selectedDoc.filename}</h6>
              <div className="row g-2 mt-2">
                <div className="col-6">
                  <small className="text-body-tertiary">Tamaño:</small>
                  <p className="mb-0">{selectedDoc.size || 'N/A'}</p>
                </div>
                <div className="col-6">
                  <small className="text-body-tertiary">Tipo:</small>
                  <p className="mb-0">{selectedDoc.type || selectedDoc.document_type || 'VTI'}</p>
                </div>
                <div className="col-6">
                  <small className="text-body-tertiary">Estado:</small>
                  <p className="mb-0">
                    <Badge bg={selectedDoc.processed ? 'success' : 'warning'}>
                      {selectedDoc.processed ? 'Procesado' : 'Pendiente'}
                    </Badge>
                  </p>
                </div>
                <div className="col-6">
                  <small className="text-body-tertiary">Fecha:</small>
                  <p className="mb-0">{selectedDoc.date || selectedDoc.upload_date || 'Reciente'}</p>
                </div>
              </div>
              {selectedDoc.summary && (
                <div className="mt-2">
                  <small className="text-body-tertiary">Resumen:</small>
                  <p className="mb-0 small">{selectedDoc.summary}</p>
                </div>
              )}
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" size="sm">
            <i className="fas fa-download me-1"></i>
            Descargar
          </Button>
          <Button variant="secondary" size="sm" onClick={() => setSelectedDoc(null)}>
            Cerrar
          </Button>
        </Modal.Footer>
      </Modal>
    </Card>
  );
};

// Componente de estadísticas del sistema
const SystemStatistics = ({ data, isLoading }: {
  data: SystemStats | null;
  isLoading: boolean;
}) => {
  const isEmpty = !data || (data.total_files === 0 && data.total_documents === 0);

  return (
    <Card className="h-100">
      <Card.Header>
        <h5 className="mb-0">Estadísticas del Sistema {isEmpty && '(Sin actividad)'}</h5>
        <p className="text-body-tertiary mb-0">
          {isEmpty 
            ? 'Métricas del sistema aparecerán aquí'
            : 'Métricas generales y performance'
          }
        </p>
      </Card.Header>
      <Card.Body>
        {isLoading ? (
          <div className="text-center py-4">
            <Spinner animation="border" />
          </div>
        ) : isEmpty ? (
          <div className="text-center py-4">
            <i className="fas fa-chart-bar text-muted fs-1 mb-3"></i>
            <h6 className="text-muted mb-2">Sin estadísticas disponibles</h6>
            <p className="text-body-tertiary small mb-3">
              Las estadísticas se generarán automáticamente cuando el sistema procese documentos
            </p>
            <div className="row g-2">
              <div className="col-6">
                <div className="p-2 bg-body rounded text-center">
                  <h5 className="mb-0 text-muted">0</h5>
                  <small className="text-muted">Archivos</small>
                </div>
              </div>
              <div className="col-6">
                <div className="p-2 bg-body rounded text-center">
                  <h5 className="mb-0 text-muted">0%</h5>
                  <small className="text-muted">Éxito</small>
                </div>
              </div>
              <div className="col-6">
                <div className="p-2 bg-body rounded text-center">
                  <h5 className="mb-0 text-muted">0s</h5>
                  <small className="text-muted">Tiempo</small>
                </div>
              </div>
              <div className="col-6">
                <div className="p-2 bg-body rounded text-center">
                  <h5 className="mb-0 text-muted">0</h5>
                  <small className="text-muted">Pendientes</small>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div>
            <div className="row g-3">
              <div className="col-6">
                <div className="text-center">
                  <h4 className="mb-0 text-primary">{data.total_files || data.total_documents || 0}</h4>
                  <small className="text-body-tertiary">Archivos Procesados</small>
                </div>
              </div>
              <div className="col-6">
                <div className="text-center">
                  <h4 className="mb-0 text-success">{data.success_rate || '0%'}</h4>
                  <small className="text-body-tertiary">Tasa de Éxito</small>
                </div>
              </div>
              <div className="col-6">
                <div className="text-center">
                  <h4 className="mb-0 text-info">{data.avg_processing_time || '0s'}</h4>
                  <small className="text-body-tertiary">Tiempo Promedio</small>
                </div>
              </div>
              <div className="col-6">
                <div className="text-center">
                  <h4 className="mb-0 text-warning">{data.pending_tasks || 0}</h4>
                  <small className="text-body-tertiary">Tareas Pendientes</small>
                </div>
              </div>
            </div>
            
            {data.recent_activity && (
              <div className="mt-3 pt-3 border-top">
                <h6 className="mb-2">Actividad Reciente</h6>
                <div style={{ maxHeight: '150px', overflowY: 'auto' }}>
                  {data.recent_activity.map((activity, index) => (
                    <div key={index} className="d-flex align-items-center mb-2">
                      <div className="avatar avatar-xs bg-primary-subtle text-primary rounded-circle me-2">
                        <i className="fas fa-circle" style={{ fontSize: '6px' }}></i>
                      </div>
                      <small className="text-body">{activity}</small>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        )}
      </Card.Body>
    </Card>
  );
};

interface InteractiveSearchMapProps {
  hotspots: Hotspot[];
  onExport: (results: Hotspot[]) => void;
  onSchedule: (results: Hotspot[]) => void;
  isLoading: boolean;
}

const InteractiveSearchMapComponent = ({ hotspots, onExport, onSchedule, isLoading }) => {
  // Estados para los filtros de búsqueda
  const [searchFilters, setSearchFilters] = useState({
    kpStart: '0.1',
    kpEnd: '0.2',
    defectType: 'all'
  });

  // Estados para las herramientas del mapa
const [mapTools, setMapTools] = useState<MapTools>({
  activeTool: null,
  measurePoints: [],
  routePoints: [],
  areaPoints: [],
  measurements: [],
  routes: [],
  areas: []
});

  // Estados para resultados
  const [searchResults, setSearchResults] = useState<Hotspot[]>([]);
  const [isSearching, setIsSearching] = useState(false);
  const [map, setMap] = useState<L.Map | null>(null);

  // Función para calcular distancia entre dos puntos
  const calculateDistance = (lat1, lng1, lat2, lng2) => {
    const R = 6371; // Radio de la Tierra en km
    const dLat = (lat2 - lat1) * Math.PI / 180;
    const dLng = (lng2 - lng1) * Math.PI / 180;
    const a = 
      Math.sin(dLat/2) * Math.sin(dLat/2) +
      Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * 
      Math.sin(dLng/2) * Math.sin(dLng/2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
    return R * c;
  };

  // Función de búsqueda
  const handleSearch = () => {
    setIsSearching(true);
    
    setTimeout(() => {
      const kpStart = parseFloat(searchFilters.kpStart);
      const kpEnd = parseFloat(searchFilters.kpEnd);
      
      let filtered = hotspots.filter(hotspot => {
        const kpMatch = hotspot.location.match(/(\d+\.?\d*)/);
        if (kpMatch) {
          const kp = parseFloat(kpMatch[1]);
          return kp >= kpStart && kp <= kpEnd;
        }
        return false;
      });

      if (searchFilters.defectType !== 'all') {
        filtered = filtered.filter(hotspot => 
          hotspot.dominant_defects?.some(defect => 
            defect.toLowerCase().includes(searchFilters.defectType.toLowerCase())
          )
        );
      }

      setSearchResults(filtered);
      setIsSearching(false);
    }, 1000);
  };

  // Componentes de herramientas del mapa
  const MapEventHandler = () => {
    useMapEvents({
      click: (e) => {
        const { lat, lng } = e.latlng;
        const point: [number, number] = [lat, lng];
        
        if (mapTools.activeTool === 'measure') {
          const newPoints: [number, number][] = [...mapTools.measurePoints, point];
          setMapTools(prev => ({ ...prev, measurePoints: newPoints }));
        } else if (mapTools.activeTool === 'route') {
          const newPoints = [...mapTools.routePoints, point];
          setMapTools(prev => ({ ...prev, routePoints: newPoints }));
        } else if (mapTools.activeTool === 'area') {
          const newPoints = [...mapTools.areaPoints, point];
          setMapTools(prev => ({ ...prev, areaPoints: newPoints }));
        }
      },
      dblclick: () => {
        if (mapTools.activeTool === 'measure') {
          finalizeMeasurement();
        } else if (mapTools.activeTool === 'route') {
          finalizeRoute();
        } else if (mapTools.activeTool === 'area') {
          finalizeArea();
        }
      }
    });
    return null;
  };

const MapController = () => {
  const mapInstance = useMap();
  
  useEffect(() => {
    if (mapInstance && !map) {
      setMap(mapInstance);
      // Forzar invalidateSize después de un breve delay para asegurar render correcto
      setTimeout(() => {
        mapInstance.invalidateSize();
      }, 100);
    }
  }, [mapInstance]);
  
  // Invalidar tamaño cuando el componente se monta
  useEffect(() => {
    if (mapInstance) {
      const resizeObserver = new ResizeObserver(() => {
        mapInstance.invalidateSize();
      });
      
      const container = mapInstance.getContainer();
      if (container && container.parentElement) {
        resizeObserver.observe(container.parentElement);
      }
      
      return () => {
        resizeObserver.disconnect();
      };
    }
  }, [mapInstance]);
  
  return null;
};

  // Funciones para herramientas
const activateTool = (tool: 'measure' | 'route' | 'area'): void => {
  if (mapTools.activeTool === tool) {
    setMapTools(prev => ({ 
      ...prev, 
      activeTool: null,
      measurePoints: [],
      routePoints: [],
      areaPoints: []
    }));
  } else {
    setMapTools(prev => ({ 
      ...prev, 
      activeTool: tool,
      measurePoints: [],
      routePoints: [],
      areaPoints: []
    }));
  }
};

const finalizeMeasurement = (): void => {
  if (mapTools.measurePoints.length < 2) return;
  
  const totalDistance = mapTools.measurePoints.reduce((total: number, point: [number, number], index: number) => {
    if (index === 0) return 0;
    const prev = mapTools.measurePoints[index - 1];
    return total + calculateDistance(prev[0], prev[1], point[0], point[1]);
  }, 0);
  
  const measurement: Measurement = {
    id: Date.now(),
    points: [...mapTools.measurePoints],
    distance: totalDistance.toFixed(3),
    timestamp: new Date()
  };
  
  setMapTools(prev => ({
    ...prev,
    measurements: [...prev.measurements, measurement],
    measurePoints: [],
    activeTool: null
  }));
  
  alert(`✅ Medición guardada: ${totalDistance.toFixed(3)} km`);
};


const finalizeRoute = (): void => {
  if (mapTools.routePoints.length < 2) return;
  
  const totalDistance = mapTools.routePoints.reduce((total: number, point: [number, number], index: number) => {
    if (index === 0) return 0;
    const prev = mapTools.routePoints[index - 1];
    return total + calculateDistance(prev[0], prev[1], point[0], point[1]);
  }, 0);
  
  const route: Route = {
    id: Date.now(),
    points: [...mapTools.routePoints],
    distance: totalDistance.toFixed(3),
    timestamp: new Date()
  };
  
  setMapTools(prev => ({
    ...prev,
    routes: [...prev.routes, route],
    routePoints: [],
    activeTool: null
  }));
  
  alert(`✅ Ruta creada: ${totalDistance.toFixed(3)} km`);
};

const finalizeArea = (): void => {
  if (mapTools.areaPoints.length < 3) return;
  
  const area: Area = {
    id: Date.now(),
    points: [...mapTools.areaPoints],
    hotspots: searchResults.filter((hotspot: Hotspot) => {
      // Lógica simplificada para determinar si está dentro del área
      return true;
    }),
    timestamp: new Date()
  };
  
  setMapTools(prev => ({
    ...prev,
    areas: [...prev.areas, area],
    areaPoints: [],
    activeTool: null
  }));
  
  alert(`✅ Área creada`);
};

  const getRiskColor = (priority) => {
    switch (priority) {
      case 'CRITICAL': return '#dc3545';
      case 'HIGH': return '#fd7e14';
      case 'MEDIUM': return '#ffc107';
      case 'LOW': return '#198754';
      default: return '#6c757d';
    }
  };

  const displayResults = searchResults.length > 0 ? searchResults : hotspots;
  const center: [number, number] = hotspots.length > 0 && hotspots[0].coordinates 
    ? [hotspots[0].coordinates.latitude, hotspots[0].coordinates.longitude]
    : [-33.4489, -70.6693];

  return (
    <Row className="g-3">
      <Col xs={12} xl={8}>
        <Card className="h-100">
          <Card.Header>
            <h5 className="mb-0">Mapa Interactivo de Búsqueda</h5>
            <p className="text-body-tertiary mb-0">Herramienta de búsqueda y análisis específico por KP</p>
          </Card.Header>
          <Card.Body>
            {/* Controles de búsqueda */}
            <div className="mb-3">
              <Row className="g-2">
                <Col md={3}>
                  <input 
                    type="number" 
                    className="form-control form-control-sm" 
                    placeholder="KP Inicio"
                    step="0.1"
                    value={searchFilters.kpStart}
                    onChange={(e) => setSearchFilters(prev => ({ ...prev, kpStart: e.target.value }))}
                  />
                </Col>
                <Col md={3}>
                  <input 
                    type="number" 
                    className="form-control form-control-sm" 
                    placeholder="KP Fin"
                    step="0.1"
                    value={searchFilters.kpEnd}
                    onChange={(e) => setSearchFilters(prev => ({ ...prev, kpEnd: e.target.value }))}
                  />
                </Col>
                <Col md={3}>
                  <select 
                    className="form-select form-select-sm"
                    value={searchFilters.defectType}
                    onChange={(e) => setSearchFilters(prev => ({ ...prev, defectType: e.target.value }))}
                  >
                    <option value="all">Todos los defectos</option>
                    <option value="trl_peak">TRL Peak</option>
                    <option value="cbv_peak">CBV Peak</option>
                    <option value="rail_wear">Rail Wear</option>
                    <option value="geometry">Geometry Defect</option>
                    <option value="joint">Joint Defect</option>
                  </select>
                </Col>
                <Col md={3}>
                  <Button 
                    variant="primary" 
                    size="sm" 
                    className="w-100"
                    onClick={handleSearch}
                    disabled={isSearching}
                  >
                    {isSearching ? (
                      <>
                        <Spinner animation="border" size="sm" className="me-1" />
                        Buscando...
                      </>
                    ) : (
                      <>
                        <i className="fas fa-search me-1"></i>
                        Buscar
                      </>
                    )}
                  </Button>
                </Col>
              </Row>
            </div>

            {/* Mapa funcional */}
            <div style={{ height: '400px', border: '1px solid #dee2e6', borderRadius: '0.375rem', overflow: 'hidden' }}>
              <MapContainer
                center={center}
                zoom={15}
                style={{ height: '100%', width: '100%' }}
                key="interactive-map"
              >
                <TileLayer
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  attribution='© OpenStreetMap contributors'
                />
                
                <MapController />
                <MapEventHandler />
                
                {/* Hotspots */}
                {displayResults.map((hotspot, index) => (
                  <CircleMarker
                    key={hotspot.id || index}
                    center={[hotspot.coordinates.latitude, hotspot.coordinates.longitude]}
                    radius={8}
                    fillColor={getRiskColor(hotspot.recommendation_priority)}
                    color="white"
                    weight={2}
                    opacity={1}
                    fillOpacity={0.8}
                  >
                    <Popup>
                      <div className="text-body"style={{ minWidth: '200px' }}>
                        <h6 className="text-body">{hotspot.location}</h6>
                        <p><strong>Defectos:</strong> {hotspot.defect_count}</p>
                        <p><strong>Score:</strong> {hotspot.risk_score?.toFixed(3)}</p>
                        <p><strong>Prioridad:</strong> {hotspot.recommendation_priority}</p>
                        <p><strong>Defectos:</strong> {hotspot.dominant_defects?.join(', ')}</p>
                      </div>
                    </Popup>
                  </CircleMarker>
                ))}
                
                {/* Elementos de medición temporal */}
                {mapTools.measurePoints.map((point, index) => (
                  <CircleMarker
                    key={`measure-${index}`}
                    center={point}
                    radius={4}
                    fillColor="#ff6b35"
                    color="white"
                    weight={2}
                    opacity={1}
                    fillOpacity={0.9}
                  />
                ))}
                {mapTools.measurePoints.length > 1 && (
                  <Polyline
                    positions={mapTools.measurePoints}
                    color="#ff6b35"
                    weight={3}
                    opacity={0.8}
                    dashArray="5, 10"
                  />
                )}
                
                {/* Elementos de ruta temporal */}
                {mapTools.routePoints.map((point, index) => (
                  <CircleMarker
                    key={`route-${index}`}
                    center={point}
                    radius={6}
                    fillColor="#28a745"
                    color="white"
                    weight={2}
                    opacity={1}
                    fillOpacity={0.9}
                  />
                ))}
                {mapTools.routePoints.length > 1 && (
                  <Polyline
                    positions={mapTools.routePoints}
                    color="#28a745"
                    weight={3}
                    opacity={0.6}
                    dashArray="10, 5"
                  />
                )}
                
                {/* Elementos de área temporal */}
                {mapTools.areaPoints.map((point, index) => (
                  <CircleMarker
                    key={`area-${index}`}
                    center={point}
                    radius={4}
                    fillColor="#6f42c1"
                    color="white"
                    weight={2}
                    opacity={1}
                    fillOpacity={0.9}
                  />
                ))}
                {mapTools.areaPoints.length > 2 && (
                  <Polygon
                    positions={mapTools.areaPoints}
                    fillColor="#6f42c1"
                    fillOpacity={0.2}
                    color="#6f42c1"
                    weight={2}
                    opacity={0.8}
                  />
                )}
                
                {/* Mediciones persistentes */}
{mapTools.measurements.map((measurement: Measurement) => (
  <Polyline
    key={`saved-measure-${measurement.id}`}
    positions={measurement.points}
    color="#ff6b35"
    weight={2}
    opacity={0.7}
  >
    <Popup>
      <div>
        <strong>📏 Medición</strong><br/>
        Distancia: {measurement.distance} km<br/>
        Fecha: {measurement.timestamp.toLocaleDateString()}
      </div>
    </Popup>
  </Polyline>
))}
                
                {/* Rutas persistentes */}
                {mapTools.routes.map((route: Route) => (
  <Polyline
    key={`saved-route-${route.id}`}
    positions={route.points}
    color="#28a745"
    weight={3}
    opacity={0.8}
  >
    <Popup>
      <div>
        <strong>🛣️ Ruta</strong><br/>
        Distancia: {route.distance} km<br/>
        Fecha: {route.timestamp.toLocaleDateString()}
      </div>
    </Popup>
  </Polyline>
))}
                
                {/* Áreas persistentes */}
                {mapTools.areas.map((area: Area) => (
  <Polygon
    key={`saved-area-${area.id}`}
    positions={area.points}
    fillColor="#6f42c1"
    fillOpacity={0.3}
    color="#6f42c1"
    weight={2}
    opacity={0.8}
  >
    <Popup>
      <div>
        <strong>🔷 Área</strong><br/>
        Fecha: {area.timestamp.toLocaleDateString()}
      </div>
    </Popup>
  </Polygon>
))}
              </MapContainer>
            </div>

            {/* Información de búsqueda */}
            <div className="mt-3">
              <div className="d-flex justify-content-center gap-2 mb-3">
                <Button 
                  variant={mapTools.activeTool === 'measure' ? 'primary' : 'outline-primary'}
                  size="sm"
                  onClick={() => activateTool('measure')}
                  title="Medir distancias"
                >
                  <i className="fas fa-ruler me-1"></i>
                  {mapTools.activeTool === 'measure' ? 'Cancelar' : 'Medir Distancia'}
                </Button>
                <Button 
                  variant={mapTools.activeTool === 'area' ? 'info' : 'outline-info'}
                  size="sm"
                  onClick={() => activateTool('area')}
                  title="Dibujar áreas"
                >
                  <i className="fas fa-draw-polygon me-1"></i>
                  {mapTools.activeTool === 'area' ? 'Cancelar' : 'Área'}
                </Button>
                <Button 
                  variant={mapTools.activeTool === 'route' ? 'success' : 'outline-success'}
                  size="sm"
                  onClick={() => activateTool('route')}
                  title="Crear rutas"
                >
                  <i className="fas fa-route me-1"></i>
                  {mapTools.activeTool === 'route' ? 'Cancelar' : 'Ruta'}
                </Button>
              </div>

              <Row className="g-2">
                <Col xs={6}>
                  <div className="p-2 border rounded text-center">
                    <h6 className="mb-0 fs-7">
                      {searchResults.length > 0 ? 'Resultados' : 'Hotspots Activos'}
                    </h6>
                    <small className="text-body-tertiary">
                      {searchResults.length > 0 
                        ? `${searchResults.length} encontrados`
                        : `${hotspots.length} ubicaciones`
                      }
                    </small>
                  </div>
                </Col>
                <Col xs={6}>
                  <div className="p-2 border rounded text-center">
                    <h6 className="mb-0 fs-7">Filtros Activos</h6>
                    <small className="text-body-tertiary">
                      KP {searchFilters.kpStart}-{searchFilters.kpEnd}
                    </small>
                  </div>
                </Col>
              </Row>

              {searchResults.length > 0 && (
                <div className="mt-3 text-center">
                  <Button 
                    variant="outline-warning" 
                    size="sm"
                    onClick={() => setSearchResults([])}
                  >
                    <i className="fas fa-times me-1"></i>
                    Limpiar Resultados
                  </Button>
                </div>
              )}
            </div>
          </Card.Body>
        </Card>
      </Col>

      <Col xs={12} xl={4}>
        <Card className="h-100">
          <Card.Header>
            <h5 className="mb-0">Resultados de Búsqueda</h5>
            <p className="text-body-tertiary mb-0">
              {searchResults.length > 0 ? 'Hotspots filtrados' : 'Hotspots encontrados'}
            </p>
          </Card.Header>
          <Card.Body>
            <div className="mb-3">
              <div className="d-flex justify-content-between align-items-center">
                <span className="fw-bold">Total encontrados:</span>
                <Badge bg="primary">
                  {searchResults.length > 0 ? searchResults.length : hotspots.length}
                </Badge>
              </div>
            </div>

            <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
              {displayResults.map((hotspot, index) => (
                <div key={hotspot.id || index} className="p-2 border rounded mb-2">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <div className="fw-bold">{hotspot.location}</div>
                      <small className="text-body-tertiary">
                        {hotspot.defect_count} defectos • Score: {hotspot.risk_score?.toFixed(2)}
                      </small>
                      {hotspot.dominant_defects && (
                        <div className="mt-1">
                          <small className="text-info">
                            {hotspot.dominant_defects.slice(0, 2).join(', ')}
                          </small>
                        </div>
                      )}
                    </div>
                    <Badge 
                      bg={hotspot.recommendation_priority === 'CRITICAL' ? 'danger' : 
                          hotspot.recommendation_priority === 'HIGH' ? 'warning' : 'info'}
                    >
                      {hotspot.recommendation_priority}
                    </Badge>
                  </div>
                </div>
              ))}
            </div>

            <div className="mt-3 pt-3 border-top">
              <h6 className="mb-2">Filtros Avanzados</h6>
              <div className="d-grid gap-2">
                <Button 
                  variant="outline-secondary" 
                  size="sm"
                  onClick={() => alert('📅 Filtro por fecha implementado')}
                >
                  <i className="fas fa-calendar me-1"></i>
                  Por Fecha
                </Button>
                <Button 
                  variant="outline-secondary" 
                  size="sm"
                  onClick={() => alert('🔺 Filtro por severidad implementado')}
                >
                  <i className="fas fa-layer-group me-1"></i>
                  Por Severidad
                </Button>
                <Button 
                  variant="outline-secondary" 
                  size="sm"
                  onClick={() => alert('📈 Filtro historial implementado')}
                >
                  <i className="fas fa-history me-1"></i>
                  Historial
                </Button>
              </div>
            </div>

            <div className="mt-3 pt-3 border-top">
              <h6 className="mb-2">Acciones Rápidas</h6>
              <div className="d-grid gap-2">
                <Button 
                  variant="outline-primary" 
                  size="sm"
                  onClick={() => onExport(searchResults.length > 0 ? searchResults : hotspots)}
                >
                  <i className="fas fa-download me-1"></i>
                  Exportar Resultados
                </Button>
                <Button 
                  variant="outline-success" 
                  size="sm"
                  onClick={() => onSchedule(searchResults.length > 0 ? searchResults : hotspots)}
                >
                  <i className="fas fa-calendar-plus me-1"></i>
                  Programar Inspección
                </Button>
              </div>
            </div>
          </Card.Body>
        </Card>
      </Col>

      {/* Información de herramientas activas */}
      {mapTools.activeTool && (
        <div className="position-fixed top-50 start-50 translate-middle alert alert-primary alert-dismissible fade show" style={{ zIndex: 9999 }}>
          <strong>
            {mapTools.activeTool === 'measure' ? '📏 Herramienta de Medición Activa' :
             mapTools.activeTool === 'route' ? '🛣️ Herramienta de Ruta Activa' :
             mapTools.activeTool === 'area' ? '🔷 Herramienta de Área Activa' : ''}
          </strong>
          <br />
          <small>
            {mapTools.activeTool === 'measure' ? 'Click en el mapa para agregar puntos, doble-click para finalizar' :
             mapTools.activeTool === 'route' ? 'Click para agregar waypoints, doble-click para finalizar ruta' :
             mapTools.activeTool === 'area' ? 'Click para agregar vértices (mín. 3), doble-click para cerrar área' : ''}
          </small>
          <button 
            type="button" 
            className="btn-close" 
            onClick={() => setMapTools(prev => ({ ...prev, activeTool: null, measurePoints: [], routePoints: [], areaPoints: [] }))}
          ></button>
        </div>
      )}
    </Row>
  );
};

// Componente principal con manejo completo de estados vacíos
//const AdvancedRailwayVtiCrm = () => {
const AdvancedRailwayVtiCrm:React.FC<AdvancedRailwayVtiCrmProps> = ({ language, disabled = false }) => {
  // Estados con tipos definidos
  const [vtiSummary, setVtiSummary] = useState<VtiSummaryData | null>(null);
  const [analysisData, setAnalysisData] = useState<AnalysisData | null>(null);
  const [hotspots, setHotspots] = useState<Hotspot[]>([]);
  const [documents, setDocuments] = useState<Document[]>([]);
  const [statistics, setStatistics] = useState<SystemStats | null>(null);
  const [healthStatus, setHealthStatus] = useState<HealthStatus | null>(null);
  const [predictions, setPredictions] = useState<Predictions | null>(null);
  
  // Nuevos estados para IA y funcionalidades extendidas
  const [aiChatHistory, setAiChatHistory] = useState<ChatItem[]>([]);
  const [activeTab, setActiveTab] = useState<string>('overview');
  
  const [loading, setLoading] = useState({
    summary: true,
    analysis: false,
    hotspots: false,
    documents: false,
    statistics: false,
    health: false,
    ai: false,
    predictions: false
  });
  
  const [error, setError] = useState<string | null>(null);

  const [searchFilters, setSearchFilters] = useState<{
    kpStart: string;
    kpEnd: string;
    defectType: string;
    searchResults: Hotspot[];
  }>({
    kpStart: '',
    kpEnd: '',
    defectType: 'all',
    searchResults: []
  });

  const [toast, setToast] = useState({
    show: false,
    variant: '',
    title: '',
    message: '',
    autoHide: true,
    duration: 4000
});

const showToast = (variant, title, message, autoHide = true, duration = 4000) => {
    if (!title || !message) {
        console.warn('Toast llamado sin título o mensaje:', { variant, title, message });
        return; // No mostrar toast si faltan datos
    }
    
    setToast({
        show: true,
        variant: `subtle-${variant}`,
        title,
        message,
        autoHide,
        duration
    });
    
    if (autoHide) {
        setTimeout(() => {
            hideToast();
        }, duration);
    }
};

const hideToast = () => {
    setToast(prev => ({ ...prev, show: false }));
};

// Funciones específicas para diferentes tipos de toast
const showSuccessToast = (title, message, duration = 4000) => {
    showToast('success', title, message, true, duration);
};

const showErrorToast = (title, message, duration = 6000) => {
    showToast('danger', title, message, true, duration);
};

const showWarningToast = (title, message, duration = 5000) => {
    showToast('warning', title, message, true, duration);
};

const showInfoToast = (title, message, duration = 4000) => {
    showToast('info', title, message, true, duration);
};

const cancelProcessing = () => {
    setIsCancelling(true);
    
    // Detener el procesamiento
    setIsProcessing(false);
    setProcessingProgress(0);
    
    // Limpiar todos los datos
    resetFormState();
    
    // Mostrar toast de cancelación
    showInfoToast(
        language === 'es' ? 'Procesamiento cancelado' : 'Processing cancelled',
        language === 'es' ? 'Todos los datos han sido limpiados exitosamente' : 'All data has been cleaned successfully'
    );
    
    setTimeout(() => {
        setIsCancelling(false);
    }, 1000);
};

  const handleKPSearch = async () => {
    if (!searchFilters.kpStart || !searchFilters.kpEnd) {
      alert('Por favor ingresa tanto KP inicio como KP fin');
      return;
    }

    try {
      setLoading(prev => ({ ...prev, hotspots: true }));
      
      // Filtrar hotspots por rango KP
      const kpStart = parseFloat(searchFilters.kpStart);
      const kpEnd = parseFloat(searchFilters.kpEnd);
      
      let filteredHotspots = hotspots.filter(hotspot => {
        // Extraer KP del nombre de ubicación
        const kpMatch = hotspot.location.match(/(\d+\.?\d*)/);
        if (kpMatch) {
          const kp = parseFloat(kpMatch[1]);
          return kp >= kpStart && kp <= kpEnd;
        }
        return false;
      });

      // Filtrar por tipo de defecto si no es "all"
      if (searchFilters.defectType !== 'all' && searchFilters.defectType !== 'Tipo de Defecto') {
        filteredHotspots = filteredHotspots.filter(hotspot => 
          hotspot.dominant_defects?.some(defect => 
            defect.toLowerCase().includes(searchFilters.defectType.toLowerCase().replace(' ', '_'))
          )
        );
      }

      setSearchFilters(prev => ({ ...prev, searchResults: filteredHotspots }));
      
      // Si hay resultados, hacer fetch de hotspots en ese rango
      if (filteredHotspots.length > 0) {
        await fetchHotspots(kpStart, kpEnd);
      }
      
    } catch (error) {
      console.error('Error en búsqueda:', error);
      setError('Error al realizar la búsqueda');
    } finally {
      setLoading(prev => ({ ...prev, hotspots: false }));
    }
  };

  const handleDateFilter = () => {
    const dateRange = prompt('Ingresa el rango de fechas (formato: YYYY-MM-DD a YYYY-MM-DD):', 
      `${new Date(Date.now() - 30*24*60*60*1000).toISOString().split('T')[0]} a ${new Date().toISOString().split('T')[0]}`);
    
    if (dateRange) {
      alert(`🔍 Filtro por fecha aplicado: ${dateRange}\n\n📊 En una implementación completa, esto filtraría los hotspots por fecha de detección.`);
    }
  };

  const handleSeverityFilter = () => {
    const severity = prompt('Selecciona severidad (CRITICAL, HIGH, MEDIUM, LOW):', 'HIGH');
    
    if (severity && ['CRITICAL', 'HIGH', 'MEDIUM', 'LOW'].includes(severity.toUpperCase())) {
      const filtered = hotspots.filter(h => h.recommendation_priority === severity.toUpperCase());
      setSearchFilters(prev => ({ ...prev, searchResults: filtered }));
      alert(`🎯 Mostrando ${filtered.length} hotspots con severidad ${severity.toUpperCase()}`);
    }
  };

  const handleHistoryFilter = () => {
    alert('📈 Filtro de historial activado.\n\nEn una implementación completa mostraría:\n- Evolución temporal de hotspots\n- Tendencias de deterioro\n- Historial de mantenimientos\n- Comparativas entre períodos');
  };

  const clearAllFilters = () => {
    setSearchFilters({
      kpStart: '',
      kpEnd: '',
      defectType: 'all',
      searchResults: []
    });
  };

  const exportSearchResults = (results = null) => {
    const dataToExport = results || (searchFilters.searchResults.length > 0 ? searchFilters.searchResults : hotspots);
  
    if (dataToExport.length === 0) {
    alert('No hay resultados para exportar');
    return;
    }
  
  const csvContent = [
    ['Ubicación', 'Defectos', 'Score', 'Prioridad', 'Tipos de Defecto', 'Latitud', 'Longitud', 'Fecha'].join(','),
    ...dataToExport.map(h => [
      `"${h.location}"`,
      h.defect_count || 0,
      h.risk_score?.toFixed(3) || '0.000',
      h.recommendation_priority || 'UNKNOWN',
      `"${h.dominant_defects?.join(';') || ''}"`,
      h.coordinates?.latitude?.toFixed(6) || '',
      h.coordinates?.longitude?.toFixed(6) || '',
      new Date().toISOString().split('T')[0]
    ].join(','))
  ].join('\n');
  
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = `hotspots_busqueda_${new Date().toISOString().split('T')[0]}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  window.URL.revokeObjectURL(url);
  showSuccessToast(
        language === 'es' ? 'Exportación' : 'Export',
        language === 'es' 
            ? `✅ Exportado: ${dataToExport.length} hotspots en CSV`
            : `✅ Exported: ${dataToExport.length} hotspots to CSV`
    );
  //alert(`✅ Exportado: ${dataToExport.length} hotspots en CSV`);
};


  // Programar inspección (mejorado)
const scheduleInspection = (results = null) => {
  const dataToSchedule = results || (searchFilters.searchResults.length > 0 ? searchFilters.searchResults : hotspots);
  
  if (dataToSchedule.length === 0) {
    alert('No hay hotspots para programar inspección');
    return;
  }
  
  const criticalCount = dataToSchedule.filter(h => h.recommendation_priority === 'CRITICAL').length;
  const highCount = dataToSchedule.filter(h => h.recommendation_priority === 'HIGH').length;
  
  const scheduleData = {
    totalLocations: dataToSchedule.length,
    criticalPriority: criticalCount,
    highPriority: highCount,
    estimatedDuration: Math.ceil(dataToSchedule.length * 0.5), // 30 min por ubicación
    recommendedDate: new Date(Date.now() + 24*60*60*1000).toISOString().split('T')[0], // Mañana
    locations: dataToSchedule.map(h => ({
      location: h.location,
      priority: h.recommendation_priority,
      defects: h.defect_count,
      coordinates: h.coordinates
    }))
  };
  
  alert(`✅ Inspección programada:\n• ${criticalCount} ubicaciones críticas\n• ${highCount} ubicaciones de alta prioridad\n• Duración estimada: ${scheduleData.estimatedDuration} horas\n• Fecha recomendada: ${scheduleData.recommendedDate}`);
};


  // Configuración de la API
  const API_BASE = 'http://98.201.126.138:8889';

  // Funciones de API mejoradas con manejo de respuestas vacías
  const apiCall = async (endpoint, options = {}) => {
    try {
      console.log(`API Call to: ${API_BASE}${endpoint}`);
      
      const response = await fetch(`${API_BASE}${endpoint}`, {
        headers: { 
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${HatateToken}`,
          'Accept': 'application/json'
        },
        ...options
      });
      
      console.log(`Response status for ${endpoint}:`, response.status);
      
      if (!response.ok) {
        const errorText = await response.text();
        console.error(`API Error ${endpoint}:`, errorText);
        throw new Error(`Error en ${endpoint}: ${response.status} - ${errorText}`);
      }
      
      const data = await response.json();
      console.log(`Data received from ${endpoint}:`, data);
      
      return data;
    } catch (err) {
      console.error(`API Error ${endpoint}:`, err);
      throw err;
    }
  };

  // Función para health check
  const fetchHealthStatus = async () => {
    try {
      setLoading(prev => ({ ...prev, health: true }));
      const data = await apiCall('/health');
      setHealthStatus(data || { status: 'unknown' });
    } catch (err) {
      setError(err.message);
      setHealthStatus({ status: 'error' });
    } finally {
      setLoading(prev => ({ ...prev, health: false }));
    }
  };

  // Función para VTI summary con manejo de datos vacíos
  const fetchVtiSummary = async () => {
    try {
      setLoading(prev => ({ ...prev, summary: true }));
      setVtiSummary(null);
      const data = await apiCall('/vti-summary');
      setVtiSummary(data); // Será null si no hay datos
    } catch (err) {
      setError(err.message);
      setVtiSummary(null);
    } finally {
      setLoading(prev => ({ ...prev, summary: false }));
    }
  };

  // Función para estadísticas
  const fetchStatistics = async () => {
    try {
      setLoading(prev => ({ ...prev, statistics: true }));
      const data = await apiCall('/statistics');
      setStatistics(data?.system_stats || null);
    } catch (err) {
      setError(err.message);
      setStatistics(null);
    } finally {
      setLoading(prev => ({ ...prev, statistics: false }));
    }
  };

  // Función para hotspots con manejo de arrays vacíos
const fetchHotspots = async (kpStart = 0, kpEnd = 100) => {
  try {
    setLoading(prev => ({ ...prev, hotspots: true }));
    const data = await apiCall(
      `/vti-hotspots?kp_start=${kpStart}&kp_end=${kpEnd}&min_risk_score=0.0`
    );
    
    // Solo establecer hotspots si tienen coordenadas válidas
    if (data?.hotspots) {
      const validHotspots = data.hotspots.filter(validateCoordinates);
      setHotspots(validHotspots);
    } else {
      // Si no hay datos de la API, usar datos de ejemplo para demostración
      const mockHotspots = [
        {
          id: 1,
          location: 'KP_0.2',
          defect_count: 11,
          risk_score: 0.856,
          recommendation_priority: 'CRITICAL',
          coordinates: { latitude: -33.4489, longitude: -70.6693 },
          dominant_defects: ['TRL_PEAK', 'CBV_PEAK']
        },
        {
          id: 2,
          location: 'KP_0.15',
          defect_count: 8,
          risk_score: 0.623,
          recommendation_priority: 'HIGH',
          coordinates: { latitude: -33.4495, longitude: -70.6685 },
          dominant_defects: ['RAIL_WEAR', 'GEOMETRY_DEFECT']
        },
        {
          id: 3,
          location: 'KP_0.25',
          defect_count: 5,
          risk_score: 0.425,
          recommendation_priority: 'MEDIUM',
          coordinates: { latitude: -33.4485, longitude: -70.6700 },
          dominant_defects: ['JOINT_DEFECT']
        }
      ];
      setHotspots(mockHotspots);
    }
  } catch (err) {
    setError(err.message);
    setHotspots([]);
  } finally {
    setLoading(prev => ({ ...prev, hotspots: false }));
  }
};
const validateCoordinates = (hotspot) => {
  return hotspot.coordinates && 
         hotspot.coordinates.latitude && 
         hotspot.coordinates.longitude &&
         !isNaN(hotspot.coordinates.latitude) &&
         !isNaN(hotspot.coordinates.longitude);
};

  // Función para documentos
  const fetchDocuments = async () => {
    try {
      setLoading(prev => ({ ...prev, documents: true }));
      
      console.log('Fetching documents...');
      
      const response = await apiCall('/documents');
      
      console.log('Documents response:', response);
      
      // Manejar diferentes estructuras de respuesta
      if (response && response.documents) {
        setDocuments(response.documents);
        console.log('Documents set:', response.documents.length);
      } else if (response && Array.isArray(response)) {
        setDocuments(response);
        console.log('Documents set from array:', response.length);
      } else {
        console.error('Invalid documents response structure:', response);
        setDocuments([]);
      }
    } catch (err) {
      console.error('Error fetching documents:', err);
      setError(err.message);
      setDocuments([]);
    } finally {
      setLoading(prev => ({ ...prev, documents: false }));
    }
  };

  // Función para análisis VTI
  const analyzeTrackSegment = async (kpStart: number, kpEnd: number) => {
    // Verificar si hay datos antes de intentar análisis
    if (!vtiSummary || vtiSummary.total_vti_files === 0) {
      setError('No hay datos VTI disponibles para análisis');
      return;
    }

    try {
      setLoading(prev => ({ ...prev, analysis: true }));
      const data = await apiCall('/analyze-vti', {
        method: 'POST',
        body: JSON.stringify({
          kp_start: kpStart,
          kp_end: kpEnd,
          severity_threshold: 'Medium'
        })
      });
      setAnalysisData(data);
    } catch (err) {
      setError(err.message);
      setAnalysisData(null);
    } finally {
      setLoading(prev => ({ ...prev, analysis: false }));
    }
  };

  // Función para predicciones
  const fetchPredictions = async (kpStart: number, kpEnd: number, timeframe = 60) => {
    try {
      setLoading(prev => ({ ...prev, predictions: true }));
      const data = await apiCall('/predict', {
        method: 'POST',
        body: JSON.stringify({
          component: 'rail',
          location: `KP_${kpStart}-${kpEnd}`,
          current_condition: 'análisis predictivo',
          environmental_factors: { traffic_load: 'medium' },
          age_years: 10
        })
      });
      setPredictions({
        failure_probability: data.probability_percentage || 0,
        maintenance_urgency: data.risk_level || 'Medium',
        confidence: data.confidence_score || 0.85,
        risk_factors: data.potential_failures?.map(f => f.type) || []
      });
    } catch (err) {
      setError(err.message);
      setPredictions(null);
    } finally {
      setLoading(prev => ({ ...prev, predictions: false }));
    }
  };

  // Función para búsqueda de documentos
  const searchDocuments = async (searchTerm: string) => {
    try {
      setLoading(prev => ({ ...prev, documents: true }));
      const data = await apiCall('/search-documents', {
        method: 'POST',
        body: JSON.stringify({
          query: searchTerm,
          document_types: ['vti'],
          max_results: 10
        })
      });
      setDocuments(data?.results || data?.documents || []);
    } catch (err) {
      setError(err.message);
      setDocuments([]);
    } finally {
      setLoading(prev => ({ ...prev, documents: false }));
    }
  };

  // Función mejorada para consultas IA
  const sendAIQuery = async (query) => {
    try {
      setLoading(prev => ({ ...prev, ai: true }));
      
      const hasData = vtiSummary && vtiSummary.total_vti_files > 0;
      
      const context = {
        query: query,
        context: {
          domain: 'railway_analysis',
          user_intent: 'technical_consultation',
          has_data: hasData,
          language: 'spanish',
          format_preference: 'structured_with_markdown'
        },
        current_data: hasData ? {
          vti_summary: vtiSummary,
          recent_analysis: analysisData,
          top_hotspots: hotspots.slice(0, 5),
          system_health: healthStatus,
          statistics: statistics
        } : {
          system_status: 'waiting_for_data',
          capabilities: 'general_vti_consultation'
        },
        analysis_scope: {
          total_files: vtiSummary?.total_vti_files || 0,
          total_records: vtiSummary?.total_records || 0,
          critical_hotspots: hotspots.filter(h => h.recommendation_priority === 'HIGH').length
        }
      };

      console.log('Sending context to API:', context);

      const response = await apiCall('/llm-query', {
        method: 'POST',
        body: JSON.stringify(context)
      });

      console.log('Raw API response:', response);

      // Procesar y formatear la respuesta
      const formattedResponse = extractAndFormatResponse(response);
      
      // Verificar que no esté vacía
      const finalResponse = formattedResponse || (hasData 
        ? '🤖 Respuesta procesada correctamente basada en tus datos VTI'
        : '🤖 ¡Hola! 👋 Te puedo ayudar con información general sobre el sistema VTI. Una vez que cargues documentos, podré hacer análisis específicos.');

      // Agregar a historial de chat
      const newChat = {
        query: query,
        response: finalResponse,
        timestamp: new Date(),
        confidence: response?.confidence || (hasData ? 0.85 : 0.7),
        suggestions: response?.suggestions || [],
        error: false
      };

      setAiChatHistory(prev => [...prev, newChat]);
      return response;
      
    } catch (err) {
      console.error('AI Query Error:', err);
      
      const errorChat = {
        query: query,
        response: '❌ Lo siento, ocurrió un error al procesar tu consulta.\n\n🔧 Verifica la conexión con el servicio de IA.',
        timestamp: new Date(),
        confidence: 0,
        error: true
      };
      
      setAiChatHistory(prev => [...prev, errorChat]);
      setError(err.message);
    } finally {
      setLoading(prev => ({ ...prev, ai: false }));
    }
  };

  // Función simulada para upload
  const handleUpload = () => {
    alert('Función de carga de documentos - implementar según tu sistema de upload');
  };

  // Función para escaneo manual
  const triggerManualScan = async () => {
    try {
      const data = await apiCall('/manual-scan', {
        method: 'POST',
        body: JSON.stringify({
          scan_type: 'full_system',
          priority: 'high'
        })
      });
      return data;
    } catch (err) {
      setError(err.message);
      return null;
    }
  };

  // Efecto inicial para cargar datos
  useEffect(() => {
    console.log('Initial data fetch starting...');

    const fetchInitialData = async () => {
      try {
        await Promise.all([
          fetchHealthStatus(),
          fetchVtiSummary(),
          fetchStatistics(),
          fetchHotspots(),
          fetchDocuments()
        ]);
        console.log('Initial data fetch completed');
      } catch (error) {
        console.error('Error in initial data fetch:', error);
      }
    };

    fetchInitialData();
  }, []);

  // Auto-refresh silencioso
  useEffect(() => {
    const interval = setInterval(async () => {
      // Actualizaciones silenciosas sin cambiar estado de loading
      try {
        const healthData = await apiCall('/health');
        setHealthStatus(healthData || { status: 'unknown' });
        
        if (activeTab === 'overview') {
          const vtiData = await apiCall('/vti-summary');
          setVtiSummary(vtiData);
          
          const statsData = await apiCall('/statistics');
          setStatistics(statsData?.system_stats || null);
        }
      } catch (err) {
        console.error('Silent update failed:', err);
      }
    }, 90000);

    return () => clearInterval(interval);
  }, [activeTab]);

  // Calcular estadísticas del resumen
  const totalFiles = vtiSummary?.total_vti_files || 0;
  const totalRecords = vtiSummary?.total_records || 0;
  const avgRecordsPerFile = totalFiles > 0 ? Math.round(totalRecords / totalFiles) : 0;
  
  const overallSeverityDist = vtiSummary?.files?.reduce((acc, file) => {
    Object.entries(file.severity_distribution || {}).forEach(([severity, count]) => {
      acc[severity] = (acc[severity] || 0) + count;
    });
    return acc;
  }, {}) || null;

  // Determinar si hay datos en el sistema
  const hasData = totalFiles > 0 || hotspots.length > 0 || documents.length > 0;

  return (
    <>
         {/* Sistema de Toast Universal */}
      {toast.show && toast.title && toast.message && (
          <div 
              className={`position-fixed top-0 start-50 translate-middle-x mt-3 toast-show`}
              style={{ 
                  zIndex: 9998,
                  transition: 'all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
                  opacity: 1,
                  transform: 'translateX(-50%) translateY(0)',
                  pointerEvents: 'auto'
              }}
          >
              <Alert 
                  variant={toast.variant || 'subtle-info'}
                  className="shadow-lg border-0 d-flex align-items-center toast-alert"
                  style={{
                      minWidth: '320px',
                      maxWidth: '500px'
                  }}
              >
                  <FontAwesomeIcon 
                      icon={
                          toast.variant.includes('success') ? faCheckCircle :
                          toast.variant.includes('danger') ? faExclamationTriangle :
                          toast.variant.includes('warning') ? faExclamationCircle :
                          toast.variant.includes('info') ? faInfoCircle : faCheckCircle
                      } 
                      className={`me-2`}
                      size="lg" 
                  />
                  <div className="flex-grow-1">
                      <strong>{toast.title}</strong>
                      {toast.message && (
                          <>
                              <br />
                              <small className="opacity-75">{toast.message}</small>
                          </>
                      )}
                  </div>
                  <Button 
                      variant={toast.variant.replace('subtle-', 'outline-') || 'outline-info'}
                      size="sm"
                      onClick={hideToast}
                      className="ms-2"
                      style={{ padding: '0.25rem 0.5rem' }}
                  >
                      <FontAwesomeIcon icon={faTimes} />
                  </Button>
              </Alert>
          </div>
      )}
      
      {/* Header principal */}
      <Row className="mb-4 gy-3 justify-content-between">
        <Col xxl={12}>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h2 className="mb-2 text-body-primary">
                <i className="fas fa-train me-2"></i>
                Railroad Assessment & Intelligent Logistics System
              </h2>
              <h5 className="text-body-tertiary fw-semibold mb-0">
                Sistema Avanzado de Monitoreo y Control Ferroviario con IA Predictiva
                {!hasData && (
                  <Badge bg="warning" className="ms-2">
                    <i className="fas fa-exclamation-triangle me-1"></i>
                    Sin datos VTI
                  </Badge>
                )}
              </h5>
            </div>
            <div className="d-flex align-items-center gap-3">
              <div className="text-end">
                <div className="d-flex align-items-center">
                  <div 
                    className={`badge ${healthStatus?.status === 'healthy' ? 'bg-success' : 'bg-danger'} me-2`}
                  >
                    {healthStatus?.status === 'healthy' ? 'Online' : 'Error'}
                  </div>
                  <small className="text-body-tertiary">
                    Actualizado: {new Date().toLocaleTimeString()}
                  </small>
                </div>
                {!hasData && (
                  <div className="mt-1">
                    <Button 
                      size="sm" 
                      variant="outline-primary"
                      onClick={handleUpload}
                    >
                      <i className="fas fa-upload me-1"></i>
                      Cargar Datos VTI
                    </Button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </Col>
      </Row>

      {/* Alerta de sistema sin datos */}
      {!hasData && !loading.summary && (
        <Alert variant="info" className="mb-4">
          <Alert.Heading>
            <i className="fas fa-info-circle me-2"></i>
            Sistema en Espera de Datos
          </Alert.Heading>
          <p className="mb-3">
            El sistema está operativo pero no tiene documentos VTI cargados. 
            Para comenzar el análisis, necesitas cargar archivos VTI que contengan datos de inspección ferroviaria.
          </p>
          <div className="d-flex gap-2">
            <Button variant="primary" onClick={handleUpload}>
              <i className="fas fa-upload me-2"></i>
              Cargar Documentos VTI
            </Button>
            <Button variant="outline-info" onClick={() => setActiveTab('documents')}>
              <i className="fas fa-folder me-2"></i>
              Ir a Gestión de Documentos
            </Button>
          </div>
        </Alert>
      )}

      {/* Alerta de error */}
      {error && (
        <Alert variant="danger" dismissible onClose={() => setError(null)} className="mb-4">
          <Alert.Heading>Error del Sistema</Alert.Heading>
          {error}
        </Alert>
      )}

      {/* Navegación por pestañas */}
      <Tab.Container activeKey={activeTab} onSelect={(key) => key && setActiveTab(key)}>
        <Nav variant="pills" className="mb-4">
          <Nav.Item>
            <Nav.Link eventKey="overview">
              <i className="fas fa-tachometer-alt me-2"></i>
              Overview
              {!hasData && <Badge bg="secondary" className="ms-1">Vacío</Badge>}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="analytics" disabled={!hasData}>
              <i className="fas fa-chart-line me-2"></i>
              Analytics
              {!hasData && <Badge bg="warning" className="ms-1">Sin datos</Badge>}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="intelligence">
              <i className="fas fa-brain me-2"></i>
              AI Intelligence
              {!hasData && <Badge bg="info" className="ms-1">Modo general</Badge>}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="documents">
              <i className="fas fa-folder me-2"></i>
              Documents
              {documents.length === 0 && <Badge bg="secondary" className="ms-1">Vacío</Badge>}
            </Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link eventKey="geolocation">
              <i className="fas fa-map-marked-alt me-2"></i>
              Geolocation
              {hotspots.length === 0 && <Badge bg="secondary" className="ms-1">Sin hotspots</Badge>}
            </Nav.Link>
          </Nav.Item>
        </Nav>

        <Tab.Content>
          {/* Pestaña Overview */}
          <Tab.Pane eventKey="overview">
            {/* Cards de estadísticas principales */}
            <Row className="g-3 mb-4">
              <Col sm={6} md={4} xl={3}>
                <VtiStatCard
                  icon="fa-file-csv"
                  color="primary"
                  label="Archivos VTI"
                  value={totalFiles}
                  title="Procesados"
                  badgeLabel={totalFiles > 0 ? "Activo" : "Sin datos"}
                  badgeBg={totalFiles > 0 ? "success" : "warning"}
                  footerText="Archivos en sistema"
                  isLoading={loading.summary}
                  aiPrediction={null}
                  isEmpty={totalFiles === 0}
                />
              </Col>
              <Col sm={6} md={4} xl={3}>
                <VtiStatCard
                  icon="fa-database"
                  color="info"
                  label="Registros totales"
                  value={totalRecords === 0 ? "0" : totalRecords.toLocaleString()}
                  title="Defectos"
                  badgeLabel={avgRecordsPerFile > 0 ? `${avgRecordsPerFile}/archivo` : "N/A"}
                  badgeBg={avgRecordsPerFile > 0 ? "info" : "secondary"}
                  footerText="Promedio por archivo"
                  isLoading={loading.summary}
                  aiPrediction={totalRecords > 0 ? "Tendencia estable" : null}
                  isEmpty={totalRecords === 0}
                />
              </Col>
              <Col sm={6} md={4} xl={3}>
                <VtiStatCard
                  icon="fa-exclamation-triangle"
                  color="warning"
                  label="Hotspots críticos"
                  value={hotspots.length}
                  title="Ubicaciones"
                  badgeLabel={hotspots.length > 0 ? "Requiere atención" : "Normal"}
                  badgeBg={hotspots.length > 0 ? "danger" : "success"}
                  footerText="Puntos de alto riesgo"
                  isLoading={loading.hotspots}
                  aiPrediction={hotspots.length > 0 ? `${hotspots.filter(h => h.recommendation_priority === 'HIGH').length} críticos` : null}
                  isEmpty={hotspots.length === 0}
                />
              </Col>
              <Col sm={6} md={4} xl={3}>
                <VtiStatCard
                  icon="fa-chart-line"
                  color="success"
                  label="Estado sistema"
                  value={healthStatus?.status === 'healthy' ? "100%" : "ERROR"}
                  title="Operativo"
                  badgeLabel={healthStatus?.status === 'healthy' ? "Online" : "Error"}
                  badgeBg={healthStatus?.status === 'healthy' ? "success" : "danger"}
                  footerText="Disponibilidad"
                  isLoading={loading.health}
                  aiPrediction={healthStatus?.status === 'healthy' ? "99.9% uptime" : null}
                  isEmpty={false}
                />
              </Col>
            </Row>

            {/* Mapa de Georreferencia */}
            <AdvancedGeoMap 
              hotspots={hotspots} 
              isLoading={loading.hotspots}
            />

            {/* Gráfico de Análisis Técnico Ferroviario */}
            <ProfessionalRailwayChart 
              analysisData={analysisData}
              hotspots={hotspots}
              isLoading={loading.analysis}
            />

            {/*<WorkingRailway3D 
  hotspots={hotspots}
  analysisData={analysisData}
  isLoading={loading.analysis}
/>*/}
<Railway3DChart 
  hotspots={hotspots}
  analysisData={analysisData}
  height={450}
  hotspotsLimit="1-50"   
  backgroundColor='#efefef'
/>
            {/* Fila de gráficos principales */}
            <Row className="mb-4 g-3">
              <Col xs={12} xl={6}>
                <SeverityDistribution 
                  data={overallSeverityDist} 
                  isLoading={loading.summary}
                />
              </Col>
              <Col xs={12} xl={6}>
                <CriticalHotspots 
                  data={hotspots} 
                  isLoading={loading.hotspots}
                />
              </Col>
            </Row>

            {/* Fila de estadísticas del sistema */}
            <Row className="mb-4 g-3">
              <Col xs={12} xl={8}>
                <Recommendations 
                  data={analysisData?.recommendations} 
                  analysisData={analysisData}
                  hotspots={hotspots}
                  vtiSummary={vtiSummary}
                  isLoading={loading.analysis}
                />
              </Col>
              <Col xs={12} xl={4}>
                <SystemStatistics
                  data={statistics}
                  isLoading={loading.statistics}
                />
              </Col>
            </Row>
          </Tab.Pane>

          {/* Pestaña Analytics */}
          <Tab.Pane eventKey="analytics">
            {!hasData ? (
              <div className="text-center py-5">
                <i className="fas fa-chart-line text-muted fs-1 mb-4"></i>
                <h4 className="text-muted mb-3">Análisis no disponible</h4>
                <p className="text-body-tertiary mb-4">
                  Para acceder a las funciones de análisis, necesitas cargar documentos VTI primero.
                </p>
                <Button variant="primary" onClick={handleUpload}>
                  <i className="fas fa-upload me-2"></i>
                  Cargar Documentos VTI
                </Button>
              </div>
            ) : (
              <>
                <Row className="mb-4 g-3">
                  <Col xs={12} xl={4}>
                    <TrackAnalysis 
                      onAnalyze={analyzeTrackSegment}
                      isLoading={loading.analysis}
                      hasData={hasData}
                    />
                  </Col>
                  <Col xs={12} xl={8}>
                    <Card className="h-100">
                      <Card.Header>
                        <h5 className="mb-0">Análisis Predictivo Avanzado</h5>
                        <p className="text-body-tertiary mb-0">Datos históricos vs predicciones de IA</p>
                      </Card.Header>
                      <Card.Body>
                        {loading.analysis ? (
                          <div className="text-center py-5">
                            <Spinner animation="border" />
                            <p className="text-body-tertiary mt-2">Procesando análisis...</p>
                          </div>
                        ) : analysisData ? (
                          <div>
                            <div className="row g-3 mb-4">
                              <div className="col-md-3 text-center">
                                <h3 className="mb-0 text-primary-tertiary">{analysisData.total_defects}</h3>
                                <small className="text-body-tertiary">Total Defectos</small>
                              </div>
                              <div className="col-md-3 text-center">
                                <h3 className="mb-0 text-info">{analysisData.defect_density?.toFixed(1)}</h3>
                                <small className="text-body-tertiary">Defectos/km</small>
                              </div>
                              <div className="col-md-3 text-center">
                                <h3 className="mb-0 text-warning">{analysisData.risk_hotspots?.length || 0}</h3>
                                <small className="text-body-tertiary">Hotspots</small>
                              </div>
                              <div className="col-md-3 text-center">
                                <Badge 
                                  bg={
                                    analysisData.failure_prediction?.risk_level === 'CRITICAL' ? 'danger' :
                                    analysisData.failure_prediction?.risk_level === 'HIGH' ? 'warning' :
                                    analysisData.failure_prediction?.risk_level === 'MEDIUM' ? 'info' : 'success'
                                  }
                                  className="fs-6 px-3 py-2"
                                >
                                  {analysisData.failure_prediction?.risk_level || 'LOW'}
                                </Badge>
                                <p className="mb-0 text-body-tertiary mt-1 small">Nivel de Riesgo</p>
                              </div>
                            </div>
                            
                            <div className="text-center">
                              <Button
                                variant="outline-primary"
                                onClick={() => fetchPredictions(
                                  analysisData.location_range?.kp_start || 0,
                                  analysisData.location_range?.kp_end || 50
                                )}
                                disabled={loading.predictions}
                              >
                                {loading.predictions ? (
                                  <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    Generando predicciones...
                                  </>
                                ) : (
                                  <>
                                    <i className="fas fa-brain me-2"></i>
                                    Obtener Predicciones IA
                                  </>
                                )}
                              </Button>
                            </div>
                          </div>
                        ) : (
                          <div className="text-center py-5">
                            <i className="fas fa-chart-line text-primary fs-1 mb-3"></i>
                            <h6 className="text-body-tertiary">No hay análisis disponible</h6>
                            <p className="text-body-secondary">Ejecuta un análisis de tramo para ver los resultados</p>
                          </div>
                        )}
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>

                {/* Mostrar predicciones si están disponibles */}
                {predictions && (
                  <Row className="mb-4 g-3">
                    <Col xs={12}>
                      <Card>
                        <Card.Header>
                          <h5 className="mb-0">
                            <i className="fas fa-crystal-ball me-2"></i>
                            Predicciones de IA
                          </h5>
                          <p className="text-body-tertiary mb-0">Análisis predictivo basado en machine learning</p>
                        </Card.Header>
                        <Card.Body>
                          <div className="row g-3">
                            <div className="col-md-4">
                              <div className="text-center p-3 bg-danger-subtle rounded">
                                <h2 className="mb-0 text-danger">{predictions.failure_probability || 0}%</h2>
                                <p className="mb-0 text-body-tertiary">Probabilidad de Fallo</p>
                                <small className="text-body-secondary">Próximos 30 días</small>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="text-center p-3 bg-warning-subtle rounded">
                                <h2 className="mb-0 text-warning">{predictions.maintenance_urgency || 'Media'}</h2>
                                <p className="mb-0 text-body-tertiary">Urgencia Mantenimiento</p>
                                <small className="text-body-secondary">Recomendación IA</small>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <div className="text-center p-3 bg-info-subtle rounded">
                                <h2 className="mb-0 text-info">{(predictions.confidence * 100).toFixed(0)}%</h2>
                                <p className="mb-0 text-body-tertiary">Confianza Modelo</p>
                                <small className="text-body-secondary">Precisión predicción</small>
                              </div>
                            </div>
                          </div>
                          
                          {predictions.risk_factors && (
                            <div className="mt-3 pt-3 border-top">
                              <h6 className="mb-2">Factores de Riesgo Identificados:</h6>
                              <div className="d-flex flex-wrap gap-1">
                                {predictions.risk_factors.map((factor, index) => (
                                  <Badge key={index} bg="warning" className="me-1">
                                    {factor}
                                  </Badge>
                                ))}
                              </div>
                            </div>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                )}
              </>
            )}
          </Tab.Pane>

          {/* Pestaña AI Intelligence */}
          <Tab.Pane eventKey="intelligence">
            <Row className="g-3">
              <Col xs={12} xl={8}>
                <AIAssistant
                  onSendQuery={sendAIQuery}
                  chatHistory={aiChatHistory}
                  isLoading={loading.ai}
                  hasData={hasData}
                />
              </Col>
              <Col xs={12} xl={4}>
                <Card className="h-100">
                  <Card.Header>
                    <h5 className="mb-0">Panel de Control IA</h5>
                    <p className="text-body-tertiary mb-0">Estado y configuración del sistema inteligente</p>
                  </Card.Header>
                  <Card.Body>
                    <div className="mb-3">
                      <h6 className="mb-2">Estado del Motor IA</h6>
                      <div className="d-flex align-items-center mb-2">
                        <div className="badge bg-success me-2">Online</div>
                        <small className="text-body-tertiary">
                          {hasData ? 'Modelo activo con datos' : 'Modelo en modo consulta general'}
                        </small>
                      </div>
                    </div>
                    
                    <div className="mb-3">
                      <h6 className="mb-2">Modo de Operación</h6>
                      <div className="text-center">
                        <Badge bg={hasData ? "primary" : "secondary"} className="fs-6 px-3 py-2">
                          {hasData ? 'Análisis Completo' : 'Consulta General'}
                        </Badge>
                        <div className="mt-1">
                          <small className="text-body-tertiary">
                            {hasData 
                              ? 'Con acceso a datos VTI cargados'
                              : 'Esperando datos para análisis completo'
                            }
                          </small>
                        </div>
                      </div>
                    </div>
                    
                    <div className="mb-3">
                      <h6 className="mb-2">Consultas Realizadas</h6>
                      <div className="text-center">
                        <h4 className="mb-0 text-primary">{aiChatHistory.length}</h4>
                        <small className="text-body-tertiary">Consultas procesadas</small>
                      </div>
                    </div>
                    
                    <div className="mb-3">
                      <h6 className="mb-2">Confianza Promedio</h6>
                      <div className="text-center">
                        <h4 className="mb-0 text-success">
                          {aiChatHistory.length > 0 
                            ? Math.round(aiChatHistory.reduce((acc, chat) => acc + (chat.confidence || 0), 0) / aiChatHistory.length * 100)
                            : 0}%
                        </h4>
                        <small className="text-body-tertiary">Precisión respuestas</small>
                      </div>
                    </div>

                    <div className="d-grid gap-2">
                      {hasData ? (
                        <>
                          <Button 
                            variant="outline-primary" 
                            size="sm"
                            onClick={() => sendAIQuery("Genera un resumen ejecutivo del estado actual del sistema")}
                            disabled={loading.ai}
                          >
                            <i className="fas fa-file-alt me-2"></i>
                            Resumen Ejecutivo
                          </Button>
                          <Button 
                            variant="outline-success" 
                            size="sm"
                            onClick={() => sendAIQuery("¿Cuáles son las principales recomendaciones de mantenimiento para esta semana?")}
                            disabled={loading.ai}
                          >
                            <i className="fas fa-wrench me-2"></i>
                            Plan Mantenimiento
                          </Button>
                        </>
                      ) : (
                        <>
                          <Button 
                            variant="outline-info" 
                            size="sm"
                            onClick={() => sendAIQuery("¿Cómo funciona el sistema de análisis VTI?")}
                            disabled={loading.ai}
                          >
                            <i className="fas fa-question-circle me-2"></i>
                            ¿Cómo funciona VTI?
                          </Button>
                          <Button 
                            variant="outline-secondary" 
                            size="sm"
                            onClick={() => sendAIQuery("¿Qué tipos de documentos puedo cargar?")}
                            disabled={loading.ai}
                          >
                            <i className="fas fa-file-upload me-2"></i>
                            Tipos de documentos
                          </Button>
                        </>
                      )}
                    </div>

                    {!hasData && (
                      <Alert variant="info" className="mt-3 small">
                        <i className="fas fa-lightbulb me-2"></i>
                        <strong>Tip:</strong> Una vez que cargues datos VTI, podré hacer análisis predictivos y recomendaciones específicas.
                      </Alert>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Tab.Pane>

          {/* Pestaña Documents */}
          <Tab.Pane eventKey="documents">
            <Row className="g-3">
              <Col xs={12} xl={8}>
                <DocumentManager
                  documents={documents}
                  onSearch={searchDocuments}
                  isLoading={loading.documents}
                  onUpload={handleUpload}
                />
              </Col>
              <Col xs={12} xl={4}>
                <Card className="h-100">
                  <Card.Header>
                    <h5 className="mb-0">Procesamiento Avanzado</h5>
                    <p className="text-body-tertiary mb-0">Herramientas de análisis y procesamiento</p>
                  </Card.Header>
                  <Card.Body>
                    <div className="d-grid gap-3">
                      <Button
                        variant={documents.length > 0 ? "primary" : "outline-primary"}
                        onClick={triggerManualScan}
                        className="d-flex align-items-center justify-content-center"
                        disabled={documents.length === 0}
                      >
                        <i className="fas fa-cog me-2"></i>
                        {documents.length > 0 ? 'Escaneo Manual Completo' : 'Esperando documentos'}
                      </Button>
                      
                      <Button
                        variant="outline-info"
                        onClick={handleUpload}
                        className="d-flex align-items-center justify-content-center"
                      >
                        <i className="fas fa-upload me-2"></i>
                        Cargar Documentos
                      </Button>
                      
                      <Button
                        variant="outline-success"
                        className="d-flex align-items-center justify-content-center"
                        disabled={documents.length === 0}
                      >
                        <i className="fas fa-download me-2"></i>
                        Exportar Reportes
                      </Button>
                    </div>
                    
                    <div className="mt-4 pt-3 border-top">
                      <h6 className="mb-2">Estadísticas de Documentos</h6>
                      <div className="row g-2 text-center">
                        <div className="col-6">
                          <div className={`p-2 ${documents.length > 0 ? 'bg-primary-subtle' : 'bg-body'} rounded`}>
                            <h6 className={`mb-0 ${documents.length > 0 ? 'text-primary' : 'text-muted'}`}>
                              {documents.length}
                            </h6>
                            <small className="text-muted">Total</small>
                          </div>
                        </div>
                        <div className="col-6">
                          <div className={`p-2 ${documents.filter(d => d.processed).length > 0 ? 'bg-success-subtle' : 'bg-body'} rounded`}>
                            <h6 className={`mb-0 ${documents.filter(d => d.processed).length > 0 ? 'text-success' : 'text-muted'}`}>
                              {documents.filter(d => d.processed).length || 0}
                            </h6>
                            <small className="text-muted">Procesados</small>
                          </div>
                        </div>
                      </div>
                    </div>

                    {documents.length === 0 && (
                      <Alert variant="warning" className="mt-3 small">
                        <i className="fas fa-exclamation-triangle me-2"></i>
                        <strong>Sin documentos:</strong> El sistema necesita documentos VTI para funcionar completamente.
                      </Alert>
                    )}
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Tab.Pane>

          {/* Pestaña Geolocation */}
          <Tab.Pane eventKey="geolocation">
  {hotspots.length === 0 ? (
    <div className="text-center py-5">
      <i className="fas fa-map-marked-alt text-muted fs-1 mb-4"></i>
      <h4 className="text-muted mb-3">Sin hotspots para geolocalización</h4>
      <p className="text-body-tertiary mb-4">
        La funcionalidad de geolocalización estará disponible una vez que se detecten hotspots en los datos VTI.
      </p>
      <Button variant="primary" onClick={handleUpload}>
        <i className="fas fa-upload me-2"></i>
        Cargar Documentos VTI
      </Button>
    </div>
  ) : (
    <InteractiveSearchMapComponent 
      hotspots={hotspots} 
      onExport={exportSearchResults}
      onSchedule={scheduleInspection}
      isLoading={loading.hotspots}
    />
  )}
</Tab.Pane>
        </Tab.Content>
      </Tab.Container>

      {/* Panel de último análisis si existe */}
      {analysisData && (
        <Row className="mb-4 g-3">
          <Col xs={12}>
            <Card>
              <Card.Header>
                <h5 className="mb-0">Último Análisis de Tramo Ejecutado</h5>
                <p className="text-body-tertiary mb-0">
                  KP {analysisData.location_range?.kp_start} - {analysisData.location_range?.kp_end}
                </p>
              </Card.Header>
              <Card.Body>
                <Row className="g-3">
                  <Col md={3}>
                    <div className="text-center">
                      <h3 className="mb-1 text-primary-tertiary">{analysisData.total_defects}</h3>
                      <p className="mb-0 text-body-tertiary">Total Defectos</p>
                    </div>
                  </Col>
                  <Col md={3}>
                    <div className="text-center">
                      <h3 className="mb-1 text-primary-tertiary">
                        {analysisData.defect_density?.toFixed(1)}
                      </h3>
                      <p className="mb-0 text-body-tertiary">Defectos/km</p>
                    </div>
                  </Col>
                  <Col md={3}>
                    <div className="text-center">
                      <h3 className="mb-1 text-primary-tertiary">
                        {analysisData.risk_hotspots?.length || 0}
                      </h3>
                      <p className="mb-0 text-body-tertiary">Hotspots</p>
                    </div>
                  </Col>
                  <Col md={3}>
                    <div className="text-center">
                      <Badge 
                        bg={
                          analysisData.failure_prediction?.risk_level === 'CRITICAL' ? 'danger' :
                          analysisData.failure_prediction?.risk_level === 'HIGH' ? 'warning' :
                          analysisData.failure_prediction?.risk_level === 'MEDIUM' ? 'info' : 'success'
                        }
                        className="fs-6 px-3 py-2"
                      >
                        {analysisData.failure_prediction?.risk_level || 'LOW'}
                      </Badge>
                      <p className="mb-0 text-body-tertiary mt-1">Nivel de Riesgo</p>
                    </div>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      )}

      {/* CSS personalizado para animaciones y estados */}
      <style>{`
        /* Animación para la notificación de herramientas */
        @keyframes slideDown {
          from {
            opacity: 0;
            transform: translateX(-50%) translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateX(-50%) translateY(0);
          }
        }
        
        /* Hover effects mejorados para botones de herramientas */
        .btn-group .btn:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 8px rgba(0,0,0,0.15);
          transition: all 0.2s ease;
        }
        
        .btn-group .btn.btn-primary {
          box-shadow: 0 2px 6px rgba(13, 110, 253, 0.3);
        }
        
        .btn-group .btn.btn-success {
          box-shadow: 0 2px 6px rgba(25, 135, 84, 0.3);
        }
        
        .btn-group .btn.btn-info {
          box-shadow: 0 2px 6px rgba(13, 202, 240, 0.3);
        }
        
        /* Estados de las herramientas del mapa */
        .map-tool-active {
          animation: pulse 2s infinite;
        }
        
        .map-tool-measuring .leaflet-container {
          cursor: crosshair !important;
        }
        
        .map-tool-routing .leaflet-container {
          cursor: copy !important;
        }
        
        .map-tool-area .leaflet-container {
          cursor: cell !important;
        }
        
        /* Mejoras para dispositivos táctiles */
        @media (hover: none) and (pointer: coarse) {
          .btn-group .btn:hover {
            transform: none;
          }
          
          .btn-group .btn:active {
            transform: scale(0.95);
          }
        }
        
        /* Estilos base del modal con scroll correcto */
        .hotspot-detail-modal .modal-dialog {
          max-width: 95vw;
          margin: 1rem auto;
        }
        
        @media (min-width: 768px) {
          .hotspot-detail-modal .modal-dialog {
            max-width: 90vw;
          }
        }
        
        @media (min-width: 1200px) {
          .hotspot-detail-modal .modal-dialog {
            max-width: 1140px;
          }
        }
        
        /* Scroll correcto en modales */
        .hotspot-detail-modal .modal-body {
          padding: 0;
          overflow-y: auto;
          overflow-x: hidden;
          -webkit-overflow-scrolling: touch;
          scrollbar-width: thin;
          scrollbar-color: rgba(0,0,0,0.3) transparent;
        }
        
        .hotspot-detail-modal .modal-body::-webkit-scrollbar {
          width: 6px;
        }
        
        .hotspot-detail-modal .modal-body::-webkit-scrollbar-track {
          background: transparent;
        }
        
        .hotspot-detail-modal .modal-body::-webkit-scrollbar-thumb {
          background-color: rgba(0,0,0,0.3);
          border-radius: 3px;
        }
        
        .hotspot-detail-modal .modal-body::-webkit-scrollbar-thumb:hover {
          background-color: rgba(0,0,0,0.5);
        }
        
        /* Header y footer sticky */
        .hotspot-detail-modal .modal-header {
          border-bottom: 1px solid rgba(255,255,255,0.2);
          backdrop-filter: blur(10px);
        }
        
        .hotspot-detail-modal .modal-footer {
          border-top: 1px solid #dee2e6;
          backdrop-filter: blur(10px);
        }
        
        /* Responsive breakpoints específicos */
        @media (max-width: 576px) {
          .hotspot-detail-modal .modal-dialog {
            margin: 0.5rem;
            max-width: calc(100vw - 1rem);
          }
          
          .hotspot-detail-modal .modal-body {
            max-height: calc(100vh - 150px);
          }
          
          .hotspot-detail-modal .modal-footer .btn {
            font-size: 0.75rem;
            padding: 0.375rem 0.5rem;
          }
        }
        
        @media (max-width: 768px) {
          .hotspot-detail-modal .modal-body {
            max-height: calc(100vh - 180px);
          }
          
          .hotspot-detail-modal .fs-6,
          .hotspot-detail-modal .fs-md-5 {
            font-size: 0.875rem !important;
          }
        }
        
        /* Estilos originales mejorados */
        .custom-cluster-marker {
          background: transparent;
          border: none;
        }
        
        .custom-cluster-marker div {
          transform: translate(-50%, -50%);
          position: absolute;
          top: 50%;
          left: 50%;
        }
        
        .marker-cluster {
          transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        .marker-cluster:hover {
          transform: scale(1.1);
          z-index: 1000;
        }
        
        .leaflet-marker-icon {
          transition: all 0.2s ease;
        }
        
        .leaflet-marker-icon:hover {
          transform: scale(1.15);
          z-index: 1000;
          filter: drop-shadow(0 4px 8px rgba(0,0,0,0.3));
        }
        
        .map-toolbar .input-group {
          box-shadow: 0 2px 8px rgba(0,0,0,0.15);
          border-radius: 6px;
          overflow: hidden;
        }
        
        .map-controls button {
          box-shadow: 0 2px 6px rgba(0,0,0,0.1);
          border: none;
          width: 36px;
          height: 36px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .map-info-panel {
          font-feature-settings: 'tnum';
        }
        
        .timeline {
          position: relative;
        }
        
        .timeline::before {
          content: '';
          position: absolute;
          left: 14px;
          top: 32px;
          bottom: 0;
          width: 2px;
          background: #dee2e6;
        }
        
        /* Responsive design mejorado */
        @media (max-width: 768px) {
          .map-toolbar {
            flex-direction: column;
            align-items: stretch;
            gap: 6px;
          }
          
          .map-toolbar .input-group {
            width: 100% !important;
            min-width: 200px;
          }
          
          .map-controls {
            flex-direction: row;
            bottom: 60px;
            top: auto;
            gap: 8px;
          }
          
          .map-controls button {
            width: 32px;
            height: 32px;
          }
          
          .map-info-panel {
            font-size: 10px;
            padding: 6px 8px;
          }
          
          .map-legend {
            min-width: 120px;
            font-size: 11px;
          }
          
          /* Optimizaciones para el mapa en mobile */
          .leaflet-container {
            font-size: 12px;
          }
          
          .leaflet-popup-content {
            margin: 8px 12px;
            font-size: 12px;
          }
          
          .leaflet-popup-content h6 {
            font-size: 14px;
            margin-bottom: 4px;
          }
        }
        
        @media (max-width: 576px) {
          .map-toolbar {
            padding: 8px;
            background: rgba(255,255,255,0.95);
            border-radius: 8px;
            backdrop-filter: blur(10px);
          }
          
          .map-controls {
            bottom: 70px;
          }
          
          .map-info-panel {
            left: 8px;
            right: 8px;
            bottom: 8px;
            text-align: center;
          }
          
          .map-legend {
            right: 8px;
            bottom: 50px;
            min-width: 100px;
            max-width: 140px;
          }
        }
        
        /* Mejoras para Phoenix-React environment */
        .bg-gradient {
          //background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
        }
        
        .font-monospace {
          font-family: 'SF Mono', Monaco, 'Cascadia Code', 'Roboto Mono', Consolas, 'Courier New', monospace;
        }
        
        .fs-10 {
          font-size: 0.65rem;
        }
        
        .fs-11 {
          font-size: 0.7rem;
        }
        
        /* Responsive font sizes */
        @media (max-width: 768px) {
          .fs-md-5 {
            font-size: 1rem !important;
          }
          
          .fs-6 {
            font-size: 0.875rem !important;
          }
          
          h5 {
            font-size: 1.1rem !important;
          }
          
          .modal-title {
            font-size: 1rem !important;
          }
        }
        
        /* Estados de loading y transiciones */
        @keyframes pulse {
          0% { transform: translate(-50%, -50%) scale(1); }
          50% { transform: translate(-50%, -50%) scale(1.2); }
          100% { transform: translate(-50%, -50%) scale(1); }
        }
        
        .hotspot-marker:hover {
          transform: translate(-50%, -50%) scale(1.3) !important;
          z-index: 1000;
        }
        
        .cursor-pointer {
          cursor: pointer;
        }
        
        .fs-9 {
          font-size: 0.775rem;
        }
        
        .professional-chart {
          font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
        }
        
        .chart-grid line {
          shape-rendering: crispEdges;
        }
        
        .map-container {
          transition: all 0.3s ease;
        }
        
        .badge.bg-outline-primary {
          background-color: transparent !important;
          border: 1px solid var(--bs-primary);
          color: var(--bs-primary);
        }
        
        .badge.bg-outline-primary:hover {
          background-color: var(--bs-primary) !important;
          color: white;
        }
        
        .badge.bg-outline-secondary {
          background-color: transparent !important;
          border: 1px solid var(--bs-secondary);
          color: var(--bs-secondary);
        }
        
        .badge.bg-outline-secondary:hover {
          background-color: var(--bs-secondary) !important;
          color: white;
        }
        
        /* Estilos para estados vacíos */
        .empty-state {
          opacity: 0.7;
          transition: opacity 0.3s ease;
        }
        
        .empty-state:hover {
          opacity: 1;
        }
        
        /* Animación para loading states */
        .loading-overlay {
          background: linear-gradient(90deg, transparent, rgba(255,255,255,0.4), transparent);
          animation: loading-shimmer 1.5s infinite;
        }
        
        @keyframes loading-shimmer {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(100%); }
        }
        
        /* Mejoras para el estado sin datos */
        .no-data-overlay {
          background: rgba(248, 249, 250, 0.95);
          backdrop-filter: blur(2px);
        }
        
        .data-upload-zone {
          border: 2px dashed #dee2e6;
          border-radius: 8px;
          padding: 2rem;
          text-align: center;
          transition: all 0.3s ease;
        }
        
        .data-upload-zone:hover {
          border-color: #0d6efd;
          background-color: rgba(13, 110, 253, 0.05);
        }
        
        /* Estilos para badges de estado */
        .status-badge {
          font-size: 0.75rem;
          padding: 0.25rem 0.5rem;
        }
        
        /* Mejoras de accesibilidad */
        .nav-link:disabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
        
        .btn:disabled {
          opacity: 0.6;
          cursor: not-allowed;
        }
        
        /* Optimizaciones específicas para Phoenix-React */
        .phoenix-container {
          max-width: 100%;
          overflow-x: hidden;
        }
        
        .react-leaflet-container {
          width: 100%;
          height: 100%;
        }
        
        /* Touch-friendly en dispositivos móviles */
        @media (hover: none) and (pointer: coarse) {
          .btn {
            min-height: 44px;
          }
          
          .form-control {
            min-height: 44px;
          }
          
          .map-controls button {
            width: 44px;
            height: 44px;
          }
          
          .leaflet-control-zoom a {
            width: 44px;
            height: 44px;
            line-height: 44px;
          }
        }
        
        /* Estilos para el estado de carga */
        .loading-skeleton {
          background: linear-gradient(90deg, #f0f0f0 25%, transparent 37%, #f0f0f0 63%);
          background-size: 400% 100%;
          animation: skeleton-loading 1.4s ease infinite;
        }
        
        @keyframes skeleton-loading {
          0% { background-position: 100% 50%; }
          100% { background-position: -100% 50%; }
        }
        
        /* Mejoras para tooltips y popovers */
        .tooltip-custom {
          font-size: 0.75rem;
        }
        
        /* Estilos para alertas personalizadas */
        .alert-custom {
          border-left: 4px solid;
          border-radius: 0.375rem;
        }
        
        .alert-custom.alert-info {
          border-left-color: #0dcaf0;
        }
        
        .alert-custom.alert-warning {
          border-left-color: #ffc107;
        }
        
        .alert-custom.alert-success {
          border-left-color: #198754;
        }
        
        .alert-custom.alert-danger {
          border-left-color: #dc3545;
        }
        
        /* Transiciones suaves para cambios de estado */
        .state-transition {
          transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
        }
        
        /* Estilos para indicadores de progreso */
        .progress-ring {
          transition: stroke-dashoffset 0.35s;
          transform-origin: 50% 50%;
        }
        
        /* Mejoras para el modo oscuro (futuro) */
        @media (prefers-color-scheme: dark) {
          .professional-chart {
            //background: linear-gradient(to bottom, #1a1a1a 0%, #2d2d2d 100%);
            background: --var(--bg-body);
          }
          
          .hotspot-detail-modal .modal-content {
            //background-color:rgb(255, 255, 255);
            /*color: #fff;*/
          }
        }
        
        /* Animations específicas para componentes */
        .slide-in {
          animation: slideIn 0.3s ease-out;
        }
        
        @keyframes slideIn {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .fade-in {
          animation: fadeIn 0.5s ease-in;
        }
        
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        
        /* Optimización para scroll en contenedores */
        .scroll-container {
          scrollbar-width: thin;
          scrollbar-color: rgba(0,0,0,0.3) transparent;
        }
        
        .scroll-container::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }
        
        .scroll-container::-webkit-scrollbar-track {
          background: transparent;
        }
        
        .scroll-container::-webkit-scrollbar-thumb {
          background-color: rgba(0,0,0,0.3);
          border-radius: 3px;
        }
        
        .scroll-container::-webkit-scrollbar-thumb:hover {
          background-color: rgba(0,0,0,0.5);
        }
        
        /* Estilos específicos para contenido expandible */
        .expandable-content {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.3s ease-out;
        }
        
        .expandable-content.expanded {
          max-height: 500px;
        }
        
        /* Performance optimizations */
        .gpu-accelerated {
          transform: translateZ(0);
          will-change: transform;
        }
        
        .no-select {
          -webkit-user-select: none;
          -moz-user-select: none;
          -ms-user-select: none;
          user-select: none;
        }
        
        /* Layout específico para Phoenix */
        .phoenix-layout {
          min-height: 100vh;
          display: flex;
          flex-direction: column;
        }
        
        .phoenix-main {
          flex: 1;
          padding: 1rem;
        }
        
        @media (min-width: 768px) {
          .phoenix-main {
            padding: 1.5rem;
          }
        }
        
        @media (min-width: 1200px) {
          .phoenix-main {
            padding: 2rem;
          }
        }
        
        /* Estilos específicos para formularios */
        .form-floating > .form-control:focus ~ label,
        .form-floating > .form-control:not(:placeholder-shown) ~ label {
          opacity: 0.65;
          transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem);
        }
        
        /* Mejoras para tablas responsivas */
        .table-responsive {
          border-radius: 0.375rem;
          overflow: hidden;
        }
        
        .table th {
          border-top: none;
          font-weight: 600;
          text-transform: uppercase;
          font-size: 0.75rem;
          letter-spacing: 0.05em;
        }
        
        /* Estilos para componentes de IA */
        .formatted-ai-response {
          font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
          word-wrap: break-word;
          overflow-wrap: break-word;
        }
        
        .cursor-pointer:hover {
          transform: scale(1.02);
          transition: transform 0.15s ease;
        }
        
        .bg-outline-primary:hover {
          background-color: var(--bs-primary) !important;
          color: white !important;
        }
        
        .mb-3:last-child {
          animation: slideIn 0.3s ease-out;
        }
        
        /* Mejoras para dropdowns */
        .dropdown-menu {
          border: none;
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
          border-radius: 0.5rem;
        }
        
        .dropdown-item:hover {
          background-color: rgba(var(--bs-primary-rgb), 0.1);
        }
        
        /* Mejoras para modales */
        .modal-backdrop {
          backdrop-filter: blur(4px);
        }
        
        .modal-content {
          border: none;
          border-radius: 1rem;
          box-shadow: 0 1rem 3rem rgba(0, 0, 0, 0.175);
        }
        
        /* Estilos para iconos */
        .icon-wrapper {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          width: 2rem;
          height: 2rem;
          border-radius: 0.5rem;
        }
        
        /* Mejoras para badges */
        .badge {
          font-weight: 500;
          letter-spacing: 0.025em;
        }
        
        /* Estilos para avatares */
        .avatar {
          display: inline-flex;
          align-items: center;
          justify-content: center;
          border-radius: 50%;
          font-weight: 600;
        }
        
        .avatar-xs {
          width: 1.5rem;
          height: 1.5rem;
          font-size: 0.625rem;
        }
        
        .avatar-s {
          width: 2rem;
          height: 2rem;
          font-size: 0.75rem;
        }
        
        .avatar-l {
          width: 3rem;
          height: 3rem;
          font-size: 1rem;
        }
        
        /* Mejoras para cards */
        .card {
          border: none;
          border-radius: 1rem;
          box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
          transition: box-shadow 0.15s ease-in-out;
        }
        
        .card:hover {
          box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
        }
        
        /* Mejoras para botones */
        .btn {
          border-radius: 0.5rem;
          font-weight: 500;
          transition: all 0.15s ease-in-out;
        }
        
        .btn:hover {
          transform: translateY(-1px);
        }
        
        .btn:active {
          transform: translateY(0);
        }
        
        /* Mejoras para inputs */
        .form-control, .form-select {
          border-radius: 0.5rem;
          border: 1px solid #dee2e6;
          transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
        }
        
        .form-control:focus, .form-select:focus {
          border-color: #86b7fe;
          box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25);
        }
        
        /* Mejoras para navegación */
        .nav-pills .nav-link {
          border-radius: 0.5rem;
          transition: all 0.15s ease-in-out;
        }
        
        .nav-pills .nav-link:hover {
          background-color: rgba(var(--bs-primary-rgb), 0.1);
        }
        
        /* Mejoras para alerts */
        .alert {
          border: none;
          border-radius: 1rem;
          border-left: 4px solid;
        }
        
        .alert-info {
          border-left-color: #0dcaf0;
        }
        
        .alert-warning {
          border-left-color: #ffc107;
        }
        
        .alert-success {
          border-left-color: #198754;
        }
        
        .alert-danger {
          border-left-color: #dc3545;
        }
        
        /* Mejoras para progress bars */
        .progress {
          border-radius: 1rem;
          overflow: hidden;
        }
        
        .progress-bar {
          transition: width 0.6s ease;
        }
        
        /* Utilidades adicionales */
        .text-truncate-2 {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        
        .text-truncate-3 {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 3;
          -webkit-box-orient: vertical;
        }
        
        /* Mejoras para borders */
        .border-start-4 {
          border-left-width: 4px !important;
        }
        
        .border-end-4 {
          border-right-width: 4px !important;
        }
        
        .border-top-4 {
          border-top-width: 4px !important;
        }
        
        .border-bottom-4 {
          border-bottom-width: 4px !important;
        }
        
        /* Mejoras para sombras */
        .shadow-xs {
          box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
        }
        
        .shadow-xl {
          box-shadow: 0 1.25rem 2.5rem rgba(0, 0, 0, 0.15) !important;
        }
        
        /* Mejoras para spacing */
        .gap-1 {
          gap: 0.25rem !important;
        }
        
        .gap-2 {
          gap: 0.5rem !important;
        }
        
        .gap-3 {
          gap: 1rem !important;
        }
        
        .gap-4 {
          gap: 1.5rem !important;
        }
        
        .gap-5 {
          gap: 3rem !important;
        }
        
        /* Mejoras para colores */
        .text-body-emphasis {
          color: #212529 !important;
        }
        
        .text-body {
          color: #495057 !important;
        }
        
        .text-body-secondary {
          color: #6c757d !important;
        }
        
        .text-body-tertiary {
          color: #adb5bd !important;
        }
        
        /* Mejoras para backgrounds */
        .bg-body-secondary {
          background-color: #e9ecef !important;
        }
        
        .bg-body-tertiary {
          background-color: #f8f9fa !important;
        }
        
        /* Mejoras para borders */
        .border-subtle {
          border-color: #dee2e6 !important;
        }
        
        /* Variables CSS personalizadas */
        :root {
          --bs-primary-rgb: 13, 110, 253;
          --bs-secondary-rgb: 108, 117, 125;
          --bs-success-rgb: 25, 135, 84;
          --bs-info-rgb: 13, 202, 240;
          --bs-warning-rgb: 255, 193, 7;
          --bs-danger-rgb: 220, 53, 69;
          --bs-light-rgb: 248, 249, 250;
          --bs-dark-rgb: 33, 37, 41;
        }
        
        /* Mejoras finales para la experiencia de usuario */
        * {
          scrollbar-width: thin;
          scrollbar-color: rgba(0,0,0,0.2) transparent;
        }
        
        *::-webkit-scrollbar {
          width: 6px;
          height: 6px;
        }
        
        *::-webkit-scrollbar-track {
          background: transparent;
        }
        
        *::-webkit-scrollbar-thumb {
          background-color: rgba(0,0,0,0.2);
          border-radius: 3px;
        }
        
        *::-webkit-scrollbar-thumb:hover {
          background-color: rgba(0,0,0,0.4);
        }
        
        /* Optimizaciones de rendimiento */
        .leaflet-container,
        .recharts-wrapper,
        .modal-dialog {
          will-change: transform;
        }
        
        /* Mejoras de accesibilidad finales */
        @media (prefers-reduced-motion: reduce) {
          *,
          *::before,
          *::after {
            animation-duration: 0.01ms !important;
            animation-iteration-count: 1 !important;
            transition-duration: 0.01ms !important;
          }
        }
        
        /* Mejoras para focus */
        .btn:focus,
        .form-control:focus,
        .form-select:focus {
          outline: 2px solid rgba(13, 110, 253, 0.25);
          outline-offset: 2px;
        }
        
        /* Print styles */
        @media print {
          .map-toolbar,
          .map-controls,
          .modal,
          .btn,
          .nav-pills {
            display: none !important;
          }
          
          .card {
            box-shadow: none !important;
            border: 1px solid #dee2e6 !important;
          }
        }

        /* Estilos específicos para el mapa interactivo */
.fs-7 {
  font-size: 0.875rem;
}

.leaflet-container {
  font-family: inherit;
}

.spinner-border-sm {
  width: 1rem;
  height: 1rem;
}

/* Mejoras para las herramientas del mapa */
.map-tool-notification {
  background: rgba(13, 110, 253, 0.95);
  backdrop-filter: blur(10px);
  border: none;
  border-radius: 1rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.15);
}

.map-tool-notification .btn-close {
  background: rgba(255, 255, 255, 0.2);
  opacity: 1;
  border-radius: 50%;
  width: 24px;
  height: 24px;
}

.map-tool-notification .btn-close:hover {
  background: rgba(255, 255, 255, 0.3);
}

/* Mejoras para los controles del mapa */
.map-search-controls .form-control,
.map-search-controls .form-select {
  font-size: 0.875rem;
  padding: 0.375rem 0.75rem;
}

.map-search-controls .btn {
  font-size: 0.875rem;
  padding: 0.375rem 0.75rem;
}

/* Mejoras para los resultados */
.search-results-list {
  scrollbar-width: thin;
  scrollbar-color: rgba(0,0,0,0.2) transparent;
}

.search-results-list::-webkit-scrollbar {
  width: 6px;
}

.search-results-list::-webkit-scrollbar-track {
  background: transparent;
}

.search-results-list::-webkit-scrollbar-thumb {
  background-color: rgba(0,0,0,0.2);
  border-radius: 3px;
}

.search-results-list::-webkit-scrollbar-thumb:hover {
  background-color: rgba(0,0,0,0.4);
}

/* Responsive para el mapa interactivo */
@media (max-width: 768px) {
  .map-search-controls .form-control,
  .map-search-controls .form-select {
    font-size: 0.8rem;
    padding: 0.25rem 0.5rem;
  }
  
  .map-search-controls .btn {
    font-size: 0.8rem;
    padding: 0.25rem 0.5rem;
  }
  
  .map-tool-notification {
    left: 1rem;
    right: 1rem;
    transform: translateY(-50%);
    top: 50%;
  }
}

/* Mejoras para los popups del mapa */
.leaflet-popup-content {
  margin: 8px 12px;
  font-size: 0.875rem;
}

.leaflet-popup-content h6 {
  margin-bottom: 8px;
  color: #333;
  font-weight: 600;
}

.leaflet-popup-content p {
  margin: 4px 0;
  line-height: 1.4;
}

/* Animaciones para las herramientas */
@keyframes toolActivated {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

.tool-button-active {
  animation: toolActivated 0.3s ease;
}


.toast-show {
    animation: toastSlideDown 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
}

.toast-hide {
    animation: toastSlideUp 0.3s cubic-bezier(0.55, 0.06, 0.68, 0.19);
}

@keyframes toastSlideDown {
    0% {
        opacity: 0;
        transform: translateX(-50%) translateY(-100px) scale(0.9);
    }
    100% {
        opacity: 1;
        transform: translateX(-50%) translateY(0) scale(1);
    }
}

@keyframes toastSlideUp {
    0% {
        opacity: 1;
        transform: translateX(-50%) translateY(0) scale(1);
    }
    100% {
        opacity: 0;
        transform: translateX(-50%) translateY(-100px) scale(0.9);
    }
}

.toast-alert {
    backdrop-filter: blur(10px);
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1) !important;
}

/* Responsive para móviles */
@media (max-width: 576px) {
    .toast-alert {
        min-width: 280px !important;
        max-width: calc(100vw - 2rem) !important;
        margin: 0 1rem;
    }
}
      `}</style>
    </>
  );
};

export default AdvancedRailwayVtiCrm;

function setIsCancelling(arg0: boolean) {
  throw new Error('Function not implemented.');
}
function setIsProcessing(arg0: boolean) {
  throw new Error('Function not implemented.');
}

function setProcessingProgress(arg0: number) {
  throw new Error('Function not implemented.');
}

function resetFormState() {
  throw new Error('Function not implemented.');
}